(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6d9a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6d9a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cc240", function(module, exports) {
const article = document.querySelector('article .articles__content');
if (!article) return;
function addIdToHeading(targetText) {
    // Select all heading elements
    const headings = article.querySelectorAll('h1, h2, h3, h4, h5, h6');
    headings.forEach((heading)=>{
        // Extract text content without tags
        const text = heading.textContent.trim();
        if (text.includes(targetText)) {
            // Create an ID-friendly version of the text
            const id = targetText.replace(/\s+/g, '_'); // Replace spaces with underscores
            heading.id = id;
        }
        heading.classList.add('anchor-offset');
    });
}
const contentList = article.querySelector('ol');
Array.from(contentList.querySelectorAll('li')).forEach((li)=>{
    const idText = li.textContent.replace(/\s+/g, '_'); // Convert text to an anchor-friendly format
    const anchor = document.createElement('a'); // Create anchor element
    anchor.href = `#${idText}`; // Set anchor link
    anchor.textContent = li.textContent; // Preserve original text
    document.getElementById(idText)?.classList.add('anchor-offset');
    li.innerHTML = ''; // Clear existing content
    li.appendChild(anchor); // Append anchor inside <li>
    addIdToHeading(li.textContent);
});

});

parcelRegister("05crR", function(module, exports) {
const div = document.getElementById("rotationBanner");
if (!div) return;
let visible = false;
//TRIGGER ELEMENT
const sentinel = document.createElement("div");
sentinel.style.position = "absolute";
sentinel.style.top = "400px";
sentinel.style.height = "1px";
sentinel.style.width = "1px";
sentinel.style.pointerEvents = "none";
sentinel.style.visibility = "hidden";
document.body.appendChild(sentinel);
//INTERSECTION OBSERVER
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop >= 400 && !visible) {
            div.style.display = "flex";
            setTimeout(()=>{
                div.style.transform = "translate(-50%, 0)";
            }, 50);
            visible = true;
        } else if (scrollTop < 400 && visible) {
            div.style.transform = "translate(-50%, 100%)";
            div.addEventListener("transitionend", ()=>{
                if (!visible) div.style.display = "none";
            }, {
                once: true
            });
            visible = false;
        }
    });
}, {
    threshold: 0,
    rootMargin: "0px"
});
observer.observe(sentinel);
//TEXT ROTATION
const items = document.querySelectorAll(".rotating-slider li");
let index = 0;
function showNext() {
    items.forEach((el)=>el.classList.remove("active"));
    items[index].classList.add("active");
    index = (index + 1) % items.length;
}
showNext();
const rotationInterval = setInterval(showNext, 2000);
// CLEANUP FUNCTION
function cleanup() {
    observer.disconnect();
    bannerObserver.disconnect();
    clearInterval(rotationInterval);
}
window.cleanupScrollBanner = cleanup;

});

parcelRegister("j29Ib", function(module, exports) {

var $5u17S = parcelRequire("5u17S");

var $hi4SC = parcelRequire("hi4SC");
const wrapper = document.querySelector('.wizard-page__edit-info');
const infoBoxes = document.querySelectorAll('.wizard-update-info__box');
if (!wrapper || !infoBoxes) return;
let dogName;
let currentDogData;
let metafield;
let skioData;
let subscriptionPlanId;
let originalBoxContent = [];
//product mapping Shopify - Skio
let mappedData = [
    {
        "variantId": "3212125b-ed4f-4438-ad14-a72def971d6c",
        "platformId": "45632606339358"
    },
    {
        "variantId": "421693f3-cf68-4ddd-a0b6-bab12f45d0ae",
        "platformId": "48570888093982"
    },
    {
        "variantId": "332698da-68ca-428f-8887-bb255ed033b9",
        "platformId": "48570895139102"
    },
    {
        "variantId": "635f8a91-c7aa-46d8-a5ee-f9f1fac7b4b8",
        "platformId": "48570916110622"
    },
    {
        "variantId": "60cf92e2-d575-4aad-bcd7-751aece82a45",
        "platformId": "45833536733470"
    },
    {
        "variantId": "e305d6fa-fbfc-4040-917c-807bcc61547a",
        "platformId": "47263233999134"
    },
    {
        "variantId": "68c1aba3-3874-46bd-aa7d-48f2ce6ab60b",
        "platformId": "48570899202334"
    },
    {
        "variantId": "4308d2e2-cf09-44f3-b1e7-9ab322299862",
        "platformId": "45836361564446"
    },
    {
        "variantId": "f2bbd124-175e-46b7-ae2d-237e68d684db",
        "platformId": "47972154179870"
    },
    {
        "variantId": "91365c53-5098-4d23-9649-cd3bf05f703e",
        "platformId": "45836339380510"
    },
    {
        "variantId": "42593ee0-d431-4934-973e-d3ab7d065202",
        "platformId": "45836314411294"
    },
    {
        "variantId": "e027fd1b-8e85-4ea2-afd1-c96db65fa382",
        "platformId": "45836328599838"
    }
];
function populateOldPlanProducts(skioData) {
    let subscriptionLines = skioData.SubscriptionLines;
    subscriptionPlanId = skioData.id;
    let displayWrapper = document.querySelector('.wizard-recommendation__block-old');
    subscriptionLines.forEach((subscriptionLine)=>{
        let variantId = subscriptionLine.ProductVariant.platformId;
        variantId = variantId.split('/').pop();
        let quantity = subscriptionLine.quantity;
        originalBoxContent.push({
            "variantId": subscriptionLine.ProductVariant.id,
            quantity: quantity,
            "platformId": variantId
        });
        displayWrapper.querySelector(`[data-variant-id="${variantId}"]`)?.classList.add('is-selected');
        displayWrapper.querySelector(`[data-variant-id="${variantId}"] .wizard-product-card__info-title`)?.prepend(quantity + " x ");
    });
    // Iterate through the mappedData array
    mappedData.forEach(({ variantId, platformId })=>{
        // Query all DOM elements with the data-variant-id attribute equal to the platformId
        const elements = document.querySelectorAll(`[data-variant-id="${platformId}"]`);
        // Loop through all matched elements and set the new data attribute
        elements.forEach((element)=>{
            element.setAttribute("data-subscription-line-item-id", variantId);
        });
    });
}
function getCurrentSubscriptionInfo(dogName, customer1) {
    const store = '974fe1';
    const url = `https://netlify.blacklemon.dk/.netlify/functions/getSkioSubscriptions?customer=${customer1}&dogName=${dogName}`;
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    }).then((res)=>{
        if (res.error) console.log('We have an error:', res.error);
        else {
            skioData = res.message;
            populateOldPlanProducts(skioData);
        }
    }).catch((err)=>{
        console.error('Fetch error:', err);
    });
}
let active_dog_name;
let active_dog_new_age;
let dogs_age = [];
//populate inital boxes with dog data
function populateInfoBoxes() {
    quizDataForDogs.forEach((dogData, index)=>{
        let dogInfoBox = document.querySelector(`.wizard-update-info__box-${index}`);
        dogs_age.push({
            dog_name: dogData.name,
            dog_months: dogData.years * 12 + dogData.months
        });
        dogInfoBox.querySelector('.navigation__button').addEventListener('click', function(event) {
            metafield = event.target.dataset.metafield;
            if (metafield) {
                dogName = dogData.name;
                active_dog_name = dogName;
                currentDogData = quizDataForDogs.find((obj)=>obj.name === dogName);
                populateQuizAnswers(currentDogData);
                (0, $5u17S.default)(dogName);
                getCurrentSubscriptionInfo(dogName, customerEmail);
                document.querySelector('.wizard-update-info').style.display = "none";
                document.querySelector('.wizard-update-form').style.display = "block";
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
        //button label
        dogInfoBox.querySelector('.navigation__button .replace-dog-name').innerHTML = dogData.name;
        // gender check and spayed check TODO
        let gender = dogData.gender;
        let neutered = dogData.neutered;
        if (gender == "Boy") {
            if (neutered == "Yes") dogInfoBox.querySelector('.dog_spayed').innerHTML = "Neutered";
            else dogInfoBox.querySelector('.dog_spayed').innerHTML = "Not neutered";
        } else if (neutered == "Yes") dogInfoBox.querySelector('.dog_spayed').innerHTML = "Spayed";
        else dogInfoBox.querySelector('.dog_spayed').innerHTML = "Not spayed";
        //weight
        dogInfoBox.querySelector('.dog_weight').innerHTML = dogData.weight + "kg";
        //weightgroup
        dogInfoBox.querySelector('.dog_bodytype').innerHTML = document.querySelector(`input[name="weightgroup"][value="${dogData.weightgroup}"] + .choice-illustration__wrapper .choice-illustration__text span`).innerHTML;
        //activity
        dogInfoBox.querySelector('.dog_activity').innerHTML = document.querySelector(`input[name="activity"][value="${dogData.activity}"] + .choice-illustration__wrapper .choice-illustration__text span`).innerHTML;
        //allergies
        dogInfoBox.querySelector('.dog_allergies').innerHTML = dogData.allergies == "nothing" || dogData.allergies == "" ? "No allergies" : `Allergic to ${dogData.allergies.join(", ")}`;
        //health issues
        dogInfoBox.querySelector('.dog_health_issues').innerHTML = dogData.health_issues == "No health issues" ? "No health issues" : `${dogData.health_issues.join(", ")}`;
    });
}
//populate info boxes with all dog data
populateInfoBoxes();
//age input fields logic
const ageGroupRadios = document.querySelectorAll('input[name="age_group"]');
const inputYears = document.querySelector('input[name="years"]');
const inputMonths = document.querySelector('input[name="months"]');
const inputYearsContainer = document.getElementById("input_age_years");
function toggleInputs() {
    const selectedAgeGroup = document.querySelector('input[name="age_group"]:checked').value;
    if (selectedAgeGroup === "Puppy") {
        // Show only Months input, hide Years input
        inputYearsContainer.style.display = "none";
        inputMonths.parentElement.style.display = "block";
        inputMonths.setAttribute("required", "required"); // Make Months mandatory
        inputYears.removeAttribute("required");
        inputYears.value = ""; // Clear Years input if not needed
        inputYears.dispatchEvent(new Event('change'));
    } else {
        // Show both inputs but make Years input mandatory
        inputYearsContainer.style.display = "block";
        inputMonths.parentElement.style.display = "block";
        inputYears.setAttribute("required", "required");
        inputMonths.removeAttribute("required"); // Months optional
        inputMonths.dispatchEvent(new Event('change'));
    //inputMonths.value = ""; // Clear Months input if not needed
    }
}
// Event listener for age group radio buttons
ageGroupRadios.forEach((radio)=>radio.addEventListener("change", toggleInputs));
function populateQuizAnswers(currentDogData) {
    //update spayed/neutered label by gender
    let gender = currentDogData.gender;
    let label = document.getElementById('neutered-spayed');
    let old = label.innerHTML;
    label.innerHTML = gender == 'Boy' ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
    // fill quiz data values
    //age
    let months = currentDogData.months ? currentDogData.months : 0;
    let years = currentDogData.years ? currentDogData.years : 0;
    document.querySelector(`input[name="months"]`).value = months;
    document.querySelector(`input[name="years"]`).value = years;
    let totalMonths = years * 12 + months;
    if (totalMonths > 84) {
        document.querySelector(`input[name="age_group"][value="Senior"]`).checked = true;
        document.querySelector(`input[name="age_group"][value="Adult"]`).disabled = true;
        document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
        toggleInputs();
    } else if (totalMonths < 12) {
        document.querySelector(`input[name="age_group"][value="Puppy"]`).checked = true;
        toggleInputs();
    } else {
        document.querySelector(`input[name="age_group"][value="Adult"]`).checked = true;
        document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
        toggleInputs();
    }
    //weight
    let weight = currentDogData.weight;
    document.getElementById('weightTextInput').value = weight;
    document.getElementById('weightRangeInput').value = weight;
    (0, $hi4SC.default)('weightTextInput', 'weightRangeInput');
    //spayed/neutered
    let spayed = currentDogData.neutered;
    document.querySelector(`input[name="neutered"][value="${spayed}"]`).checked = true;
    //bodytype
    let weightgroup = currentDogData.weightgroup;
    document.querySelector(`input[name="weightgroup"][value="${weightgroup}"]`).checked = true;
    //activity
    let activity = currentDogData.weightgroup;
    document.querySelector(`input[name="activity"][value="${activity}"]`).checked = true;
    //allergies
    let allergies = currentDogData.allergies;
    allergies.forEach((allergy, index)=>{
        let capitalizedText = allergy.charAt(0).toUpperCase() + allergy.slice(1);
        document.querySelector(`input[name="allergies"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
    //treats
    let treats = currentDogData.treats;
    document.querySelector(`input[name="treats"][value="${treats}"]`).checked = true;
    //health issues
    let healthIssues = currentDogData.health_issues;
    healthIssues.forEach((healthIssue, index)=>{
        let capitalizedText = healthIssue.charAt(0).toUpperCase() + healthIssue.slice(1);
        document.querySelector(`input[name="health_issues"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
    const allCheckboxesAllergies = document.querySelectorAll("input[name='allergies']");
    allCheckboxesAllergies.forEach((input)=>{
        input.addEventListener('click', function() {
            if (this.value == 'Nothing') {
                if (this.checked) allCheckboxesAllergies.forEach((item)=>{
                    if (item.value == 'Nothing') return;
                    item.checked = false;
                });
            } else document.querySelector('input[name="allergies"][value="Nothing"]').checked = false;
        });
    });
    const allCheckboxesHealth = document.querySelectorAll("input[name='health_issues']");
    allCheckboxesHealth.forEach((input)=>{
        input.addEventListener('click', function() {
            if (this.value == 'No health issues') {
                if (this.checked) allCheckboxesHealth.forEach((item)=>{
                    if (item.value == 'No health issues') return;
                    item.checked = false;
                });
            } else document.querySelector('input[name="health_issues"][value="No health issues"]').checked = false;
        });
    });
    const allCheckboxesTreats = document.querySelectorAll("input[name='prefered_treat']");
    allCheckboxesTreats.forEach((input)=>{
        input.addEventListener('click', function() {
            if (this.value == 'none') {
                if (this.checked) allCheckboxesTreats.forEach((item)=>{
                    if (item.value == 'none') return;
                    item.checked = false;
                });
            } else document.querySelector('input[name="prefered_treat"][value="none"]').checked = false;
        });
    });
}
// Get input values
function qiv(name) {
    var element = document.querySelector('form input[name="' + name + '"]');
    return element || element === 0 ? element.value : false;
}
// Get age values
function ageInput(type) {
    if (type == 'years') return parseInt(qiv('years')) || 0;
    if (type == 'months') return parseInt(qiv('months')) || 0;
//if (type == 'birthday') { return (inputType == 'manual') ? false : qiv('datepicker__input'); }
}
//get all inputs
//create new data object
function newData() {
    //clone initial data
    let data = Object.assign({}, currentDogData);
    //update required values
    data.years = ageInput('years');
    data.months = ageInput('months');
    data.weight = parseFloat(qiv('weight'));
    data.neutered = document.querySelector('form input[name="neutered"]:checked').value;
    data.weightgroup = parseInt(document.querySelector('input[name="weightgroup"]:checked').value);
    data.activity = parseInt(document.querySelector('input[name="activity"]:checked').value);
    data.allergies = Array.from(document.querySelectorAll('form input[name="allergies"]:checked')).map((el)=>el.value.toLowerCase());
    data.treats = parseInt(document.querySelector('input[name="treats"]:checked').value);
    data.health_issues = Array.from(document.querySelectorAll('form input[name="health_issues"]:checked')).map((el)=>el.value.toLowerCase());
    //change global value
    active_dog_new_age = data.years * 12 + data.months;
    return data;
}
document.querySelector('.calculate-plan').addEventListener('click', function() {
    //display old data calculation
    calculateMealPlan(JSON.stringify(currentDogData), 'old');
    //display old data calculation
    calculateMealPlan(JSON.stringify(newData()), 'new');
    //handle step dsplay logic
    document.querySelector('.wizard-update-form').style.display = "none";
    document.querySelector('.wizard-recommendation').style.display = "block";
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});
function updatePuppyInfo() {
    // Find the dog with the specified name and update its months
    const dog = dogs_age.find((dog)=>dog.dog_name === active_dog_name);
    if (dog) dog.dog_months = active_dog_new_age;
    else console.log("Dog not found");
    // Check if any dog has dog_months greater than 11
    if (dogs_age.some((dog)=>dog.dog_months <= 11)) console.log("At least one dog has less than 11 months!");
    else {
        //set custom property to false
        const email = customerEmail; // Email of the customer
        const options = {
            method: 'POST',
            headers: {
                accept: 'application/vnd.api+json',
                revision: '2025-01-15',
                'content-type': 'application/vnd.api+json'
            },
            body: `{"data":{"type":"profile","attributes":{"properties":{"hasPuppy":false},"email":"${email}"}}}`
        };
        fetch('https://a.klaviyo.com/client/profiles?company_id=R6vSRF', options).then((res)=>res.json()).then((res)=>console.log(res)).catch((err)=>console.error(err));
    }
}
function updateCustomerMetafield(quiz, customer1, metafield) {
    const store = '974fe1';
    const url = `https://netlify.blacklemon.dk/.netlify/functions/updateCustomerMetafield?store=${store}&customer=${customer1}&metafield=${metafield}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(quiz)
    }).then((response)=>{
        if (!response.ok) {
            document.querySelector('.update-plan__error-message').style.display = "block";
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }).then((res)=>{
        if (res.error) {
            console.log('We have an error:', res.error);
            document.querySelector('.update-plan__error-message').style.display = "block";
        } else {
            console.log('Success:', res);
            document.querySelector('.wizard-recommendation__blocks').style.display = "none";
            document.querySelector('.navigation__button.update-plan').style.display = "none";
            document.querySelector('.update-plan__success-message').classList.add('plan-updated');
            updatePuppyInfo();
        }
    }).catch((err)=>{
        console.error('Fetch error:', err);
    });
}
document.querySelector('.update-plan').addEventListener('click', function() {
    document.querySelector('.update-plan').classList.add('is-loading');
    updateNewPlanInSkio(newProducts);
});
let feedingGuide;
function feedingGuideCalc(mealCount) {
    // Calculate y as x divided by 28
    const packPercentage = mealCount / 28;
    // If y is less than 0.25, set it to 0.25
    if (packPercentage < 0.25) return 0.25;
    // Round y to the nearest 0.25
    const roundedpackPercentage = Math.round(packPercentage * 4) / 4;
    return roundedpackPercentage;
}
// Default package split
let split = {
    chicken: 0.35,
    lamb: 0.2,
    beef: 0.3,
    salmon: 0.15
};
// Function to increase split percentages if the total is less than 1
function adjustSplitPercentage(split) {
    const totalSplit = Object.values(split).reduce((acc, val)=>acc + val, 0);
    if (totalSplit < 1) {
        const diff = 1 - totalSplit;
        const count = Object.keys(split).length;
        for(const key in split)split[key] += diff / count;
    }
    return split;
}
function sanitizeBolean(value) {
    value = value.trim();
    switch(value.toLowerCase()){
        case 'yes':
            return true;
        case 'no':
            return false;
        default:
            return Boolean(value);
    }
}
// Remove ingredients if allergic
function removeAllergicIngredients(subscriptionData) {
    subscriptionData.dog_allergies.forEach((allergy)=>{
        delete split[allergy.toLowerCase()];
    });
    split = adjustSplitPercentage(split);
    return split;
}
function mealDistribution(split, monthlyCartons1) {
    let foodPackage = {
        'chicken': split['chicken'] ? Math.round(monthlyCartons1 * split['chicken']) : 0,
        'lamb': split['lamb'] ? Math.round(monthlyCartons1 * split['lamb']) : 0,
        'beef': split['beef'] ? Math.round(monthlyCartons1 * split['beef']) : 0,
        'salmon': split['salmon'] ? Math.round(monthlyCartons1 * split['salmon']) : 0
    };
    // Increase package until monthly target is met
    let difference = Math.round(monthlyCartons1 - Object.values(foodPackage).reduce((a, b)=>a + b, 0));
    while(difference > 0){
        for(let type in foodPackage)if (difference > 0 && split.hasOwnProperty(type)) {
            foodPackage[type] += 1;
            difference -= 1;
        }
    }
    return foodPackage;
}
let newProducts = [];
function calculateMealPlan(payload, plan) {
    let payloadData = JSON.parse(payload);
    let fullPrice = 0;
    let fullPlanPrice = 0;
    const wpDays = 28;
    let subscriptionData = {
        "dog_name": payloadData.name,
        "dog_breed": payloadData.breed,
        "dog_gender": payloadData.gender,
        "dog_neutered": sanitizeBolean(payloadData.neutered),
        "dog_years": payloadData.years,
        "dog_months": payloadData.months,
        "dog_weight": payloadData.weight,
        "dog_weightgroup": payloadData.weightgroup,
        "dog_activity": payloadData.activity,
        "dog_treats": payloadData.treats,
        "dog_allergies": payloadData.allergies,
        "dog_eating": payloadData.food,
        "dog_fussy_dog": sanitizeBolean(payloadData.fussy_dog),
        "dog_prefered_treat": payloadData.prefered_treat,
        "dog_health_issues": payloadData.health_issues
    };
    if (plan == "new") removeAllergicIngredients(subscriptionData);
    // Calculate age in months
    let months;
    months = subscriptionData['dog_years'] * 12 + subscriptionData['dog_months'];
    // Get multiplier
    let multiplier;
    if (months < 6) multiplier = 1.8;
    else if (months < 9) multiplier = 1.6;
    else if (months < 12) multiplier = 1.4;
    else multiplier = 1.2;
    // Adjust multiplier by activity
    if (months >= 12) {
        multiplier -= subscriptionData['dog_activity'] < 2 ? 0.1 : 0; // Inactive
        multiplier += subscriptionData['dog_activity'] > 2 ? 0.1 : 0; // Very active
    }
    // Adjust multiplier by weight group
    if (months < 12) // Puppy
    multiplier *= subscriptionData['dog_weightgroup'] < 2 ? 1.1 : 1; // Underweight
    else {
        // Adult
        multiplier *= subscriptionData['dog_weightgroup'] < 2 ? 1.1 : 1; // Underweight
        multiplier *= subscriptionData['dog_weightgroup'] > 2 ? 0.9 : 1; // Overweight
    }
    // Adjust multiplier if neutered
    multiplier *= subscriptionData['dog_neutered'] && months >= 6 ? 0.9 : 1;
    // Treats to multiplier
    const treats = 1 - (subscriptionData['dog_treats'] - 1) * 0.05;
    let percentage = 100;
    // Calculate calorie requirement
    const RER = 70 * Math.pow(subscriptionData['dog_weight'], 0.75);
    const MER = RER * multiplier * treats;
    const MERReduced = MER * (percentage / 100);
    // Daily & monthly dinings/cartons
    const dailyDinings = Math.round(MERReduced / 125); // Round to nearest integer
    const dailyCartons = dailyDinings / 4; // Convert to quarters
    monthlyCartons = dailyCartons * wpDays; // Multiply by wpDays
    let foodPackage = mealDistribution(split, monthlyCartons);
    /* dog treats */ let preferedTreat = {};
    if (subscriptionData['dog_treats'] > 1) {
        let treatList = [
            "lamb",
            "chicken",
            "beef"
        ];
        if (subscriptionData['dog_prefered_treat'] == 'none') {
            subscriptionData.dog_allergies.forEach((allergy)=>{
                // Find the index of the allergy in the treatList
                const index = treatList.indexOf(allergy.toLowerCase());
                // If the allergy is in treatList, remove it
                if (index !== -1) treatList.splice(index, 1); // Remove the item at the found index
            });
            if (treatList.length) {
                //select first from list (predefined order)
                let objKey = treatList[0];
                preferedTreat[objKey] = 1;
            } else preferedTreat = "no treats";
        } else {
            // 1 product per chosen flavour
            if (Array.isArray(subscriptionData['dog_prefered_treat'])) subscriptionData['dog_prefered_treat'].forEach((item)=>{
                preferedTreat[item] = 1;
            });
            else if (subscriptionData['dog_prefered_treat']) preferedTreat[subscriptionData['dog_prefered_treat']] = 1;
        }
    }
    /* dog supplements */ let supplements = {};
    let supplementsQuantity = 1;
    // function calculateAdditions(weight) {
    //     if (weight < 10) {
    //         return 1;
    //     } else if (weight <= 25) {
    //         return 2;
    //     } else if (weight <= 40) {
    //         return 3;
    //     } else {
    //         // Calculate additional additions for weights above 40kg
    //         const extraWeight = weight - 40;
    //         const extraAdditions = Math.ceil(extraWeight / 15);
    //         return 3 + extraAdditions;
    //     }
    // }
    if (months >= 6) {
        if (subscriptionData['dog_health_issues'].includes('dry, itchy or dull coat')) supplements.oil = supplementsQuantity; // Add "oil" supplement
        if (subscriptionData['dog_health_issues'].includes('a sensitive stomach')) supplements.gut = supplementsQuantity; // Add "gut" supplement
        if (subscriptionData['dog_health_issues'].includes('dental issues or bad breath')) supplements.dental = supplementsQuantity; // Add "dental" supplement
        if (subscriptionData['dog_health_issues'].includes('joint stiffness or pain')) supplements.joint = supplementsQuantity; // Add "joint" supplement
    }
    let totalPackage = {
        foodPackage: foodPackage,
        preferedTreat: preferedTreat,
        supplements: supplements
    };
    //get quantites from api
    let response = totalPackage;
    const cartQuantites = {};
    /* MEALS */ //match quantites with products
    for (const product of productList){
        for (const [key, value] of Object.entries(response.foodPackage))if (product.title.toLowerCase().includes(key)) {
            cartQuantites[product.variants[0].id] = value;
            fullPrice += product.price * value;
            break;
        }
    }
    fullPlanPrice += fullPrice * 2;
    const mealTotalCount = Object.values(response.foodPackage).reduce((sum, value)=>sum + value, 0);
    feedingGuide = feedingGuideCalc(mealTotalCount);
    document.getElementById(`packs-per-day-${plan}`).innerHTML = feedingGuide;
    const mealFoodIncluded = Object.keys(response.foodPackage).filter((key)=>response.foodPackage[key] !== 0).join(', ');
    $('.meal-portions').html(mealTotalCount);
    $('.meal-portions-full').html(mealTotalCount * 2);
    $('.meal-contains').html(mealFoodIncluded);
    /* TREATS */ let prefferedTreats = preferedTreat;
    if (Object.keys(prefferedTreats).length > 0) {
        const mealFoodIncluded = Object.keys(prefferedTreats).filter((key)=>response.preferedTreat[key] !== 0).join(', ');
        for (const treat of treatsList){
            for (const [key, value] of Object.entries(prefferedTreats))if (treat.title.toLowerCase().includes(key)) {
                cartQuantites[treat.variants[0].id] = value;
                fullPrice += treat.price * value;
                fullPlanPrice += treat.price * value;
            }
            $('.treat-contains').html(mealFoodIncluded);
            $('.treat-count').html(Object.keys(prefferedTreats).length);
        }
    } else $('details[data-plan-type="treats"]').hide();
    /* SUPPLEMENTS */ let supplementsCalc = response.supplements;
    if (supplementsCalc && months >= 6) {
        for (const supplement of supplementList){
            for (const [key, value] of Object.entries(supplementsCalc))if (supplement.title.toLowerCase().includes(key)) {
                cartQuantites[supplement.variants[0].id] = value;
                fullPrice += supplement.price * value;
                fullPlanPrice += supplement.price * value;
                break;
            }
        }
        const supplementsCount = Object.values(supplementsCalc).reduce((acc, value)=>acc + value, 0);
        const supplementIncluded = Object.keys(response.supplements).filter((key)=>response.supplements[key] !== 0).join(', ');
        $('.supplements-quantity').html(supplementsCount);
        $('.supplements-contains').html(supplementIncluded);
    } else $('details[data-plan-type="supplements"]').hide();
    cartObject = cartQuantites;
    if (plan == "new") {
        // Get all elements with the class 'wizard-product-card'
        const productCards = document.querySelectorAll(`.wizard-recommendation__block-${plan} .wizard-product-card`);
        // Iterate over the elements and check if 'data-variant-id' is in the object
        productCards.forEach((card)=>{
            const variantId = card.getAttribute('data-variant-id');
            if (cartObject.hasOwnProperty(variantId) && cartObject[variantId] !== 0) {
                card.classList.add('is-selected');
                card.querySelector('.wizard-product-card__info-title').prepend(cartObject[variantId] + " x ");
                // Ensure the element exists before accessing properties
                const trialPlanBox = card.closest('.plan-box__summary-cards');
                if (trialPlanBox) card.querySelector('span').innerHTML = cartObject[variantId];
                // Find the closest ancestor with class 'plan-box__wrapper--full'
                const wrapper = card.closest('details.type-meals[data-plan-type="meals"]');
                if (wrapper) card.querySelector('span').innerHTML = cartObject[variantId] * 2;
            }
            //if item has no quantity, make it 0 so it can be removed form subscription
            let quantity = cartObject[variantId] ? cartObject[variantId] : 0;
            let subscriptionLineItemId = card.dataset.subscriptionLineItemId;
            newProducts.push({
                "variantId": subscriptionLineItemId,
                quantity: quantity
            });
        });
    }
}
function updateNewPlanInSkio(newProducts) {
    const store = '974fe1';
    const url = `https://netlify.blacklemon.dk/.netlify/functions/updateSkioSubscriptionProducts?subscriptionPlanId=${subscriptionPlanId}`;
    let payloadContent = {
        "originalBoxContent": originalBoxContent,
        "newBoxContent": newProducts
    };
    const payload = JSON.stringify(payloadContent);
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: payload
    }).then((response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    }).then((res)=>{
        if (res.error) console.log('We have an error:', res.error);
        else {
            console.log('Success:', res);
            //update metafield     
            let payload = newData();
            updateCustomerMetafield(payload, customer, metafield);
        }
    }).catch((err)=>{
        console.error('Fetch error:', err);
    });
}

});
parcelRegister("5u17S", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe0a0b50960839c$export$2e2bcd8739ae039);
function $3fe0a0b50960839c$var$updateName(dogName) {
    const dog = dogName || document.querySelector('input[name="dog_name"]').value;
    if (dog) {
        document.querySelectorAll('[data-dog-name]').forEach((el)=>{
            const isPossessive = el.dataset.dogName === 'possessive';
            el.textContent = isPossessive ? `${dog}'s` : dog;
        });
        document.querySelector("#package-selector span.dogname")?.text(dog);
    }
}
var $3fe0a0b50960839c$export$2e2bcd8739ae039 = $3fe0a0b50960839c$var$updateName;

});

parcelRegister("hi4SC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c967e72f8db85a4f$export$2e2bcd8739ae039);
// weightSync.js
function $c967e72f8db85a4f$var$syncWeightInputs(weightTextId, weightRangeId) {
    const weightTextInput = document.getElementById(weightTextId);
    const weightRangeInput = document.getElementById(weightRangeId);
    // Update text input when range slider changes
    weightRangeInput.addEventListener('input', (event)=>{
        weightTextInput.value = event.target.value;
    });
    // Update range slider when text input changes
    weightTextInput.addEventListener('change', (event)=>{
        // Ensure the text input value is within range slider's min and max
        let value = parseFloat(event.target.value);
        if (value < weightRangeInput.min) value = weightRangeInput.min;
        if (value > weightRangeInput.max) value = weightRangeInput.max;
        weightRangeInput.value = value;
        updateRangeBackground();
    });
    // Update the background gradient of the range slider
    function updateRangeBackground() {
        const value = (weightRangeInput.value - weightRangeInput.min) / (weightRangeInput.max - weightRangeInput.min) * 100;
        weightRangeInput.style.background = `linear-gradient(to right, #BFE7AD 0%, #BFE7AD ${value}%, #f3f3f3 ${value}%, #f3f3f3 100%)`;
    }
    // Add background update listeners
    weightRangeInput.addEventListener('input', updateRangeBackground);
    weightTextInput.addEventListener('input', updateRangeBackground);
    updateRangeBackground(); // Initialize on load
}
var $c967e72f8db85a4f$export$2e2bcd8739ae039 = $c967e72f8db85a4f$var$syncWeightInputs;

});


parcelRegister("gkyam", function(module, exports) {

var $gpsGG = parcelRequire("gpsGG");

var $evzE6 = parcelRequire("evzE6");

var $yJ7y8 = parcelRequire("yJ7y8");

var $7wDyk = parcelRequire("7wDyk");

var $gnuw3 = parcelRequire("gnuw3");

var $6uPTy = parcelRequire("6uPTy");

var $cNsAA = parcelRequire("cNsAA");

var $5u17S = parcelRequire("5u17S");

var $hi4SC = parcelRequire("hi4SC");
const wizard = document.querySelector(".shopify-section-quiz-wizard");
if (!wizard) return;
// Order data
const orderData = {
    name: {
        question: "Your dogs name is",
        answer: ""
    },
    breed: {
        question: "Marley's breed is a",
        answer: ""
    },
    gender: {
        question: "Marley is a",
        answer: ""
    },
    neutered: {
        question: "Is Marley Neutered",
        answer: ""
    },
    years: {
        question: "How old is Marley in years",
        answer: ""
    },
    months: {
        question: "How old is Marley in months",
        answer: ""
    },
    weight: {
        question: "Marley weights approximately",
        answer: ""
    },
    size: {
        question: "Marley is",
        answer: "Normal weight"
    },
    activity: {
        question: "Marley is",
        answer: "Normal activity"
    },
    allergies: {
        question: "Marley is allergic to",
        answer: []
    },
    treats: {
        question: "Marley gets treats",
        answer: "Sometimes"
    },
    eating: {
        question: "Marley is currently eating",
        answer: []
    },
    health_issues: {
        question: "Health issues",
        answer: []
    },
    fussy_dog: {
        question: "Is Marley a real fussy dog that would turn its nose up at a filet mignon?",
        answer: ""
    },
    prefered_treat: {
        question: "Prefered treat",
        answer: []
    },
    plan: {
        question: "Marley's plan",
        answer: "",
        contents: ""
    },
    owner_name: {
        question: "Your name",
        answer: ""
    },
    owner_email: {
        question: "Your email",
        answer: ""
    },
    owner_mobile: {
        question: "Mobile",
        answer: ""
    }
};
// Navigate with enter key
jQuery(window).keydown(function(e) {
    if (e.keyCode == 13) {
        e.preventDefault();
        jQuery('input[type=text], textarea').blur();
        if (document.querySelector('.wizard-v2').dataset.current == 16) jQuery('.next__button.trigger-post-quiz').trigger('click');
        else jQuery('.next__button:not(.trigger-post-quiz)').trigger('click');
        return false;
    }
});
// Add active state to wizard "Another dog" text
jQuery('.wizard__another_dog h3').on('click', function(e) {
    e.preventDefault();
    jQuery('.wizard__another_dog div.another_dog_info').slideToggle();
});
// Handle order data change
document.querySelectorAll("[data-order]").forEach((input)=>{
    input.addEventListener("change", (event)=>(0, $evzE6.default)(event, orderData));
});
// Buttons
const nextButton = document.querySelector(".next__button");
const startButton = document.querySelector(".start__button");
const checkoutButton = document.querySelector(".checkout__button");
const skipButton = document.querySelector(".skip__button");
const backButton = document.querySelector(".back__button");
const reviewButton = document.querySelector(".review__button");
// Variables
let step = 1;
let price = 0;
let running = false;
let hasReviewed = false;
let couponUsage = false;
let flkty = false;
let sliderItems = false;
let isPuppy = true;
const trial = document.querySelector('.wizard-v2').dataset.trial == 'true' ? true : false;
const trialCartons = 4;
let wpDays = trial ? 28 : 14;
function getTrialEndDate() {
    const date = new Date();
    date.setDate(date.getDate() + 14);
    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
}
// Confirm navigation
window.onbeforeunload = function() {
    return true;
};
// Puppy modals listeners
jQuery('input[data-order="years"]').on('input', function() {
    var months = Number(jQuery('input[data-order="years"]').val()) * 12 + Number(jQuery('input[data-order="months"]').val());
    puppyModalHelper(months);
});
jQuery('input[data-order="months"]').on('input', function() {
    var months = Number(jQuery('input[data-order="years"]').val()) * 12 + Number(jQuery('input[data-order="months"]').val());
    puppyModalHelper(months);
});
// Switch between neutered/spayed
jQuery('input[type="radio"][name="gender"]').on('change', function() {
    var selection = jQuery('input[type="radio"][name="gender"]:checked').val();
    var label = document.getElementById('neutered-spayed');
    var button = document.querySelector('.wizard-v2[data-current="3"] .regular-quiz-flow span');
    var old = label.innerHTML;
    let dog_sex = $('.gender-update');
    label.innerHTML = selection == 'Boy' ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
    dog_sex.html(selection == 'Boy' ? "he" : "she");
    if (button) button.innerHTML = selection == 'Boy' ? button.innerHTML.replace('Spayed', 'Neutered') : button.innerHTML.replace('Neutered', 'Spayed');
    jQuery('#neutered-spayed-container').show();
});
// Age input switch
jQuery('.inputChoices a[data-switcher="manual"]').on('click', function() {
    jQuery(this).attr('class', 'active');
    jQuery('.inputChoices a[data-switcher="datepicker"]').attr('class', '');
    jQuery('.inputSwitch#inputManual').css('display', 'block');
    jQuery('.inputSwitch#inputDatepicker').css('display', 'none');
});
jQuery('.inputChoices a[data-switcher="datepicker"]').on('click', function() {
    jQuery(this).attr('class', 'active');
    jQuery('.inputChoices a[data-switcher="manual"]').attr('class', '');
    jQuery('.inputSwitch#inputManual').css('display', 'none');
    jQuery('.inputSwitch#inputDatepicker').css('display', 'block');
});
// Slider illustrations
// jQuery('input[type="range"]').on('input change', function() {
//   var path = '/wp-content/themes/marleybones/assets/images/slider/';
//   if (this.name == 'weightgroup') { jQuery('img[data-slider="weightgroup"').attr('src', path+'size-0'+this.value+'.svg'); }
//   if (this.name == 'activity') { jQuery('img[data-slider="activity"').attr('src', path+'active-0'+this.value+'.svg'); }
//   if (this.name == 'treats') { jQuery('img[data-slider="treats"').attr('src', path+'treat-0'+this.value+'.svg'); }
// });
// Validate required inputs
function validate(target) {
    let errors = false;
    let customError = false;
    // Reset label styling
    jQuery('section[data-step="' + target + '"] label').each(function(i, obj) {
        jQuery(this).css('color', '#0f4632');
    });
    // Validate required inputs
    let invalidInputs = jQuery('section[data-step="' + target + '"] input[required]:invalid');
    if (invalidInputs.length > 0) {
        invalidInputs.each(function(i, obj) {
            jQuery('label[for="' + jQuery(this).attr('name') + '"]').css('color', '#ac2227');
        });
        errors = true;
    }
    // Validate radio buttons
    let numRadio = jQuery('section[data-step="' + target + '"] .radio__select');
    numRadio.each(function(i, obj) {
        if (jQuery(this).find('input[type="radio"]:checked').length == 0) {
            jQuery(this).siblings('label').css('color', '#ac2227');
            errors = true;
        }
    });
    // Validate checkboxes
    let multiselect = jQuery('section[data-step="' + target + '"] .multiselect__container');
    multiselect.each(function(i, obj) {
        if (jQuery(this).find('input[type="checkbox"]:checked').length == 0) {
            jQuery(this).prev('label').css('color', '#ac2227');
            errors = true;
        }
        if (jQuery(this).data('contains') == 'allergies' && jQuery(this).find('input[type="checkbox"]:checked').length == 4) {
            jQuery(this).prev('label').css('color', '#ac2227');
            errors = true;
            customError = 'Oh no! Looks like ' + orderData["name"]["answer"] + ' is allergic to all variants. Please get in touch if you have any questions';
        }
    });
    let healthselect = jQuery('section[data-step="' + target + '"] .health__container');
    healthselect.each(function(i, obj) {
        if (jQuery(this).find('input[type="checkbox"]:checked').length == 0) {
            jQuery(this).prev('label').css('color', '#ac2227');
            errors = true;
        }
    });
    if (errors) {
        if (customError) (0, $gpsGG.default)(customError);
        else (0, $gpsGG.default)();
        return false;
    }
    return true;
}
// Handle package slider
const handleSlider = ()=>{
    flkty = new Flickity(".meal__slider", {
        cellSelector: '.valid-cell',
        cellAlign: "left",
        pageDots: false,
        prevNextButtons: true
    });
    // Activate prev/next button when selecting cards. The buttons are hidden in flickity.css
    jQuery('#flickity-left').on('click', function() {
        document.querySelector('button.flickity-prev-next-button.previous').click();
    });
    jQuery('#flickity-right').on('click', function() {
        document.querySelector('button.flickity-prev-next-button.next').click();
    });
    flkty.on("staticClick", function(event, pointer, cellElement, cellIndex) {
        flkty.select(cellIndex, false, false);
    });
    flkty.on("select", function(index) {
        var cellElement = flkty.getCellElements()[index];
        document.querySelectorAll(".meal__sliderItem").forEach((item)=>{
            if (item !== cellElement) item.classList.remove("select");
        });
        // Mark as selected
        cellElement.classList.add("select");
        //document.querySelector('input[name="product"]').value = cellElement.getAttribute("data-product");
        // Ensure visible price breakdown
        document.querySelector('.price__breakdown').style.display = 'block';
        // If trial box is selected
        var isTrial = false;
        if (cellElement.getAttribute("data-product") == 'trial') {
            isTrial = true;
            orderData["plan"]["answer"] = 'Trial box';
        //document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'none';
        //document.querySelector('.price__breakdown tr[data-content="mealplan"]').style.display = 'none';
        //document.querySelector('.price__breakdown .billing-cycle').style.display = 'none';
        //document.querySelector('.price__breakdown .discount-duration').style.display = 'none';
        //document.querySelector('.price__breakdown tr[data-content="total"] .value').innerHTML = '£18.00';
        //document.querySelector('.price__breakdown tr[data-content="vat"] .value').innerHTML = '£3.00';
        } /* else {*/ 
        if (cellElement.getAttribute("data-product") == '100') orderData["plan"]["answer"] = 'Full plan';
        if (cellElement.getAttribute("data-product") == '60') orderData["plan"]["answer"] = 'Mixed plan';
        //document.querySelector('.price__breakdown tr[data-content="mealplan"]').style.display = 'block';
        document.querySelector('.price__breakdown .billing-cycle').style.display = 'block';
        document.querySelector('.price__breakdown .discount-duration').style.display = 'block';
        // Price breakdown
        var packageTotal = parseFloat(cellElement.getAttribute('data-total'));
        var packageBefore = parseFloat(cellElement.getAttribute('data-before'));
        var packageVat = parseFloat(cellElement.getAttribute('data-vat'));
        if (packageBefore > 0) {
            document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'block';
            var dailyString = "<del>\xa3" + (packageBefore / 28).toFixed(2) + "</del>&nbsp; \xa3" + (packageTotal / 28).toFixed(2) + ' /day';
            var totalString = "<del>\xa3" + packageBefore.toFixed(2) + "</del>&nbsp; \xa3" + packageTotal.toFixed(2);
            document.querySelector('.price__breakdown tr[data-content="discount"] .value').innerHTML = "-\xa3" + (packageBefore - packageTotal).toFixed(2);
            if (couponUsage) {
                if (couponUsage > 1) document.querySelector('.price__breakdown label small').innerHTML = 'The applied coupon is valid for the first ' + couponUsage + ' boxes';
                else document.querySelector('.price__breakdown label small').innerHTML = 'The applied coupon is valid for the first box';
            }
        } else {
            var dailyString = "\xa3" + (packageTotal / 28).toFixed(2) + ' /day';
            var totalString = "\xa3" + packageTotal.toFixed(2);
            document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'none';
        }
        if (isTrial) document.querySelector('.price__breakdown .billing-cycle').style.display = 'none';
        //document.querySelector('.price__breakdown tr[data-content="mealplan"] .value').innerHTML = dailyString;
        document.querySelector('.price__breakdown tr[data-content="total"] .value').innerHTML = totalString;
        document.querySelector('.price__breakdown tr[data-content="vat"] .value').innerHTML = "\xa3" + packageVat.toFixed(2);
        //}
        if (orderData["plan"]["answer"]) {
            nextButton.classList.remove("disabled");
            nextButton.innerHTML = 'Checkout';
        }
    });
    flkty.select(0, false, false);
};
// Review choices
reviewButton?.addEventListener("click", ()=>{
    (0, $gnuw3.default)(reviewButton, orderData);
    hasReviewed = true;
});
// Close review
jQuery('.review__button.close').on('click', function() {
    reviewButton.innerHTML = 'Review your choices';
    jQuery(this).css('display', 'none');
});
// Get input values
function qiv(name) {
    var element = document.querySelector('form input[name="' + name + '"]');
    return element || element === 0 ? element.value : false;
}
// Get age values
function ageInput(type) {
    if (type == 'years') return parseInt(qiv('years')) || 0;
    if (type == 'months') return parseInt(qiv('months')) || 0;
//if (type == 'birthday') { return (inputType == 'manual') ? false : qiv('datepicker__input'); }
}
let dogName = "Marley";
function getInput() {
    return {
        name: qiv('dog_name'),
        breed: document.querySelector('form input[name="breed"]:checked')?.value == "unknown_breed" ? 'Pawfect mix' : qiv('breed__autocomplete'),
        gender: document.querySelector('form input[name="gender"]:checked')?.value,
        neutered: document.querySelector('form input[name="neutered"]:checked')?.value,
        years: ageInput('years'),
        months: ageInput('months'),
        //birthday: ageInput('birthday'),
        weight: parseFloat(qiv('weight')),
        weightgroup: parseInt(document.querySelector('input[name="weightgroup"]:checked')?.value),
        activity: parseInt(document.querySelector('input[name="activity"]:checked')?.value),
        treats: parseInt(document.querySelector('input[name="treats"]:checked')?.value),
        allergies: jQuery('form input[name="allergies"]:checked')?.map(function() {
            return jQuery(this).val().toLowerCase();
        }).get(),
        food: jQuery('form input[name="current__food"]:checked')?.map(function() {
            return jQuery(this).val().toLowerCase();
        }).get(),
        health_issues: jQuery('form input[name="health_issues"]:checked')?.map(function() {
            return jQuery(this).val().toLowerCase();
        }).get(),
        fussy_dog: document.querySelector('form input[name="fussy_dog"]:checked')?.value,
        prefered_treat: jQuery('form input[name="prefered_treat"]:checked')?.map(function() {
            return jQuery(this).val().toLowerCase();
        }).get()
    };
}
// Limit modal
var limitModal = document.querySelector('.limit-modal');
limitModal.querySelector('.close').addEventListener("click", function() {
    limitModal.style.display = 'none';
});
function limitModalHelper() {
    var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    limitModal.style.marginTop = top + 'px';
    limitModal.style.display = 'inline-block';
}
// Pawrent login
var loginAction = 'create';
jQuery('.pawrent-welcome .pawrent-switch').on('click', function(e) {
    loggedIn = false;
    loginAction = 'login';
    jQuery('.pawrent-welcome').css('display', 'none');
    jQuery('.pawrent-login').css('display', 'block');
});
jQuery('.pawrent-login .new-account').on('click', function(e) {
    loginAction = 'create';
    jQuery('.pawrent-login').css('display', 'none');
    jQuery('.pawrent-register').css('display', 'block');
});
jQuery('.pawrent-register .existing-account').on('click', function(e) {
    loginAction = 'login';
    jQuery('.pawrent-login').css('display', 'block');
    jQuery('.pawrent-register').css('display', 'none');
});
function loginError(message) {
    running = false;
    nextButton.textContent = 'Next';
    (0, $gpsGG.default)(message);
    return false;
}
// function handleLogin() {
//   if (loggedIn) {
//     // OrderData: Ensure correct name and email
//     orderData["owner_name"]["answer"] = loggedInName;
//     orderData["owner_email"]["answer"] = loggedInEmail;
//     handleCoupon();
//     return;
//   }
//   if (loginAction == 'login') { // Perform login
//       // Validate input
//       let email = document.querySelector('.pawrent-login input[name="owner_email"]').value;
//       let password = document.querySelector('.pawrent-login input[name="owner_password"]').value;
//       if (!/\S+@\S+\.\S+/.test(email)) { return loginError('Please type in a valid email address'); }
//       if (password.length <= 3) { return loginError('Please type in a valid password'); }
//       // Sign in
//       jQuery.ajax({
//         url: "/wp-admin/admin-ajax.php",
//         async: true,
//         data: {
//           action: 'marleybones_handle_user',
//           handle: 'login',
//           email: email,
//           password: password,
//           newsletter: document.querySelector('.pawrent-login input[name="mc_signup"]').checked
//         },
//         type: 'post',
//         success: function(res) { 
//           if (res.status == true) {
//             // OrderData: Ensure correct name and email
//             orderData["owner_name"]["answer"] = res.name;
//             orderData["owner_email"]["answer"] = email;
//             // Change to "welcome back" screen
//             loggedIn = true;
//             loggedInName = orderData["owner_name"]["answer"];
//             loggedInEmail = orderData["owner_email"]["answer"];
//             jQuery('.pawrent-welcome .welcome-text').text('Welcome back, '+orderData["owner_name"]["answer"]);
//             jQuery('.pawrent-login').css('display', 'none');
//             jQuery('.pawrent-register').css('display', 'none');
//             jQuery('.pawrent-welcome').css('display', 'block');
//             // Enable/disable trialbox
//             if (res.trialbox_status != false) {
//               jQuery('.packages .trial').css('display', 'none');
//             } else {
//               jQuery('.packages .trial').css('display', 'block');
//             }
//             // Proceed
//             handleCoupon();
//             return;
//           } else {
//             if (res.error) {
//               return loginError(res.error);
//             } else {
//               return loginError('An error occurred while trying to log you in');
//             }
//           }
//         },
//         error: function(em) { return loginError(false); }
//       });
//   } else { // Create account
//     // Validate input
//     let name = document.querySelector('.pawrent-register input[name="owner_name"]').value;
//     let email = document.querySelector('.pawrent-register input[name="owner_email"]').value;
//     let password = document.querySelector('.pawrent-register input[name="owner_password"]').value;
//     let password_repeat = document.querySelector('.pawrent-register input[name="owner_password_repeat"]').value;
//     if (name.length < 5) { return loginError('Please type in a valid name'); }
//     if (!/\S+@\S+\.\S+/.test(email)) { return loginError('Please type in a valid email address'); }
//     if (password.length <= 3) { return loginError('Please type in a valid password'); }
//     if (password !== password_repeat) { return loginError('Passwords must match'); }
//     // Check email
//     jQuery.ajax({
//       url: "/wp-admin/admin-ajax.php",
//       async: true,
//       data: {
//         action: 'marleybones_handle_user',
//         handle: 'check',
//         email: document.querySelector('.pawrent-register input[name="owner_email"]').value
//       },
//       type: 'post',
//       success: function(res) {
//         if (res.status !== true) {
//           return loginError('That email address is already in use');
//         } else {
// 					console.log('creatr account');
//           createAccount();
//           return;
//         }
//       },
//       error: function(err) { return loginError('An error occurred'); }
//     });
//   }
// }
// function createAccount() {
// 	console.log(get_phone());
//   jQuery.ajax({
//     url: "/wp-admin/admin-ajax.php",
//     async: true,
//     data: {
//       action: 'marleybones_handle_user',
//       handle: 'create',
//       name: document.querySelector('.pawrent-register input[name="owner_name"]').value,
//       email: document.querySelector('.pawrent-register input[name="owner_email"]').value,
//       password: document.querySelector('.pawrent-register input[name="owner_password"]').value,
//       newsletter: document.querySelector('.pawrent-register input[name="mc_signup"]').checked,
//       phone: get_phone(),
//     },
//     type: 'post',
//     success: function(res) {
//       if (res.status !== true) {
//         return loginError('An error occurred while trying to create your account');
//       } else {
//         // OrderData: Ensure correct name and email
//         orderData["owner_name"]["answer"] = document.querySelector('.pawrent-register input[name="owner_name"]').value;
//         orderData["owner_email"]["answer"] = document.querySelector('.pawrent-register input[name="owner_email"]').value;
//         // Change to "welcome back" screen
//         loggedIn = true;
//         loggedInName = orderData["owner_name"]["answer"];
//         loggedInEmail = orderData["owner_email"]["answer"];
//         jQuery('.pawrent-welcome .welcome-text').text('Welcome back, '+orderData["owner_name"]["answer"]);
//         jQuery('.pawrent-login').css('display', 'none');
//         jQuery('.pawrent-register').css('display', 'none');
//         jQuery('.pawrent-welcome').css('display', 'block');
//         // Ensure that trialbox is visible
//         jQuery('.packages .trial').css('display', 'block');
//         if(document.querySelector('.pawrent-register input[name="mc_signup"]').checked) {
// 					const options = {
// 						method: 'POST',
// 						headers: {revision: '2023-06-15', 'content-type': 'application/json'},
// 						body: JSON.stringify({
// 							data: {
// 								type: 'subscription',
// 								attributes: {
// 									list_id: 'XWKRtA',
// 									custom_source: 'Wizard',
// 									email: document.querySelector('.pawrent-register input[name="owner_email"]').value,
// 									phone_number: get_phone()
// 								}
// 							}
// 						})
// 					};
// 					fetch('https://a.klaviyo.com/client/subscriptions/?company_id=R6vSRF', options)
// 						.then(response => response.json())
// 						.then(response => console.log(response))
// 						.catch(err => console.error(err));
// 				}
//         // Proceed
//         handleCoupon();
//         return;
//       }
//     },
//     error: function(err) { return loginError('An error occurred'); }
//   });
// }
let discountCodeValue = 0;
let discountCode;
function handleCoupon() {
    // Check coupon-code
    let coupon = document.querySelector('form input[name="discount"]').value;
    let havecoupon = document.querySelector('form input[name="have_discount"]').checked;
    if (havecoupon !== false && coupon.length >= 3) {
        let ccode = JSON.stringify(coupon);
        let store = Shopify.shop;
        // Handle coupon
        jQuery.ajax({
            url: `https://netlify.blacklemon.dk/.netlify/functions/checkCouponCode?store=${store}`,
            async: true,
            data: {
                ccode: ccode
            },
            type: 'post',
            success: function(res) {
                let response = JSON.parse(res);
                if (response.error) {
                    console.log('we have error');
                    document.querySelector('.coupon-status').classList.remove('coupon-status--active');
                    document.querySelector('.coupon-status').classList.add('coupon-status--error');
                    $('.post-wizard-recommendation__info-discount-wrapper').hide();
                    discountCode = "";
                } else {
                    discountCodeValue = response.success / 100;
                    document.querySelector('.coupon-status').classList.add('coupon-status--active');
                    document.querySelector('.coupon-status').classList.remove('coupon-status--error');
                    document.querySelector('.coupon-status_message--valid span').innerHTML = response.success;
                    $('.package-original-price').addClass('package-original-price--crossed');
                    $('.post-wizard-recommendation__info-discount-wrapper').show();
                    discountCode = coupon;
                }
            // needs 
            },
            error: function(err) {
                (0, $gpsGG.default)('An error occurred');
                return;
            }
        });
    } else if (havecoupon !== false && coupon.length <= 3) return loginError('Invalid coupon code!');
    else // loginProceed();
    return;
}
function loginProceed() {
    (0, $yJ7y8.handleLoader)();
    navigate('next');
    //checkoutFlow(16);
    running = false;
    nextButton.textContent = 'Next';
    var variants = [
        'chicken',
        'beef',
        'lamb',
        'salmon'
    ];
    var hundred = {
        status: false
    };
    var sixty = {
        status: false
    };
    var dailyIntake = document.querySelector(".daily-intake").innerHTML;
    var breedInput = document.querySelector('form input[name="unknown_breed"]').checked == true ? '' : qiv('breed__autocomplete');
    var sizeInput = orderData["size"]["answer"];
    var dogName = document.querySelector('input[name="dog_name"]').value;
    console.log(orderData["size"]["answer"]);
    console.log(orderData["size"]);
    console.log(sizeInput);
    if (typeof sizeInput === 'string' || sizeInput instanceof String) ;
    else sizeInput = sizeInput['weight'];
    dailyIntake = dailyIntake.replace('{dogname}', dogName);
    dailyIntake = dailyIntake.replace('{years}', orderData["years"]["answer"]);
    dailyIntake = dailyIntake.replace('{breed}', breedInput.toLowerCase());
    dailyIntake = dailyIntake.replace('{size}', sizeInput.toLowerCase());
    //document.querySelector(".daily-intake").innerHTML = dailyIntake;
    var ageStr = '';
    if (orderData["years"]["answer"] != '' && orderData["years"]["answer"] != 0) {
        if (orderData["years"]["answer"] == 1) ageStr = orderData["years"]["answer"] + ' year ';
        else ageStr = orderData["years"]["answer"] + ' years ';
    }
    if (orderData["months"]["answer"] != '' && orderData["months"]["answer"] != 0) {
        if (orderData["months"]["answer"] == 1) ageStr = ageStr + orderData["months"]["answer"] + ' month ';
        else ageStr = ageStr + orderData["months"]["answer"] + ' months ';
    }
    if (ageStr != '') ageStr = ageStr + ' old';
    document.querySelector(".daily-intake output.name").innerHTML = dogName;
    document.querySelector(".daily-intake output.breed").innerHTML = breedInput.toLowerCase();
    document.querySelector(".daily-intake output.size").innerHTML = sizeInput.toLowerCase();
    document.querySelector(".daily-intake output.age").innerHTML = ageStr;
    jQuery('#package-selector .tabs').tabs();
    // Create packages
    [
        100,
        'trial'
    ].forEach((percent, index)=>{
        jQuery.ajax({
            url: "/wp-admin/admin-ajax.php",
            async: true,
            data: {
                action: 'marleybones_fetch_package',
                input: getInput(),
                percentage: percent
            },
            type: 'post',
            success: function(res) {
                // First run
                if (!hundred.status && !sixty.status) {
                    if (percent != 'trial') {
                        var meals = res.dailyMeals.toString().replace('.25', '&frac14;').replace('.5', '&frac12;').replace('.75', '&frac34;').replace('0', '');
                        //document.querySelector('.daily-intake span').innerHTML = meals + ' pack per day ('+res.dailyKcal+' kcal)'; 
                        var mealsCount = res.dailyMeals * 28;
                        mealsCount = mealsCount < 14 ? 14 : mealsCount;
                        jQuery(".package-count span").html(mealsCount);
                    }
                    if (Number(res.coupon_usage_limit) > 0) {
                        couponUsage = Number(res.coupon_usage_limit);
                        console.log('Coupon usage: ' + couponUsage);
                        var couponUsageTxt = 'The applied coupon is valid for the first box';
                        if (couponUsage > 1) couponUsageTxt = 'The applied coupon is valid for the first ' + couponUsage + ' boxes';
                        document.querySelector('.price__breakdown .discount-duration small').innerHTML = couponUsageTxt;
                    }
                }
                // Count products
                var products = 0;
                jQuery.each(variants, function(i, v) {
                    products = products + res.package_js[v];
                });
                var isTrial = res.percentage == 'trial' ? true : false;
                var dailyString = "\xa3" + (res.total / 28).toFixed(2) + ' /day';
                var totalString = "\xa3" + res.total.toFixed(2);
                console.log(res);
                if (products >= 14 || isTrial) {
                    //document.querySelector('.package[data-product="'+percent+'"]').className = 'meal__sliderItem package valid-cell';
                    // If discounted
                    if (Number(res.before) > 0) {
                        if (isTrial) {
                            var dailyString = "<del>\xa3" + res.before.toFixed(2) + "</del>&nbsp; \xa3" + res.total.toFixed(2);
                            var totalString = "<del>\xa3" + res.before.toFixed(2) + "</del>&nbsp; \xa3" + res.total.toFixed(2);
                        } else {
                            var dailyString = "<del>\xa3" + (res.before / 28).toFixed(2) + "</del>&nbsp; \xa3" + (res.total / 28).toFixed(2) + ' /day';
                            var totalString = "<del>\xa3" + res.before.toFixed(2) + "</del>&nbsp; \xa3" + res.total.toFixed(2);
                        }
                        document.querySelector('.price__breakdown tr[data-content="discount"] .value').innerHTML = "-\xa3" + (res.before - res.total).toFixed(2);
                    } else {
                        if (isTrial) {
                            var dailyString = "\xa3" + res.total.toFixed(2);
                            var totalString = "\xa3" + res.total.toFixed(2);
                        } else {
                            var dailyString = "\xa3" + (res.total / 28).toFixed(2) + ' /day';
                            var totalString = "\xa3" + res.total.toFixed(2) + ' /month';
                        }
                        document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'none';
                    }
                    jQuery('li[data-product=' + percent + '] span').html(dailyString);
                    /*
            document.querySelector('.package[data-product="'+percent+'"] .price').innerHTML = dailyString;
            if(!isTrial) {
              document.querySelector('.package[data-product="'+percent+'"] .packs span').innerHTML = (res.dailyMeals.toString()).replace('.25', '&frac14;').replace('.5', '&frac12;').replace('.75', '&frac34;').replace('0', '') + ' ' + ((res.dailyMeals == 1) ? 'pack' : 'packs');
              //document.querySelector('.package[data-product="'+percent+'"] .dinings span').innerHTML = parseFloat(res.dailyMeals) * 4;
            }
            document.querySelector('.package[data-product="'+percent+'"]').setAttribute('data-total', res.total);
            document.querySelector('.package[data-product="'+percent+'"]').setAttribute('data-before', res.before);
            document.querySelector('.package[data-product="'+percent+'"]').setAttribute('data-vat', res.vat);
  
  */ // Insert package products
                    var packageTable = '';
                    // if(!isTrial) {
                    var sorted = Object.keys(res.package_js).sort(function(a, b) {
                        return res.package_js[b] - res.package_js[a];
                    });
                    var totalPacks = 0;
                    jQuery.each(sorted, function(i, v) {
                        //if (variants.indexOf(v) == -1) { return; }
                        if (res.package_js[v] < 1) packageTable += '<div class="hide" data-product-teaser="' + v + '"><img style="width: 100%;" src="' + res.prodimages[v] + '" /> <span>' + res.package_js[v] + '</span>x ' + v + '</div>';
                        else packageTable += '<div data-product-teaser="' + v + '"><img style="width: 100%;" src="' + res.prodimages[v] + '" /> <span>' + res.package_js[v] + '</span>x ' + v + '</div>';
                        if (percent != 'trial') {
                            jQuery("#plan_quantity_" + v).val(res.package_js[v]);
                            console.log("Setting " + v + " to " + res.package_js[v]);
                            totalPacks += res.package_js[v];
                            jQuery("#plan_quantity_" + v).trigger('change');
                        } else {
                            jQuery("#trial_quantity_" + v).val(res.package_js[v]);
                            jQuery("#trial_quantity_" + v).trigger('change');
                        }
                    });
                    if (percent != 'trial') {
                        jQuery("#package").val(totalPacks);
                        jQuery("#package").trigger('change');
                    //Add trialbox
                    }
                    if (orderData["prefered_treat"]["answer"] != '' && orderData["prefered_treat"]["answer"] != 'none') packageTable = packageTable + '<div><img style="width: 100%;" src="/wp-content/themes/marleybones/assets/images/' + orderData["prefered_treat"]["answer"] + '_treats.png"> Free treats for life</div>';
                    document.querySelector('.package-tab[data-product="' + percent + '"] .package-items').innerHTML = packageTable;
                //}
                } else if (percent == 100) {
                    navigate('back');
                    nextButton.textContent = 'Next';
                    limitModalHelper();
                    return;
                }
                // Register 100% run
                /*if (percent == 100) { 
          hundred.status = true; 
          hundred.price = res.total;
          hundred.products = products;
          document.querySelector('.packages .best-value').style.display = 'block';
        }

        // Register 60% run
        if (percent == 60) { 
          sixty.status = true; 
          sixty.price = res.total;
          sixty.products = products;
        }

        // Last run
        if (hundred.status && sixty.status) {

          // Hide 60% if price is too close to 100%
          if (hundred.price > 0 && sixty.price > 0 && hundred.price < (sixty.price+3)) {
            document.querySelector('.package[data-product="60"]').className = 'meal__sliderItem package';
            document.querySelector('.package[data-product="100"] .best-value').style.display = 'none';
          }

          // Initiate flickity
          //setTimeout(() => handleSlider(), 100); 
          //console.log('Flickity initiated');

        }*/ // 100% package
                if (percent == 100) {
                    // Show default price breakdown
                    document.querySelector('.price__breakdown').style.display = 'block';
                    //document.querySelector('.price__breakdown tr[data-content="mealplan"] .value').innerHTML = dailyString;
                    document.querySelector('.price__breakdown tr[data-content="total"] .value').innerHTML = totalString;
                //document.querySelector('.price__breakdown tr[data-content="vat"] .value').innerHTML = '£'+res.vat.toFixed(2);
                }
            },
            error: function(err) {
                (0, $gpsGG.default)('An error occurred');
                return;
            }
        });
    });
}
function handleCheckout() {
    // Handle attempts
    checkoutAttempts = checkoutAttempts + 1;
    if (checkoutAttempts <= 5) {
        console.log(checkoutAttempts + '. Attempt...');
        console.log(getInput());
        var activeProduct = document.querySelector('input[name="product"]').value;
        if (activeProduct == '') activeProduct = 'trial';
        var mealQuantity = {};
        var extraQuantity = {};
        jQuery('.mealquantity.plan-' + activeProduct).each(function() {
            mealQuantity[jQuery(this).attr('data-product-id')] = jQuery(this).val();
        });
        jQuery('.extraquantity').each(function() {
            extraQuantity[jQuery(this).attr('data-product-id')] = jQuery(this).val();
        });
        console.log(mealQuantity);
        console.log(extraQuantity);
        // Add to cart
        jQuery.ajax({
            url: "/wp-admin/admin-ajax.php",
            async: true,
            data: {
                action: 'marleybones_add_to_cart',
                percentage: activeProduct,
                quantity_meals: mealQuantity,
                quantity_extras: extraQuantity,
                input: getInput()
            },
            type: 'post',
            success: function(res) {
                if (res.status == true) {
                    // Redirect to checkout
                    console.log(res);
                    window.onbeforeunload = null;
                    window.location.href = "/checkout";
                } else {
                    console.log(res);
                    console.log('Failed (status false)');
                    handleCheckout();
                }
            },
            error: function(err) {
                console.log('Failed (AJAX error)');
                handleCheckout();
            }
        });
    } else {
        (0, $gpsGG.default)('Checkout failed. Please try again or contact us');
        return;
    }
}
// Checkout flow tracking
function checkoutFlow(step) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
            'checkout': {
                'actionField': {
                    'step': step
                }
            }
        }
    });
}
// Track first step on load
checkoutFlow(1);
let monthlyCartons;
let cartObject;
let cartTrialObject;
let cartHalfObject;
// Handle steps
function navigate(click) {
    // Handle navigation
    step = click == 'back' ? step - 1 : step + 1;
    document.querySelector('.progress__counter span').innerHTML = step - 1;
    document.querySelector('.next__button span').innerHTML = document.querySelector(`section[data-step='${step + 1}']`)?.dataset.topic;
    (0, $5u17S.default)();
    dogName = qiv('dog_name');
    (0, $7wDyk.default)(click, step);
    (0, $cNsAA.default)(step);
    (0, $6uPTy.scrollToTop)();
    document.querySelector('.wizard-v2').dataset.current = step;
    if (step === 1) checkoutFlow(1);
}
function handleSteps() {
    let next = step + 1;
    if (step > 1) saveQuizProgress(step);
    // Proceed from dog name and apply it to labels
    if (next === 2) {
        if (validate(step)) {
            navigate('next');
            backButton.classList.remove("disabled");
            // startButton.classList.add("disabled");
            nextButton.classList.remove("disabled");
            checkoutFlow(next);
        }
    }
    if (next === 3) /* if (!ageInput('years') && !ageInput('months') && !ageInput('birthday')) {
       triggerAlert('Please fill out the age of your pooch');
     } else {
       if (validate(step)) {
         if (ageAllowed) {
           navigate('next');
           checkoutFlow(next);
         } else {
           triggerAlert('Whoops, seems like you\'ve exceeded the age limit. Are you sure that your dog is that old?');
         }
       }
     }*/ {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 4) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 5) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    // Go to login
    if (next === 6) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 7) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 8) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 9) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 10) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 11) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 12) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 13) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 14) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    if (next === 15) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
    }
    // Coupon & login
    if (next === 16) {
        if (validate(step)) {
            navigate('next');
            checkoutFlow(next);
        }
        let data = getInput();
        console.log("\uD83D\uDC15 Quiz completed - User choices:", data);
        function sanitizeBolean(value) {
            value = value.trim();
            switch(value.toLowerCase()){
                case 'yes':
                    return true;
                case 'no':
                    return false;
                default:
                    return Boolean(value);
            }
        }
        let subscriptionData = {
            "dog_name": data.name,
            "dog_breed": data.breed,
            "dog_gender": data.gender,
            "dog_neutered": sanitizeBolean(data.neutered),
            "dog_years": data.years,
            "dog_months": data.months,
            "dog_weight": data.weight,
            "dog_weightgroup": data.weightgroup,
            "dog_activity": data.activity,
            "dog_treats": data.treats,
            "dog_allergies": data.allergies,
            "dog_eating": data.food,
            "dog_fussy_dog": data.fussy_dog,
            "dog_prefered_treat": data.prefered_treat,
            "dog_health_issues": data.health_issues
        };
        // Calculate age in months
        let months;
        months = parseInt(subscriptionData.dog_years) * 12 + parseInt(subscriptionData.dog_months);
        if (months > 11) isPuppy = false;
        // Get multiplier
        let multiplier;
        if (months < 6) multiplier = 1.8;
        else if (months < 9) multiplier = 1.6;
        else if (months < 12) multiplier = 1.4;
        else multiplier = 1.2;
        // Adjust multiplier by activity
        if (months >= 12) {
            multiplier -= subscriptionData['dog_activity'] < 2 ? 0.1 : 0; // Inactive
            multiplier += subscriptionData['dog_activity'] > 2 ? 0.1 : 0; // Very active
        }
        // Adjust multiplier by weight group
        if (months < 12) // Puppy
        multiplier *= subscriptionData['dog_weightgroup'] < 2 ? 1.1 : 1; // Underweight
        else {
            // Adult
            multiplier *= subscriptionData['dog_weightgroup'] < 2 ? 1.1 : 1; // Underweight
            multiplier *= subscriptionData['dog_weightgroup'] > 2 ? 0.9 : 1; // Overweight
        }
        // Adjust multiplier if neutered
        multiplier *= subscriptionData['dog_neutered'] && months >= 6 ? 0.9 : 1;
        // Treats to multiplier
        const treats = 1 - (subscriptionData['dog_treats'] - 1) * 0.05;
        let percentage = 100;
        // Calculate calorie requirement
        const RER = 70 * Math.pow(subscriptionData['dog_weight'], 0.75);
        const MER = RER * multiplier * treats;
        const MERReduced = MER * (percentage / 100);
        // Daily & monthly dinings/cartons
        const dailyDinings = Math.round(MERReduced / 125); // Round to nearest integer
        const dailyCartons = dailyDinings / 4; // Convert to quarters
        monthlyCartons = dailyCartons * wpDays; // Multiply by wpDays
        document.getElementById('cal_counter').innerHTML = Math.round(MER);
    }
    next;
    // Load checkout
    if (next === 18) {
        checkoutFlow(next);
        navigate('next');
        document.querySelector('nav.bottom__navigation').style.display = 'none';
        backButton.classList.add("disabled");
        nextButton.classList.add("disabled");
        console.log('Preparing checkout\n');
    // handleCheckout();
    }
    document.querySelector('.wizard-v2').dataset.current = step;
}
jQuery("#have_discount").on('click', function(e) {
    jQuery('.discount-input-wrapper').toggleClass('active');
});
function emptyCartOnStart() {
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((data)=>{
        console.log('Cart cleared:', data);
    // Optionally, refresh the page or update the cart UI here
    }).catch((error)=>console.error('Error clearing cart:', error));
}
nextButton.addEventListener("click", ()=>{
    handleSteps();
});
startButton.addEventListener("click", ()=>{
    handleSteps();
    emptyCartOnStart();
// $('.apply-coupon').click();
});
checkoutButton?.addEventListener("click", ()=>{
    handleSteps();
});
skipButton?.addEventListener("click", ()=>{
    handleSteps();
});
backButton.addEventListener("click", ()=>{
    navigate('back');
    if (step === 1) backButton.classList.add("disabled");
    if (step === 5) {
        // Reset navigation button
        nextButton.classList.remove("disabled");
        nextButton.textContent = 'Next';
        // Destroy flickity
        if (flkty) {
            flkty.destroy();
            flkty = false;
            console.log('Flickity destroyed');
        }
    }
});
function getBreeds(path) {
    var csv = breedsData;
    return csv.split('\n');
}
var breeds = getBreeds();
const input = document.querySelector(".autocomplete");
function autocomplete(inp, arr) {
    /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/ var currentFocus;
    /*execute a function when someone writes in the text field:*/ inp.addEventListener("input", function(e) {
        var a, b, i, val = this.value;
        /*close any already open lists of autocompleted values*/ closeAllLists();
        if (!val || val.length < 2) return false;
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/ a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/ this.parentNode.appendChild(a);
        /*for each item in the array...*/ for(i = 0; i < arr.length; i++){
            /* Lowercase */ var $breed = arr[i].toLowerCase();
            var $input = val.toLowerCase();
            /*check if the item starts with the same letters as the text field value:*/ if ($breed.indexOf($input) !== -1) {
                /*create a DIV element for each matching element:*/ b = document.createElement("DIV");
                /*make the matching letters bold:*/ b.innerHTML = arr[i].toLowerCase().replace($input, "<strong>" + $input + "</strong>");
                /*insert a input field that will hold the current array item's value:*/ b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                let evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                b.dispatchEvent(evt);
                /*execute a function when someone clicks on the item value (DIV element):*/ b.addEventListener("click", function(e) {
                    /*insert the value for the autocomplete text field:*/ inp.value = this.getElementsByTagName("input")[0].value;
                    inp.dispatchEvent(evt);
                    /*close the list of autocompleted values,
              (or any other open lists of autocompleted values:*/ closeAllLists();
                });
                a.appendChild(b);
            }
        }
    });
    /*execute a function presses a key on the keyboard:*/ inp.addEventListener("keydown", function(e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/ currentFocus++;
            /*and and make the current item more visible:*/ addActive(x);
        } else if (e.keyCode == 38) {
            //up
            /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/ currentFocus--;
            /*and and make the current item more visible:*/ addActive(x);
        } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/ e.preventDefault();
            if (currentFocus > -1) /*and simulate a click on the "active" item:*/ {
                if (x) x[currentFocus].click();
            }
        }
    });
    function addActive(x) {
        /*a function to classify an item as "active":*/ if (!x) return false;
        /*start by removing the "active" class on all items:*/ removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        /*add class "autocomplete-active":*/ x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/ for(var i = 0; i < x.length; i++)x[i].classList.remove("autocomplete-active");
    }
    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
    except the one passed as an argument:*/ var x = document.getElementsByClassName("autocomplete-items");
        for(var i = 0; i < x.length; i++)if (elmnt != x[i] && elmnt != inp) x[i].parentNode.removeChild(x[i]);
    }
    /*execute a function when someone clicks in the document:*/ document.addEventListener("click", function(e) {
        closeAllLists(e.target);
    });
}
autocomplete(input, breeds);
const allCheckboxesAllergies = document.querySelectorAll("input[name='allergies']");
jQuery('input[name="allergies"]').on('click', function() {
    if (this.value == 'Nothing') {
        if (this.checked) allCheckboxesAllergies.forEach((item)=>{
            if (item.value == 'Nothing') return;
            item.checked = false;
        });
    } else document.querySelector('input[name="allergies"][value="Nothing"]').checked = false;
});
const allCheckboxesHealth = document.querySelectorAll("input[name='health_issues']");
jQuery('input[name="health_issues"]').on('click', function() {
    if (this.value == 'No health issues') {
        if (this.checked) allCheckboxesHealth.forEach((item)=>{
            if (item.value == 'No health issues') return;
            item.checked = false;
        });
    } else document.querySelector('input[name="health_issues"][value="No health issues"]').checked = false;
});
const allCheckboxesTreats = document.querySelectorAll("input[name='prefered_treat']");
jQuery('input[name="prefered_treat"]').on('click', function() {
    if (this.value == 'none') {
        if (this.checked) allCheckboxesTreats.forEach((item)=>{
            if (item.value == 'none') return;
            item.checked = false;
        });
    } else document.querySelector('input[name="prefered_treat"][value="none"]').checked = false;
});
function sanitizeBolean(value) {
    value = value.trim();
    switch(value.toLowerCase()){
        case 'yes':
            return true;
        case 'no':
            return false;
        default:
            return Boolean(value);
    }
}
function mealDistribution(split, monthlyCartons) {
    let foodPackage = {
        'chicken': split['chicken'] ? Math.round(monthlyCartons * split['chicken']) : 0,
        'beef': split['beef'] ? Math.round(monthlyCartons * split['beef']) : 0,
        'lamb': split['lamb'] ? Math.round(monthlyCartons * split['lamb']) : 0,
        'salmon': split['salmon'] ? Math.round(monthlyCartons * split['salmon']) : 0
    };
    // Increase package until monthly target is met
    let difference = Math.round(monthlyCartons - Object.values(foodPackage).reduce((a, b)=>a + b, 0));
    while(difference > 0){
        for(let type in foodPackage)if (difference > 0 && split.hasOwnProperty(type)) {
            foodPackage[type] += 1;
            difference -= 1;
        }
    }
    return foodPackage;
}
// Default package split
let split = {
    chicken: 0.35,
    beef: 0.3,
    lamb: 0.2,
    salmon: 0.15
};
// Default package split
let trialSplit = {
    chicken: 0.25,
    beef: 0.25,
    lamb: 0.25,
    salmon: 0.25
};
// Function to increase split percentages if the total is less than 1
function adjustSplitPercentage(split) {
    const totalSplit = Object.values(split).reduce((acc, val)=>acc + val, 0);
    if (totalSplit < 1) {
        const diff = 1 - totalSplit;
        const count = Object.keys(split).length;
        for(const key in split)split[key] += diff / count;
    }
    return split;
}
// Remove ingredients if allergic
function removeAllergicIngredients(subscriptionData) {
    subscriptionData.dog_allergies.forEach((allergy)=>{
        delete split[allergy.toLowerCase()];
        delete trialSplit[allergy.toLowerCase()];
    });
    split = adjustSplitPercentage(split);
    trialSplit = adjustSplitPercentage(trialSplit);
    return true;
}
let feedingGuide;
function feedingGuideCalc(mealCount) {
    // Calculate y as x divided by 14
    const packPercentage = mealCount / wpDays;
    // If y is less than 0.25, set it to 0.25
    if (packPercentage < 0.25) return 0.25;
    // Round y to the nearest 0.25
    const roundedpackPercentage = Math.round(packPercentage * 4) / 4;
    return roundedpackPercentage;
}
function decimalToFraction(decimal) {
    if (decimal === Math.floor(decimal)) return decimal.toString(); // It's a whole number
    const wholeNumber = Math.floor(decimal);
    const fractionalPart = decimal - wholeNumber;
    const precision = 100000; // Precision to avoid floating-point issues
    const numerator = Math.round(fractionalPart * precision);
    const denominator = precision;
    // Simplify the fraction using the greatest common divisor (GCD)
    function gcd(a, b) {
        return b === 0 ? a : gcd(b, a % b);
    }
    const divisor = gcd(numerator, denominator);
    const simplifiedNumerator = numerator / divisor;
    const simplifiedDenominator = denominator / divisor;
    if (wholeNumber === 0) return `<sup>${simplifiedNumerator}</sup>/<sub>${simplifiedDenominator}</sub>`;
    return `${wholeNumber}<sup>${simplifiedNumerator}</sup>/<sub>${simplifiedDenominator}</sub>`;
}
function calculateMealPlan(payload) {
    let payloadData = JSON.parse(payload);
    let fullPrice = 0;
    let trialPrice = 0;
    let fullPlanPrice = 0;
    let subscriptionData = {
        "dog_name": payloadData.name,
        "dog_breed": payloadData.breed,
        "dog_gender": payloadData.gender,
        "dog_neutered": sanitizeBolean(payloadData.neutered),
        "dog_years": payloadData.years,
        "dog_months": payloadData.months,
        "dog_weight": payloadData.weight,
        "dog_weightgroup": payloadData.weightgroup,
        "dog_activity": payloadData.activity,
        "dog_treats": payloadData.treats,
        "dog_allergies": payloadData.allergies,
        "dog_eating": payloadData.food,
        "dog_fussy_dog": payloadData.fussy_dog,
        "dog_prefered_treat": payloadData.prefered_treat,
        "dog_health_issues": payloadData.health_issues
    };
    removeAllergicIngredients(subscriptionData);
    // Calculate age in months
    let months;
    months = subscriptionData['dog_years'] * 12 + subscriptionData['dog_months'];
    // Get multiplier
    let multiplier;
    if (months < 6) multiplier = 1.8;
    else if (months < 9) multiplier = 1.6;
    else if (months < 12) multiplier = 1.4;
    else multiplier = 1.2;
    // Adjust multiplier by activity
    if (months >= 12) {
        multiplier -= subscriptionData['dog_activity'] < 2 ? 0.1 : 0; // Inactive
        multiplier += subscriptionData['dog_activity'] > 2 ? 0.1 : 0; // Very active
    }
    // Adjust multiplier by weight group
    if (months < 12) // Puppy
    multiplier *= subscriptionData['dog_weightgroup'] < 2 ? 1.1 : 1; // Underweight
    else {
        // Adult
        multiplier *= subscriptionData['dog_weightgroup'] < 2 ? 1.1 : 1; // Underweight
        multiplier *= subscriptionData['dog_weightgroup'] > 2 ? 0.9 : 1; // Overweight
    }
    // Adjust multiplier if neutered
    multiplier *= subscriptionData['dog_neutered'] && months >= 6 ? 0.9 : 1;
    // Treats to multiplier
    const treats = 1 - (subscriptionData['dog_treats'] - 1) * 0.05;
    let percentage = 100;
    // Calculate calorie requirement
    const RER = 70 * Math.pow(subscriptionData['dog_weight'], 0.75);
    const MER = RER * multiplier * treats;
    const MERReduced = MER * (percentage / 100);
    // Daily & monthly dinings/cartons
    const dailyDinings = Math.round(MERReduced / 125); // Round to nearest integer
    const dailyCartons = dailyDinings / 4; // Convert to quarters
    monthlyCartons = dailyCartons * wpDays; // Multiply by wpDays
    // document.getElementById('cartons-per-day').innerHTML = decimalToFraction(dailyCartons);
    // if (Number(dailyCartons) >= 2) {
    //   document.getElementById('cartons-plaural').innerHTML = "s";
    // }
    let foodPackage = mealDistribution(split, monthlyCartons);
    let trialFoodPackage = mealDistribution(trialSplit, trialCartons);
    /* dog treats */ let preferedTreat = {};
    if (subscriptionData['dog_treats'] > 1) {
        let treatList = [
            "lamb",
            "chicken",
            "beef"
        ];
        if (subscriptionData['dog_prefered_treat'] == 'none') {
            subscriptionData.dog_allergies.forEach((allergy)=>{
                // Find the index of the allergy in the treatList
                const index = treatList.indexOf(allergy.toLowerCase());
                // If the allergy is in treatList, remove it
                if (index !== -1) treatList.splice(index, 1); // Remove the item at the found index
            });
            if (treatList.length) {
                //select first from list (predefined order)
                let objKey = treatList[0];
                preferedTreat[objKey] = 1;
            } else preferedTreat = "no treats";
        } else {
            // 1 product per chosen flavour
            if (Array.isArray(subscriptionData['dog_prefered_treat'])) subscriptionData['dog_prefered_treat'].forEach((item)=>{
                preferedTreat[item] = 1;
            });
            else if (subscriptionData['dog_prefered_treat']) preferedTreat[subscriptionData['dog_prefered_treat']] = 1;
        }
    }
    /* dog supplements */ let supplements = {};
    let supplementsQuantity = 1;
    // function calculateAdditions(weight) {
    //     if (weight < 10) {
    //         return 1;
    //     } else if (weight <= 25) {
    //         return 2;
    //     } else if (weight <= 40) {
    //         return 3;
    //     } else {
    //         // Calculate additional additions for weights above 40kg
    //         const extraWeight = weight - 40;
    //         const extraAdditions = Math.ceil(extraWeight / 15);
    //         return 3 + extraAdditions;
    //     }
    // }
    if (months >= 6) {
        if (subscriptionData['dog_health_issues'].includes('dry, itchy or dull coat')) supplements.oil = supplementsQuantity; // Add "oil" supplement
        if (subscriptionData['dog_health_issues'].includes('a sensitive stomach')) supplements.gut = supplementsQuantity; // Add "gut" supplement
        if (subscriptionData['dog_health_issues'].includes('dental issues or bad breath')) supplements.dental = supplementsQuantity; // Add "dental" supplement
        if (subscriptionData['dog_health_issues'].includes('joint stiffness or pain')) supplements.joint = supplementsQuantity; // Add "joint" supplement
        // Recommend joint supplement for dogs 7+ years old
        if (months >= 84 && !supplements.joint) supplements.joint = supplementsQuantity;
    }
    let totalPackage = {
        foodPackage: foodPackage,
        preferedTreat: preferedTreat,
        supplements: supplements
    };
    let trialPackage = {
        foodPackage: trialFoodPackage,
        preferedTreat: preferedTreat,
        supplements: supplements
    };
    //get quantites from api
    let response = totalPackage;
    const cartQuantites = {};
    const trialCartQuantities = {};
    /* MEALS */ //match quantites with products
    for (const product of productList){
        for (const [key, value] of Object.entries(response.foodPackage))if (product.title.toLowerCase().includes(key)) {
            cartQuantites[product.variants[0].id] = value;
            fullPrice += product.price * value;
            break;
        }
        for (const [key, value] of Object.entries(trialPackage.foodPackage))if (product.title.toLowerCase().includes(key)) {
            trialCartQuantities[product.variants[0].id] = value;
            trialPrice += product.price * value;
            break;
        }
    }
    fullPlanPrice += fullPrice;
    const mealTotalCount = Object.values(response.foodPackage).reduce((sum, value)=>sum + value, 0);
    feedingGuide = feedingGuideCalc(mealTotalCount);
    const mealFoodIncluded = Object.keys(response.foodPackage).filter((key)=>response.foodPackage[key] !== 0).join(', ');
    // Calculate half plan meals (round up if odd)
    const halfPlanMeals = Math.ceil(mealTotalCount / 2);
    // Get the allowed proteins from foodPackage
    const allowedProteins = Object.keys(response.foodPackage).filter((key)=>response.foodPackage[key] > 0);
    // Calculate half plan distribution using filterSplitAdjust
    const halfPlanSplit = filterSplitAdjust(allowedProteins, false);
    const halfPlanDistribution = mealDistribution(halfPlanSplit, halfPlanMeals);
    // Build half plan cart quantities by variant ID (same method as cartQuantites)
    const halfPlanCartQuantities = {};
    let halfPlanMealPrice = 0;
    for (const product of productList){
        for (const [key, value] of Object.entries(halfPlanDistribution))if (product.title.toLowerCase().includes(key)) {
            halfPlanCartQuantities[product.variants[0].id] = value;
            halfPlanMealPrice += product.price * value;
            break;
        }
    }
    if (trial) {
        $('.meal-portions').html(halfPlanMeals);
        $('[data-trial-meal-portions]').html(trialCartons + 'x');
    } else $('.meal-portions').html(halfPlanMeals);
    $('.meal-portions-full').html(mealTotalCount);
    $('.meal-contains').html(mealFoodIncluded);
    /* TREATS */ let prefferedTreats = preferedTreat;
    let treatsTotalPrice = 0;
    if (Object.keys(prefferedTreats).length > 0) {
        const mealFoodIncluded = Object.keys(prefferedTreats).filter((key)=>response.preferedTreat[key] !== 0).join(', ');
        for (const treat of treatsList){
            for (const [key, value] of Object.entries(prefferedTreats))if (treat.title.toLowerCase().includes(key)) {
                cartQuantites[treat.variants[0].id] = value;
                fullPrice += treat.price * value;
                fullPlanPrice += treat.price * value;
                treatsTotalPrice += treat.price * value;
                trialCartQuantities[treat.variants[0].id] = value;
                trialPrice += treat.price * value;
                // Half plan gets same treats as full plan
                halfPlanCartQuantities[treat.variants[0].id] = value;
            }
            $('.treat-contains').html(mealFoodIncluded);
            $('.treat-count').html(Object.keys(prefferedTreats).length);
            $('[data-trial-treat-count]').html(Object.keys(prefferedTreats).length + 'x');
            $('[data-trial-treat-contains]').html(mealFoodIncluded);
        }
    } else $('[data-plan-type="treats"]').hide();
    /* SUPPLEMENTS */ let supplementsCalc = response.supplements;
    let supplementsTotalPrice = 0;
    if (Object.keys(supplementsCalc).length && months >= 6) {
        for (const supplement of supplementList){
            for (const [key, value] of Object.entries(supplementsCalc))if (supplement.title.toLowerCase().includes(key)) {
                cartQuantites[supplement.variants[0].id] = value;
                fullPrice += supplement.price * value;
                fullPlanPrice += supplement.price * value;
                supplementsTotalPrice += supplement.price * value;
                trialCartQuantities[supplement.variants[0].id] = value;
                trialPrice += supplement.price * value;
                // Half plan gets same supplements as full plan
                halfPlanCartQuantities[supplement.variants[0].id] = value;
                break;
            }
        }
        const newItems = Object.entries(supplementsCalc).filter(([, value])=>value !== 0).map(([name, qty])=>`
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <rect y="0.629883" width="23.76" height="23.76" rx="11.88" fill="#E6FFD4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.88 24.3899C18.4413 24.3899 23.76 19.0712 23.76 12.5099C23.76 5.94856 18.4413 0.629883 11.88 0.629883C5.31868 0.629883 0 5.94856 0 12.5099C0 19.0712 5.31868 24.3899 11.88 24.3899ZM16.0808 8.30911C16.3038 8.08635 16.6063 7.96134 16.9215 7.96156C17.2368 7.96178 17.539 8.08723 17.7618 8.3103C17.9845 8.53338 18.1096 8.83581 18.1093 9.15106C18.1091 9.46631 17.9837 9.76856 17.7606 9.99132L11.0448 16.7071L11.0401 16.7118C10.93 16.8225 10.7991 16.9104 10.655 16.9703C10.5109 17.0303 10.3563 17.0612 10.2002 17.0612C10.0441 17.0612 9.88948 17.0303 9.74534 16.9703C9.60119 16.9104 9.47032 16.8225 9.36025 16.7118L9.3555 16.7071L5.9994 13.351C5.88593 13.2414 5.79543 13.1103 5.73317 12.9654C5.67091 12.8204 5.63813 12.6645 5.63676 12.5068C5.63539 12.3491 5.66545 12.1926 5.72518 12.0466C5.78492 11.9006 5.87313 11.768 5.98467 11.6564C6.09622 11.5449 6.22886 11.4567 6.37486 11.3969C6.52086 11.3372 6.6773 11.3071 6.83504 11.3085C6.99278 11.3099 7.14867 11.3427 7.29361 11.4049C7.43855 11.4672 7.56964 11.5577 7.67923 11.6712L10.2002 14.1909L16.0808 8.3103V8.30911Z" fill="#00592F"/>
          </svg>
          <div>${qty}x ${name} supplement</div>
        </li>
      `).join('');
        $('[data-plan-type="supplements"]')?.replaceWith(newItems);
    } else $('[data-plan-type="supplements"]').hide();
    cartObject = cartQuantites;
    cartTrialObject = trialCartQuantities;
    cartHalfObject = halfPlanCartQuantities;
    let totalPrice = fullPrice;
    let fullPriceOutput = (fullPrice / 100 / wpDays).toFixed(2);
    let discountedPriceOutput = (fullPrice / 100 / wpDays * (1 - discountCodeValue)).toFixed(2);
    let trialDiscountedPriceOutput = (trialPrice / 100 * (1 - discountCodeValue)).toFixed(2);
    totalPrice = Shopify.formatMoney(totalPrice * (1 - discountCodeValue), Shopify.money_format);
    fullPriceOutput = Shopify.formatMoney(fullPriceOutput * 100, Shopify.money_format);
    discountedPriceOutput = Shopify.formatMoney(discountedPriceOutput * 100, Shopify.money_format);
    let trialFullPriceOutput = Shopify.formatMoney(trialPrice, Shopify.money_format);
    trialDiscountedPriceOutput = Shopify.formatMoney(trialDiscountedPriceOutput * 100, Shopify.money_format);
    let volumeDiscount = 0.1; // $0-74: 10%
    //volume discounts
    if (parseInt(fullPlanPrice) >= 12000) volumeDiscount = 0.25; // $120+: 25%
    else if (parseInt(fullPlanPrice) >= 10000) volumeDiscount = 0.2; // $100-119: 20%
    else if (parseInt(fullPlanPrice) >= 7500) volumeDiscount = 0.15; // $75-99: 15%
    // let fullPlanPriceOutput = ((fullPlanPrice / 100) / wpDays).toFixed(2);
    // let discountedPlanPriceOutput = (((fullPlanPrice / 100) / wpDays) * (1 - volumeDiscount)).toFixed(2);
    let fullPlanPriceOutput = fullPlanPrice / 100;
    let discountedPlanPriceOutput = (fullPlanPrice / 100 * (1 - volumeDiscount)).toFixed(2);
    fullPlanPriceOutput = Shopify.formatMoney(fullPlanPriceOutput * 100, Shopify.money_format);
    discountedPlanPriceOutput = Shopify.formatMoney(discountedPlanPriceOutput * 100, Shopify.money_format);
    //trial plan info display
    if (trial) {
        // $('.plan-box--half .post-wizard-recommendation__info-discount').hide();
        $('.pw-trial.post-wizard-recommendation__info-discount--full-price').html(trialFullPriceOutput);
        $('.pw-trial.post-wizard-recommendation__info-discount--discounted-price').html(trialDiscountedPriceOutput);
        $('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
        $('[data-trial-box-compare-price]').html(trialFullPriceOutput);
        $('[data-trial-box-price]').html(trialDiscountedPriceOutput);
    } else {
        $('.pw-trial.post-wizard-recommendation__info-discount--full-price').html(fullPriceOutput);
        $('.pw-trial.post-wizard-recommendation__info-discount--discounted-price').html(discountedPriceOutput);
        $('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
        $('[data-trial-box-compare-price]').html(fullPriceOutput);
        $('[data-trial-box-price]').html(discountedPriceOutput);
    }
    $('[data-quiz-trial-discount]').html(discountCodeValue * 100);
    //full plan info display
    $('.pw-full.post-wizard-recommendation__info-discount--full-price').html(fullPlanPriceOutput);
    $('.pw-full.post-wizard-recommendation__info-discount--discounted-price').html(discountedPlanPriceOutput);
    $('.pw-full.post-wizard-recommendation__info-discount--discounted-percentage').html(volumeDiscount * 100);
    $('[data-quiz-plan-discount="full"], [data-quiz-plan-discount="selected"]').html(volumeDiscount * 100);
    const fullPlanPricePerDay = Shopify.formatMoney(fullPlanPrice / 28, Shopify.money_format);
    const discountedPlanPricePerDay = Shopify.formatMoney(fullPlanPrice * (1 - volumeDiscount) / 28, Shopify.money_format);
    $('[data-full-box-compare-price]').html(fullPlanPricePerDay);
    $('[data-full-box-price]').html(discountedPlanPricePerDay + '/day');
    $('[data-selected-box-compare-price]').html(fullPlanPricePerDay);
    $('[data-selected-box-price]').html(discountedPlanPricePerDay + '/day');
    // Half plan price calculation (half meals + same treats + same supplements)
    const halfPlanPrice = halfPlanMealPrice + treatsTotalPrice + supplementsTotalPrice;
    // Apply volume discount based on half plan price
    let halfVolumeDiscount = 0.1; // $0-74: 10%
    if (parseInt(halfPlanPrice) >= 12000) halfVolumeDiscount = 0.25; // $120+: 25%
    else if (parseInt(halfPlanPrice) >= 10000) halfVolumeDiscount = 0.2; // $100-119: 20%
    else if (parseInt(halfPlanPrice) >= 7500) halfVolumeDiscount = 0.15; // $75-99: 15%
    const halfPlanComparePrice = Shopify.formatMoney(halfPlanPrice, Shopify.money_format);
    const halfPlanDiscountedPrice = Shopify.formatMoney(halfPlanPrice * (1 - halfVolumeDiscount), Shopify.money_format);
    const halfPlanComparePricePerDay = Shopify.formatMoney(halfPlanPrice / 28, Shopify.money_format);
    const halfPlanDiscountedPricePerDay = Shopify.formatMoney(halfPlanPrice * (1 - halfVolumeDiscount) / 28, Shopify.money_format);
    $('[data-half-box-compare-price]').html(halfPlanComparePricePerDay);
    $('[data-half-box-price]').html(halfPlanDiscountedPricePerDay + '/day');
    $('[data-quiz-plan-discount="half"]').html(halfVolumeDiscount * 100);
    // Calculate trial box savings (compare price - discounted price)
    const trialBoxSavings = Shopify.formatMoney(trialPrice - trialPrice * (1 - discountCodeValue), Shopify.money_format);
    $('[data-trial-box-savings]').html(`-${trialBoxSavings}`);
    $('[data-trial-end-date]').html(getTrialEndDate());
    // $('.post-wizard-sticky-cta #total_price').html(totalPrice);
    // Get all elements with the class 'wizard-product-card'
    const productCards = document.querySelectorAll('.wizard-product-card');
    // Iterate over the elements and check if 'data-variant-id' is in the object
    productCards.forEach((card)=>{
        const variantId = card.getAttribute('data-variant-id');
        if (cartObject.hasOwnProperty(variantId) && cartObject[variantId] !== 0 || cartTrialObject.hasOwnProperty(variantId) && cartTrialObject[variantId] !== 0) {
            card.classList.add('is-selected');
            // Half plan box - use halfPlanCartQuantities for meals
            const halfPlanBox = card.closest('.plan-box--half .plan-box__summary-cards');
            if (halfPlanBox) {
                const mealsDetail = card.closest('[data-plan-type="meals"]');
                if (mealsDetail && halfPlanCartQuantities[variantId]) card.querySelector('span').innerHTML = halfPlanCartQuantities[variantId];
                else // For treats and supplements, use the same quantities as full plan
                card.querySelector('span').innerHTML = cartObject[variantId];
            }
            // Full plan box - use full meal quantities
            const fullPlanBox = card.closest('.plan-box--full .plan-box__summary-cards');
            if (fullPlanBox) card.querySelector('span').innerHTML = cartObject[variantId];
        }
        if (card.querySelector('.wizard-product-card__price-wrapper')) {
            let temp_price = card.dataset.price;
            card.querySelector('.wizard-product-card__price-wrapper .wizard-product-card__discounted-price').innerHTML = Shopify.formatMoney(temp_price * (1 - discountCodeValue), Shopify.money_format);
        }
    });
}
function validateEmail() {
    const emailInput = document.querySelector('input[name="owner_email"]');
    const emailValue = emailInput.value.trim();
    // Email validation regex pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailValue === "" || !emailPattern.test(emailValue)) return false; // Invalid email
    return true; // Valid email
}
document.querySelector('.final-step-flow input[name="owner_email"]').addEventListener('focus', function() {
    document.querySelector('.invalid-email').classList.remove('triggered');
});
$('.trigger-post-quiz').click(function() {
    if ($(this).hasClass('next__button') && validateEmail()) {
        //add mail to klaviyo
        if (document.querySelector('.final-step-flow input[name="mc_signup"]').checked) {
            const userEmail = document.querySelector('.final-step-flow [name="owner_email"]').value;
            const originalDogProfile = getInput();
            if (!originalDogProfile) {
                console.error('getInput() returned nothing or invalid data');
                return;
            }
            // Define the value mappings
            const activityLevelMap = {
                1: 'Pretty snoozy',
                2: 'Active',
                3: 'Explosion of energy'
            };
            const bodyTypeMap = {
                1: 'A bit skinny',
                2: 'Just paw-fect',
                3: 'A bit chonky'
            };
            const treatsPerDayMap = {
                1: 'Never',
                2: 'Sometimes',
                3: 'Pretty often'
            };
            const fussyLevelMap = {
                'Yes': 'Very fussy',
                'Between': 'A little fussy',
                'No': 'Not fussy'
            };
            console.log('originalDogProfile', originalDogProfile);
            // Create the new object with the correct Klaviyo property names and mapped values
            const klaviyoProfile = {
                dog_name: originalDogProfile.name,
                dog_gender: originalDogProfile.gender,
                dog_spayed_neutered: originalDogProfile.neutered,
                dog_breed: originalDogProfile.breed,
                dog_life_stage: (()=>{
                    const totalMonths = originalDogProfile.years * 12 + originalDogProfile.months;
                    if (totalMonths < 12) return 'Puppy';
                    if (totalMonths > 84) return 'Senior';
                    return 'Adult';
                })(),
                dog_weight_kg: originalDogProfile.weight,
                // Use the maps to get the string values
                dog_bodytype: bodyTypeMap[originalDogProfile.weightgroup],
                dog_activity_level: activityLevelMap[originalDogProfile.activity],
                dog_treats_per_day: treatsPerDayMap[originalDogProfile.treats],
                dog_fussy_level: fussyLevelMap[originalDogProfile.fussy_dog],
                dog_allergies_dislikes: originalDogProfile.allergies,
                dog_current_diet: originalDogProfile.food,
                dog_health_issues: originalDogProfile.health_issues,
                dog_treat_preference: originalDogProfile.prefered_treat
            };
            // console.log('klaviyoProfile', klaviyoProfile)
            // Subscribe Profile to List (Creates profile if needed)
            const subscribeOptions = {
                method: 'POST',
                headers: {
                    revision: '2023-06-15',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            list_id: 'XWKRtA',
                            custom_source: 'Wizard',
                            email: userEmail,
                            properties: {
                                hasPuppy: isPuppy,
                                ...klaviyoProfile
                            }
                        }
                    }
                })
            };
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=R6vSRF', subscribeOptions).then((response)=>{
                if (!response.ok) return response.json().then((err)=>Promise.reject(err));
                console.log('Step 1: Profile subscribed successfully.', subscribeOptions);
                return;
            }).then(()=>{
                // Send the 'Completed Dog Quiz' Event
                const eventOptions = {
                    method: 'POST',
                    headers: {
                        revision: '2023-06-15',
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: {
                            type: 'event',
                            attributes: {
                                properties: klaviyoProfile,
                                metric: {
                                    name: 'Completed Dog Quiz'
                                },
                                profile: {
                                    email: userEmail
                                }
                            }
                        }
                    })
                };
                return fetch('https://a.klaviyo.com/client/events/?company_id=R6vSRF', eventOptions);
            }).then((response)=>{
                if (!response.ok) return response.json().then((err)=>Promise.reject(err));
                console.log('Step 2: "Completed Dog Quiz" event sent successfully!');
            }).catch((err)=>console.error('Klaviyo API Error:', err));
        }
        let genderContainer = $('.dog-gender');
        let genderPossessive = $('.dog-gender-possessive');
        let gender = document.querySelector('input[name="gender"]:checked').value;
        genderContainer.html(gender === 'Boy' ? 'he' : 'she');
        genderPossessive.html(gender === 'Boy' ? 'his' : 'her');
        saveQuizProgress(16);
        (0, $yJ7y8.handleLoader)();
        calculateMealPlan(JSON.stringify(getInput()));
        $('.wizard-v2').hide();
        $('.post-wizard-wrapper').show();
        (0, $6uPTy.scrollToTop)();
        //for tracking purposes
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "checkout",
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 17
                    }
                }
            }
        });
        $('.wizard-page-post-extra').show();
        $('.wizard-section-post-extra').show();
        // Select the accordion tab component
        const accordionTabs = document.querySelectorAll('accordion-tab');
        accordionTabs.forEach((accordion)=>{
            // Clone the component to avoid retaining event listeners
            const newAccordion = accordion.cloneNode(true);
            const parent = accordion.parentElement;
            // Remove the original from the DOM
            parent.removeChild(accordion);
            // Append the cloned (new) component to reinitialize it
            parent.appendChild(newAccordion);
        });
    } else document.querySelector('.invalid-email').classList.add('triggered');
});
$('.edit-plan-trigger').click(function() {
    $('.post-wizard-recommendation, .wizard-page-post-extra, .post-wizard-plan-overview').hide();
    $('.post-wizard-editor, .post-wizard-sticky-cta').show();
    recalculateMeals();
    (0, $6uPTy.scrollToTop)();
});
$('[data-box-plan-label]').on('click', function(e) {
    e.preventDefault();
    const selectedPlan = e.currentTarget.dataset.boxPlanLabel;
    $('[data-selected-plan]').html(selectedPlan);
    document.querySelector(`input[name="box-plan"][value="${selectedPlan}"]`).checked = true;
    if (selectedPlan === 'full plan') {
        $('[data-selected-box-price]').html($('[data-full-box-price]').html());
        $('[data-selected-box-compare-price]').html($('[data-full-box-compare-price]').html());
        $('[data-quiz-plan-discount="selected"]').html($('[data-quiz-plan-discount="full"]').html());
    } else {
        $('[data-selected-box-price]').html($('[data-half-box-price]').html());
        $('[data-selected-box-compare-price]').html($('[data-half-box-compare-price]').html());
        $('[data-quiz-plan-discount="selected"]').html($('[data-quiz-plan-discount="half"]').html());
    }
});
$('.apply-coupon').click(function() {
    handleCoupon();
});
// Function to add items to Shopify cart
async function addItemsToCart(items, fullPlanCart, halfPlanCart, selectedPlan) {
    const addToCartURL = '/cart/add.js';
    const updateCartURL = '/cart/update.js';
    try {
        // Prepare data as an array of items
        const data = {
            'items': items.map((item)=>({
                    'id': parseInt(item.id),
                    'quantity': item.quantity,
                    'selling_plan': "8019935518",
                    'properties': {
                        '_dog_name': dogName,
                        '_dynamicBoxIndex': 0,
                        '_dynamicBoxId': "b47674e0-72a2-4bff-9c7b-4f2cc0ef47d9"
                    }
                }))
        };
        // Make POST request to add item to the cart
        await fetch(addToCartURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((response)=>response.json());
        // }
        // Determine which plan cart to store based on selection
        const selectedPlanCart = selectedPlan === 'half plan' ? halfPlanCart : fullPlanCart;
        // Step 2: Add hidden note as cart attribute
        await fetch(updateCartURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    _hidden_note: JSON.stringify(getInput()),
                    _feeding_guide: feedingGuide,
                    _dog_name: dogName,
                    _selected_plan: trial ? selectedPlan : null,
                    _full_month_plan: trial ? JSON.stringify(selectedPlanCart) : null
                }
            })
        }).then((response)=>response.json());
        // Redirect to checkout page
        if (discountCode.length) window.location.href = `/checkout?discount=${discountCode}`;
        else window.location.href = `/checkout`;
    } catch (error) {
        console.error('Error adding items to cart:', error);
    }
}
//add selected items and proceed to checkout
$('.go-to-checkout').click(function() {
    $('[data-checkout-quiz]').click();
});
// //sync weight inputs
// const weightTextInput = document.getElementById('weightTextInput');
// const weightRangeInput = document.getElementById('weightRangeInput');
// // Update text input when range slider changes
// weightRangeInput.addEventListener('input', (event) => {
//   weightTextInput.value = event.target.value;
// });
// // Update range slider when text input changes
// weightTextInput.addEventListener('input', (event) => {
//   // Ensure the text input value is within range slider's min and max
//   let value = parseFloat(event.target.value);
//   if (value < weightRangeInput.min) value = weightRangeInput.min;
//   if (value > weightRangeInput.max) value = weightRangeInput.max;
//   weightRangeInput.value = value;
// });
// function updateRangeBackground() {
//   const value = (weightRangeInput.value - weightRangeInput.min) / (weightRangeInput.max - weightRangeInput.min) * 100;
//   weightRangeInput.style.background = `linear-gradient(to right, #BFE7AD 0%, #BFE7AD ${value}%, #f3f3f3 ${value}%, #f3f3f3 100%)`;
// }
// weightRangeInput.addEventListener('input', updateRangeBackground);
// weightTextInput.addEventListener('input', updateRangeBackground);
// updateRangeBackground(); // Initialize on load
(0, $hi4SC.default)('weightTextInput', 'weightRangeInput');
function filterSplitAdjust(allowedItems, isTrial) {
    let initialSplit;
    if (!isTrial) initialSplit = {
        chicken: 0.35,
        beef: 0.3,
        lamb: 0.2,
        salmon: 0.15
    };
    else initialSplit = {
        chicken: 0.25,
        beef: 0.25,
        lamb: 0.25,
        salmon: 0.25
    };
    // Iterate over initialSplit keys and delete any that are not in allowedItems
    for(const key in initialSplit)if (!allowedItems.includes(key)) delete initialSplit[key];
    return adjustSplitPercentage(initialSplit);
}
let editCartQuantites = {};
let editTrialCartQuantites = {};
let editHalfCartQuantites = {};
function calcCartQ(data, trialData) {
    for (const product of productList){
        for (const [key, value] of Object.entries(data))if (product.title.toLowerCase().includes(key)) {
            if (trialData) editTrialCartQuantites[product.variants[0].id] = value;
            else editCartQuantites[product.variants[0].id] = value;
            break;
        }
    }
}
function calcHalfCartQ(halfPlanDist) {
    editHalfCartQuantites = {};
    for (const product of productList){
        for (const [key, value] of Object.entries(halfPlanDist))if (product.title.toLowerCase().includes(key)) {
            editHalfCartQuantites[product.variants[0].id] = value;
            break;
        }
    }
}
let newSum = 0;
function recalculateTotal() {
    newSum = 0;
    // Full plan meal count from meal-portions-full
    let fullMealCount = parseInt($('.meal-portions-full').html()) || 0;
    let halfMealCount = parseInt($('.plan-box--half .meal-portions').html()) || 0;
    let mealPrice = parseInt($('.product-grid.main-meals .wizard-product-card').data('price')) || 0;
    let fullMealsTotal = fullMealCount * mealPrice;
    let halfMealsTotal = halfMealCount * mealPrice;
    let trialMealsTotal = trialCartons * mealPrice; // Trial box is always 4 meals
    let treatsTotal = $('.product-grid.treat-meals .is-selected').length * parseInt($('.product-grid.treat-meals .wizard-product-card').data('price'));
    let supplementsTotal = $('.product-grid.supplement-meals .wizard-product-card.is-selected').toArray() // Convert jQuery object to array
    .reduce((total, el)=>total + parseInt($(el).data('price') || 0), 0);
    newSum = fullMealsTotal + treatsTotal + supplementsTotal;
    // Half plan price calculation
    let halfPlanTotal = halfMealsTotal + treatsTotal + supplementsTotal;
    // Trial box price calculation (4 meals + treats + supplements)
    let trialBoxTotal = trialMealsTotal + treatsTotal + supplementsTotal;
    let fullPrice = newSum;
    let fullPriceOutput = fullPrice / 100;
    let discountedPriceOutput = (fullPrice / 100 * (1 - discountCodeValue)).toFixed(2);
    fullPrice = Shopify.formatMoney(fullPrice * (1 - discountCodeValue), Shopify.money_format);
    fullPriceOutput = Shopify.formatMoney(fullPriceOutput * 100, Shopify.money_format);
    discountedPriceOutput = Shopify.formatMoney(discountedPriceOutput * 100, Shopify.money_format);
    // Trial box formatting
    let trialFullPriceOutput = Shopify.formatMoney(trialBoxTotal, Shopify.money_format);
    let trialDiscountedPriceOutput = Shopify.formatMoney(trialBoxTotal * (1 - discountCodeValue), Shopify.money_format);
    if (trial) {
        $('.pw-trial.post-wizard-recommendation__info-discount--full-price').html(trialFullPriceOutput);
        $('.pw-trial.post-wizard-recommendation__info-discount--discounted-price').html(trialDiscountedPriceOutput);
        $('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
    } else {
        $('.post-wizard-recommendation__info-discount--full-price').html(fullPriceOutput);
        $('.post-wizard-recommendation__info-discount--discounted-price').html(discountedPriceOutput);
        $('.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
    }
    $('[data-trial-box-compare-price]').html(trialFullPriceOutput);
    $('[data-trial-box-price]').html(trialDiscountedPriceOutput);
    // Calculate trial box savings
    const trialBoxSavings = Shopify.formatMoney(trialBoxTotal * discountCodeValue, Shopify.money_format);
    $('[data-trial-box-savings]').html(`-${trialBoxSavings}`);
    // Half plan volume discount
    let halfVolumeDiscount = 0.1; // $0-74: 10%
    if (parseInt(halfPlanTotal) >= 12000) halfVolumeDiscount = 0.25; // $120+: 25%
    else if (parseInt(halfPlanTotal) >= 10000) halfVolumeDiscount = 0.2; // $100-119: 20%
    else if (parseInt(halfPlanTotal) >= 7500) halfVolumeDiscount = 0.15; // $75-99: 15%
    const halfPlanComparePrice = Shopify.formatMoney(halfPlanTotal, Shopify.money_format);
    const halfPlanDiscountedPrice = Shopify.formatMoney(halfPlanTotal * (1 - halfVolumeDiscount), Shopify.money_format);
    $('[data-half-box-compare-price]').html(Shopify.formatMoney(halfPlanTotal / 28, Shopify.money_format));
    $('[data-half-box-price]').html(Shopify.formatMoney(halfPlanTotal * (1 - halfVolumeDiscount) / 28, Shopify.money_format) + '/day');
    // Full plan volume discount and display
    let fullVolumeDiscount = 0.1; // $0-74: 10%
    if (parseInt(newSum) >= 12000) fullVolumeDiscount = 0.25; // $120+: 25%
    else if (parseInt(newSum) >= 10000) fullVolumeDiscount = 0.2; // $100-119: 20%
    else if (parseInt(newSum) >= 7500) fullVolumeDiscount = 0.15; // $75-99: 15%
    const fullPlanComparePrice = Shopify.formatMoney(newSum, Shopify.money_format);
    const fullPlanDiscountedPrice = Shopify.formatMoney(newSum * (1 - fullVolumeDiscount), Shopify.money_format);
    const fullPlanComparePricePerDay = Shopify.formatMoney(newSum / 28, Shopify.money_format);
    const fullPlanDiscountedPricePerDay = Shopify.formatMoney(newSum * (1 - fullVolumeDiscount) / 28, Shopify.money_format);
    const halfPlanComparePricePerDay2 = Shopify.formatMoney(halfPlanTotal / 28, Shopify.money_format);
    const halfPlanDiscountedPricePerDay2 = Shopify.formatMoney(halfPlanTotal * (1 - halfVolumeDiscount) / 28, Shopify.money_format);
    $('[data-full-box-compare-price]').html(fullPlanComparePricePerDay);
    $('[data-full-box-price]').html(fullPlanDiscountedPricePerDay + '/day');
    // Update selected plan prices based on current selection
    const selectedPlan = $('input[name="box-plan"]:checked').val();
    if (selectedPlan === 'full plan') {
        $('[data-selected-box-price]').html(fullPlanDiscountedPricePerDay + '/day');
        $('[data-selected-box-compare-price]').html(fullPlanComparePricePerDay);
    } else {
        $('[data-selected-box-price]').html(halfPlanDiscountedPricePerDay2 + '/day');
        $('[data-selected-box-compare-price]').html(halfPlanComparePricePerDay2);
    }
}
function updateHalfPlanDisplay(halfPlanDist) {
    // Update meal portions total for half plan
    const totalHalfMeals = Object.values(halfPlanDist).reduce((sum, val)=>sum + val, 0);
    $('.plan-box--half .meal-portions').html(totalHalfMeals);
    // Update individual meal cards in half plan
    const halfPlanMealCards = document.querySelectorAll('.plan-box--half [data-plan-type="meals"] .wizard-product-card');
    halfPlanMealCards.forEach((card)=>{
        const foodType = card.dataset.foodType;
        const quantity = halfPlanDist[foodType] || 0;
        if (quantity > 0) {
            card.classList.add('is-selected');
            card.querySelector('span').innerHTML = quantity;
        } else card.classList.remove('is-selected');
    });
}
function recalculateMeals() {
    let currentPicks = $('.main-meals .is-selected');
    let currentSplit = [];
    let currentTrialSplit = [];
    //initial
    currentPicks.each(function() {
        currentSplit.push(this.dataset.foodType);
        currentTrialSplit.push(this.dataset.foodType);
        if ($(this).closest('.product-grid').hasClass('main-meals')) {
            currentSplit.push(this.dataset.foodType);
            currentTrialSplit.push(this.dataset.foodType);
            calcCartQ(mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons), false);
            calcCartQ(mealDistribution(filterSplitAdjust(currentTrialSplit, true), trialCartons), true);
            // Update half plan display
            const fullMealDist = mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons);
            const fullMealCount = Object.values(fullMealDist).reduce((sum, val)=>sum + val, 0);
            const halfMealCount = Math.ceil(fullMealCount / 2);
            const halfPlanDist = mealDistribution(filterSplitAdjust(currentSplit, false), halfMealCount);
            updateHalfPlanDisplay(halfPlanDist);
            calcHalfCartQ(halfPlanDist);
        }
    });
    recalculateTotal();
    //add items
    $('.wizard-product-card__info-button--add').click(function() {
        let productCard = $(this).closest('.wizard-product-card');
        productCard[0].classList.add('is-selected');
        if ($(this).closest('.product-grid').hasClass('main-meals')) {
            currentSplit.push(productCard[0].dataset.foodType);
            currentTrialSplit.push(productCard[0].dataset.foodType);
            calcCartQ(mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons), false);
            calcCartQ(mealDistribution(filterSplitAdjust(currentTrialSplit, true), trialCartons), true);
            // Update half plan display
            const fullMealDist = mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons);
            const fullMealCount = Object.values(fullMealDist).reduce((sum, val)=>sum + val, 0);
            const halfMealCount = Math.ceil(fullMealCount / 2);
            const halfPlanDist = mealDistribution(filterSplitAdjust(currentSplit, false), halfMealCount);
            updateHalfPlanDisplay(halfPlanDist);
            calcHalfCartQ(halfPlanDist);
        }
        recalculateTotal();
    });
    //remove items
    $('.wizard-product-card__info-button--remove').click(function() {
        if ($(this).closest('.product-grid').hasClass('main-meals')) {
            if ($('.main-meals .is-selected').length >= 2) {
                let productCard = $(this).closest('.wizard-product-card');
                var index = currentSplit.indexOf(productCard[0].dataset.foodType);
                if (index !== -1) {
                    currentSplit.splice(index, 1);
                    currentTrialSplit.splice(index, 1);
                }
                productCard[0].classList.remove('is-selected');
                calcCartQ(mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons), false);
                calcCartQ(mealDistribution(filterSplitAdjust(currentTrialSplit, true), trialCartons), true);
                // Update half plan display
                const fullMealDist = mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons);
                const fullMealCount = Object.values(fullMealDist).reduce((sum, val)=>sum + val, 0);
                const halfMealCount = Math.ceil(fullMealCount / 2);
                const halfPlanDist = mealDistribution(filterSplitAdjust(currentSplit, false), halfMealCount);
                updateHalfPlanDisplay(halfPlanDist);
                calcHalfCartQ(halfPlanDist);
            }
        } else {
            let productCard = $(this).closest('.wizard-product-card');
            productCard[0].classList.remove('is-selected');
        }
        recalculateTotal();
    });
}
$('[data-checkout-quiz]').click(function() {
    //get meals
    recalculateMeals();
    //get selected treats
    let treats = $('.treat-meals .is-selected');
    if (treats.length) treats.each(function(index, treat) {
        let id = treat.dataset.variantId;
        editCartQuantites[id] = 1;
        editTrialCartQuantites[id] = 1;
    });
    let supplements = $('.supplement-meals .is-selected');
    let supplementCount = 1;
    if (supplements.length) supplements.each(function(index, supplement) {
        let id = supplement.dataset.variantId;
        editCartQuantites[id] = supplementCount;
        editTrialCartQuantites[id] = supplementCount;
    });
    // Transforming the object to an array of items with id and quantity
    let itemsToAdd = Object.entries(trial ? editTrialCartQuantites : editCartQuantites).map(([id, quantity])=>({
            id: id,
            quantity: quantity
        })).filter((item)=>item.quantity > 0); // Filters out items with quantity 0
    const selectedPlan = $('input[name="box-plan"]:checked').val() || 'full plan';
    // Build half plan cart (same treats/supplements as full, but half meal quantities)
    const halfPlanEditCart = {
        ...editHalfCartQuantites
    };
    // Add treats to half plan
    treats.each(function(index, treat) {
        halfPlanEditCart[treat.dataset.variantId] = 1;
    });
    // Add supplements to half plan
    supplements.each(function(index, supplement) {
        halfPlanEditCart[supplement.dataset.variantId] = supplementCount;
    });
    addItemsToCart(itemsToAdd, editCartQuantites, halfPlanEditCart, selectedPlan);
});
//age input fields logic
document.addEventListener("DOMContentLoaded", function() {
    const ageGroupRadios = document.querySelectorAll('input[name="age_group"]');
    const inputYears = document.querySelector('input[name="years"]');
    const inputMonths = document.querySelector('input[name="months"]');
    const inputYearsContainer = document.getElementById("input_age_years");
    function toggleInputs() {
        const selectedAgeGroup = document.querySelector('input[name="age_group"]:checked').value;
        if (selectedAgeGroup === "Puppy") {
            // Show only Months input, hide Years input
            inputYearsContainer.style.display = "none";
            inputMonths.parentElement.style.display = "block";
            inputMonths.setAttribute("required", "required"); // Make Months mandatory
            inputYears.removeAttribute("required");
            inputYears.value = ""; // Clear Years input if not needed
            inputYears.dispatchEvent(new Event('change'));
        } else {
            // Show both inputs but make Years input mandatory
            inputYearsContainer.style.display = "block";
            inputMonths.parentElement.style.display = "block";
            inputYears.setAttribute("required", "required");
            inputMonths.removeAttribute("required"); // Months optional
            inputMonths.dispatchEvent(new Event('change'));
        //inputMonths.value = ""; // Clear Months input if not needed
        }
    }
    // Event listener for age group radio buttons
    ageGroupRadios.forEach((radio)=>radio.addEventListener("change", toggleInputs));
    // Initial call to set up the correct state
    toggleInputs();
});
/* Handle referral code from cookie */ jQuery(document).ready(function($1) {
    function mbGetCookie(name) {
        const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return match ? match.pop() : '';
    }
    var discountCode = mbGetCookie('discount_code');
    if (typeof discountCode != 'undefined' && discountCode != '') jQuery('#discount_code').val(discountCode);
    handleCoupon();
});
//handle breed logic
const purebredRadio = document.getElementById('purebred');
const crossbreedRadio = document.getElementById('crossbreed');
const breedInput = document.getElementById('breed__autocomplete');
// Function to handle changes in radio selection
function handleRadioChange() {
    if (purebredRadio.checked) {
        breedInput.setAttribute('required', 'required');
        breedInput.value = ''; // Clear the input for manual entry
    } else if (crossbreedRadio.checked) {
        breedInput.removeAttribute('required');
        breedInput.value = 'Pawfect mix'; // Automatically fill with default text
    }
}
// Attach event listeners to radio buttons
purebredRadio.addEventListener('change', handleRadioChange);
crossbreedRadio.addEventListener('change', handleRadioChange);
// Call the function once on page load to set initial state
handleRadioChange();
let previousQuizData = localStorage.getItem("quizAnswers");
let previouslyStarted = false;
if (previousQuizData) {
    previouslyStarted = true;
    //show notification modal    
    document.querySelector('.quiz-started-overlay').classList.add('show-modal');
}
function prepopulateQuizData(previousQuizData) {
    let currentDogData = JSON.parse(previousQuizData);
    //update spayed/neutered label by gender
    let gender = currentDogData.gender;
    if (gender) {
        let label = document.getElementById('neutered-spayed');
        let old = label.innerHTML;
        label.innerHTML = gender == 'Boy' ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
        document.querySelector(`input[name="gender"][value="${gender.charAt(0).toUpperCase() + gender.slice(1)}"]`).checked = true;
    }
    // fill quiz data values
    //name
    let name = currentDogData.name;
    if (name) {
        document.querySelector('input[data-order="name"]').value = name;
        (0, $5u17S.default)();
    }
    //age
    let months = currentDogData.months ? currentDogData.months : 0;
    let years = currentDogData.years ? currentDogData.years : 0;
    document.querySelector(`input[name="months"]`).value = months;
    document.querySelector(`input[name="years"]`).value = years;
    let totalMonths = years * 12 + months;
    if (totalMonths > 84) {
        document.querySelector(`input[name="age_group"][value="Senior"]`).checked = true;
        document.querySelector(`input[name="age_group"][value="Adult"]`).disabled = true;
        document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
    // toggleInputs();
    } else if (totalMonths < 12) document.querySelector(`input[name="age_group"][value="Puppy"]`).checked = true;
    else {
        document.querySelector(`input[name="age_group"][value="Adult"]`).checked = true;
        document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
    // toggleInputs();
    }
    //breed
    let breed = currentDogData.breed;
    if (breed != "") {
        const crossbreedRadio = document.getElementById('crossbreed');
        const purebredRadio = document.getElementById('purebred');
        let breedInput = document.querySelector('input[name="breed__autocomplete"]');
        if (breed == "Pawfect mix") {
            // If x is empty, select "crossbreed"
            crossbreedRadio.checked = true;
            breedInput.value = 'Pawfect mix'; // Clear input in case it's populated
        } else {
            // If x has a value, select "purebred" and set the input value
            purebredRadio.checked = true;
            console.log(breed);
            setTimeout(()=>{
                breedInput.value = breed;
            }, 1000);
        }
    }
    //weight
    let weight = currentDogData.weight;
    document.getElementById('weightTextInput').value = weight;
    document.getElementById('weightRangeInput').value = weight;
    (0, $hi4SC.default)('weightTextInput', 'weightRangeInput');
    //spayed/neutered
    let spayed = currentDogData.neutered;
    if (spayed) document.querySelector(`input[name="neutered"][value="${spayed}"]`).checked = true;
    //bodytype
    let weightgroup = currentDogData.weightgroup;
    if (weightgroup) document.querySelector(`input[name="weightgroup"][value="${weightgroup}"]`).checked = true;
    //activity
    let activity = currentDogData.weightgroup;
    if (activity) document.querySelector(`input[name="activity"][value="${activity}"]`).checked = true;
    //allergies
    let allergies = currentDogData.allergies;
    if (allergies.length) allergies.forEach((allergy, index)=>{
        let capitalizedText = allergy.charAt(0).toUpperCase() + allergy.slice(1);
        document.querySelector(`input[name="allergies"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
    //current diet
    let foodTypes = currentDogData.food;
    if (foodTypes.length) foodTypes.forEach((foodType, index)=>{
        let capitalizedText = foodType.charAt(0).toUpperCase() + foodType.slice(1);
        document.querySelector(`input[name="current__food"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
    //treats
    let treats = currentDogData.treats;
    if (treats) document.querySelector(`input[name="treats"][value="${treats}"]`).checked = true;
    //prefferad treats
    let prefferedTreats = currentDogData.prefered_treat;
    if (prefferedTreats.length) prefferedTreats.forEach((prefferedTreat, index)=>{
        let capitalizedText = prefferedTreat.charAt(0).toUpperCase() + prefferedTreat.slice(1);
        document.querySelector(`input[name="prefered_treat"][type="checkbox"][value="${prefferedTreat}"]`).checked = true;
    });
    //health issues
    let healthIssues = currentDogData.health_issues;
    if (healthIssues.length) healthIssues.forEach((healthIssue, index)=>{
        let capitalizedText = healthIssue.charAt(0).toUpperCase() + healthIssue.slice(1);
        document.querySelector(`input[name="health_issues"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
    //fussy dog
    let fussy = currentDogData.fussy_dog;
    if (fussy) document.querySelector(`input[name="fussy_dog"][value="${fussy}"]`).checked = true;
    if (currentDogData.step) {
        step = currentDogData.step;
        if (step >= 16) step = 15;
        let progress_steps = document.querySelectorAll('.progress__step');
        progress_steps.forEach((progress_step)=>{
            if (Number(progress_step.dataset.step) < step) {
                progress_step.classList.remove('is-active');
                progress_step.classList.add('is-complete');
            }
        });
        document.querySelector('.navigation__button.start__button').click();
    }
    let discountCode = currentDogData.discount_code;
    if (discountCode) {
        document.querySelector('#discount_code').value = discountCode;
        handleCoupon();
    }
    let customerEmail = currentDogData.customer_email;
    if (customerEmail) document.querySelector('input[name="owner_email').value = customerEmail;
    $('.apply-coupon').click();
    setTimeout(()=>{
        calculateMealPlan(JSON.stringify(getInput()));
    }, 1000);
}
function saveQuizProgress(step) {
    let existingData = localStorage.getItem("quizAnswers");
    // Parse the data if it exists, or start with an empty object
    existingData = existingData ? JSON.parse(existingData) : {};
    // Get the new input data
    let newData = getInput();
    // Add/Update the step field
    newData.step = step;
    newData.discount_code = document.querySelector('#discount_code').value;
    newData.customer_email = document.querySelector('input[name="owner_email"]').value;
    newData.accepts_newsletter = document.querySelector('input[name="mc_signup"]').checked;
    // Merge the new data into the existing data
    const updatedData = {
        ...existingData,
        ...newData
    };
    // Save the updated data back to localStorage
    localStorage.setItem("quizAnswers", JSON.stringify(updatedData));
}
document.querySelector('.continue-quiz').addEventListener('click', function() {
    emptyCartOnStart();
    let stepToProceed = JSON.parse(localStorage.getItem("quizAnswers")).step;
    prepopulateQuizData(previousQuizData);
    setTimeout(()=>{
        document.querySelector('.quiz-started-overlay').classList.remove('show-modal');
    }, 400);
});
document.querySelector('.restart-quiz').addEventListener('click', function() {
    localStorage.removeItem("quizAnswers");
    document.querySelector('.quiz-started-overlay').classList.remove('show-modal');
});
//prevent alert box on reload...
window.onbeforeunload = null;

});
parcelRegister("gpsGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf253be4facf78a4$export$2e2bcd8739ae039);
function $bf253be4facf78a4$export$2e2bcd8739ae039(text) {
    const alert = document.querySelector(".alert__container");
    var alertContent = text !== undefined ? text : 'Please fill out all fields to continue.';
    alert.innerHTML = alertContent;
    alert.style.display = "block";
    setTimeout(()=>{
        alert.style.display = "none";
    }, 4000);
}

});

parcelRegister("evzE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ff9c707d008945$export$2e2bcd8739ae039);

var $dDojH = parcelRequire("dDojH");
const $a8ff9c707d008945$var$handleChange = (event, data)=>{
    const { type: type, value: value } = event.target;
    const attribute = event.target.getAttribute("data-order");
    if (attribute === "size") data[attribute]["answer"] = (0, $dDojH.setWeightFromValue)(value);
    else if (attribute === "activity") data[attribute]["answer"] = (0, $dDojH.setActivityFromValue)(value);
    else if (attribute === "treats") data[attribute]["answer"] = (0, $dDojH.setTreatsFromValue)(value);
    else if (type.match(/^(text|radio|email|number|range)$/)) data[attribute]["answer"] = value;
    else if (type === "checkbox") {
        if (value === "Nothing") data[attribute]["answer"] = [
            value
        ];
        else {
            if (data[attribute]["answer"].indexOf(value) != -1) data[attribute]["answer"].splice(data[attribute]["answer"].indexOf(value), 1);
            else data[attribute]["answer"].push(value);
            data[attribute]["answer"] = data[attribute]["answer"].filter((item)=>item !== "Nothing");
        }
    }
};
var $a8ff9c707d008945$export$2e2bcd8739ae039 = $a8ff9c707d008945$var$handleChange;

});
parcelRegister("dDojH", function(module, exports) {

$parcel$export(module.exports, "setWeightFromValue", () => $9ed1c7ac238b01cd$export$7d7f25c62159ea33);
$parcel$export(module.exports, "setActivityFromValue", () => $9ed1c7ac238b01cd$export$8f41bc9a530ea710);
$parcel$export(module.exports, "setTreatsFromValue", () => $9ed1c7ac238b01cd$export$3ab91f0c4d924f36);
// const activitySlider = document.querySelector(
//   "input[type='range'][name='activity']"
// );
const $9ed1c7ac238b01cd$var$activityOutput = document.querySelector("label[for='activity']");
const $9ed1c7ac238b01cd$var$activityOutputDescription = document.querySelector("label.description[for='activity']");
// const weightSlider = document.querySelector(
//   "input[type='range'][name='weightgroup']"
// );
const $9ed1c7ac238b01cd$var$weightOutput = document.querySelector("label[for='weight']");
const $9ed1c7ac238b01cd$var$weightOutputDescription = document.querySelector("label.description[for='weightgroup']");
// const treatsSlider = document.querySelector(
//   "input[type='range'][name='treats']"
// );
const $9ed1c7ac238b01cd$var$treatsOutput = document.querySelector("label[for='treats']");
const $9ed1c7ac238b01cd$var$treatsOutputDescription = document.querySelector("label.description[for='treats']");
const $9ed1c7ac238b01cd$export$7d7f25c62159ea33 = (value)=>{
    let weight;
    let description;
    switch(Number(value)){
        case 1:
            weight = "A bit skinny";
            description = "Narrow waistline and you can clearly see the ribs.";
            break;
        case 2:
            weight = "Just pawfect";
            description = "Visible waistline with some fat cover but the ribs are easy to feel.";
            break;
        case 3:
            weight = "A bit chubby";
            description = "Waistline is not visible and the ribs are hard to feel.";
            break;
        default:
            weight = "Just pawfect";
            description = "Visible waistline with some fat cover but the ribs are easy to feel.";
            break;
    }
    var obj = {
        answer: weight,
        weight: weight,
        description: description
    };
    return obj;
};
const $9ed1c7ac238b01cd$export$8f41bc9a530ea710 = (value)=>{
    let activity;
    let description;
    switch(Number(value)){
        case 1:
            activity = "Pretty snoozy";
            description = "0-30 min walks per day";
            break;
        case 2:
            activity = "Active";
            description = "30-90 min walks per day";
            break;
        case 3:
            activity = "An explosion of energy";
            description = "90+ min walks per day";
            break;
        default:
            activity = "Active";
            description = "30-90 min walks per day";
            break;
    }
    var obj = {
        answer: activity,
        activity: activity,
        description: description
    };
    return obj;
};
const $9ed1c7ac238b01cd$export$3ab91f0c4d924f36 = (value)=>{
    let treats;
    let description;
    switch(Number(value)){
        case 1:
            treats = "Never";
            description = "Keeping it clean! Doesn't eat any";
            break;
        case 2:
            treats = "Sometimes";
            description = "1-3 times a day";
            break;
        case 3:
            treats = "Pretty often";
            description = "4+ times a day";
            break;
        default:
            treats = "Sometimes";
            description = "1-3 times a day";
            break;
    }
    var obj = {
        answer: treats,
        treats: treats,
        description: description
    };
    return obj;
};

});


parcelRegister("yJ7y8", function(module, exports) {

$parcel$export(module.exports, "handleLoader", () => $06862d229cd5aa1d$export$18561e5972b41578);
const $06862d229cd5aa1d$export$18561e5972b41578 = ()=>{
    const loadingContainer = document.querySelector(".loading__overlay");
    loadingContainer.style.display = "flex";
    document.body.classList.add("no-scroll");
    setTimeout(()=>{
        loadingContainer.style.display = "none";
        document.body.classList.remove("no-scroll");
    }, 2500);
};

});

parcelRegister("7wDyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $57aa33e66aea45c0$export$2e2bcd8739ae039);
const $57aa33e66aea45c0$var$progressSteps = document.querySelectorAll(".progress__step");
const $57aa33e66aea45c0$var$handleProgress = (direction, step)=>{
    if (direction === "next") {
        let prev = step - 1;
        $57aa33e66aea45c0$var$progressSteps[prev - 1].classList.remove("is-active");
        $57aa33e66aea45c0$var$progressSteps[prev - 1].classList.add("is-complete");
        $57aa33e66aea45c0$var$progressSteps[step - 1].classList.add("is-active");
    }
    if (direction === "back") {
        let prev = step + 1;
        $57aa33e66aea45c0$var$progressSteps[step - 1].classList.add("is-active");
        $57aa33e66aea45c0$var$progressSteps[step - 1].classList.remove("is-complete");
        $57aa33e66aea45c0$var$progressSteps[prev - 1].classList.remove("is-active");
    }
};
var $57aa33e66aea45c0$export$2e2bcd8739ae039 = $57aa33e66aea45c0$var$handleProgress;

});

parcelRegister("gnuw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bec67730bbe30a56$export$2e2bcd8739ae039);

var $6uPTy = parcelRequire("6uPTy");
const $bec67730bbe30a56$var$renderOrderData = (reviewButton, orderData)=>{
    const elements = Object.values(orderData).map((item)=>{
        if (Array.isArray(item.answer)) return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer.join(", ")}</p>
        </li>`;
        else if (item.answer.answer) return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer.answer}</p>
        </li>`;
        else return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer}</p>
        </li>`;
    }).join("");
    reviewButton.innerHTML = `<ul>${elements}</ul>`;
    jQuery('.review__button.close').css('display', 'block');
    (0, $6uPTy.scrollToSelector)(".review__button");
};
var $bec67730bbe30a56$export$2e2bcd8739ae039 = $bec67730bbe30a56$var$renderOrderData;

});
parcelRegister("6uPTy", function(module, exports) {

$parcel$export(module.exports, "scrollToTop", () => $4badccad2924df9b$export$f5d3771428a1f489);
$parcel$export(module.exports, "scrollToSelector", () => $4badccad2924df9b$export$8122fc39d44438ca);
const $4badccad2924df9b$export$f5d3771428a1f489 = ()=>{
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};
const $4badccad2924df9b$export$8122fc39d44438ca = (selector)=>{
    document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
    });
};

});


parcelRegister("cNsAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $95103cd9b4e1e85d$export$2e2bcd8739ae039);
const $95103cd9b4e1e85d$var$sections = document.querySelectorAll("section");
const $95103cd9b4e1e85d$var$handleSections = (step)=>{
    $95103cd9b4e1e85d$var$sections.forEach((section)=>{
        if (section.hasAttribute("data-step")) {
            if (Number(section.getAttribute("data-step")) === Number(step)) section.style.display = "block";
            else section.style.display = "none";
        }
    });
};
var $95103cd9b4e1e85d$export$2e2bcd8739ae039 = $95103cd9b4e1e85d$var$handleSections;

});


document.addEventListener("DOMContentLoaded", async function() {
    await $5bcba031375eae38$var$renderAnnouncementBarWithCustomDiscount();
});
async function $5bcba031375eae38$var$renderAnnouncementBarWithCustomDiscount() {
    const announcementBarText = document.querySelector(".announcement-bar .announcement-bar__text p");
    const announcementBarTextList = document.querySelectorAll(".announcement-bar .Marquee-tag p");
    if (!announcementBarText && !(announcementBarTextList && announcementBarTextList.length)) return;
    const coupon = await $5bcba031375eae38$var$getCoupon();
    if (coupon) {
        if (announcementBarText) {
            let content = announcementBarText.textContent;
            const updatedContent = content.replace(/\d+%/, `${coupon}%`);
            announcementBarText.textContent = updatedContent;
        } else announcementBarTextList.forEach((element)=>{
            let content = element.textContent;
            const updatedContent = content.replace(/\d+%/, `${coupon}%`);
            element.textContent = updatedContent;
        });
    }
}
function $5bcba031375eae38$var$mbGetCookie(name) {
    const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : '';
}
async function $5bcba031375eae38$var$getCoupon() {
    let discountCode = $5bcba031375eae38$var$mbGetCookie('discount_code');
    let store = Shopify.shop;
    // let store = '974fe1'; // for testing in development only
    let body = JSON.stringify(discountCode);
    body = new URLSearchParams({
        body: body
    });
    if (store && body) {
        const response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/checkCouponCode?store=${store}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: body
        });
        const data = await response.json();
        if (data && data.success) return data.success;
        else return false;
    }
}


parcelRequire("cc240");
class $694554d3e1507248$var$LoadMorePaginationButton extends HTMLElement {
    constructor(){
        super();
        this.resultsLength = 0;
        this.articleResults = [];
        this.loading = false;
        this.paginateData = JSON.parse(document.querySelector('.load-more-pagination').dataset.paginate);
        this.totalPages = this.paginateData.pages;
        this.articleLimit = this.paginateData.page_size;
        this.page = 1;
    }
    connectedCallback() {
        this.blogLoadMore = this.querySelector('[blog-load-more]');
        this.blogLoadMoreBtn = this.querySelector('[blog-load-more] button');
        this.articlesContainer = document.getElementById('blog-more-articles-list');
        this.blogLoadMoreBtn.addEventListener('click', this.loadMoreArticles.bind(this));
    }
    loadMoreArticles() {
        if (!this.loading) this.resultsLength = 0;
        this.loadNextPage();
    }
    getArticles() {
        this.blogLoadMoreBtn.classList.add('loadingState');
        this.blogLoadMoreBtn.setAttribute('disabled', 'disabled');
        this.loading = true;
        const url = this.paginateData.next.url;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        fetch(url, {
            signal: signal
        }).then((response)=>response.text()).then((html)=>{
            const dom = new DOMParser().parseFromString(html, 'text/html');
            const articles = dom.getElementsByClassName('blogs__moreArticlesItem-card');
            this.articleResults = [
                ...this.articleResults,
                ...articles
            ];
            const newPaginationData = JSON.parse(dom.querySelector('.load-more-pagination').dataset.paginate);
            this.paginateData = newPaginationData;
            this.loadNextPage();
        }).catch((error)=>{
            if (!error.message.includes('user aborted')) HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerToastMessage, document, {
                toastType: 'common-errors',
                messageType: 'error',
                message: 'Something went wrong. Please try again'
            });
            this.blogLoadMoreBtn.classList.remove('loadingState');
            this.blogLoadMoreBtn.removeAttribute('disabled');
            this.loading = false;
        });
    }
    loadNextPage() {
        const toPrint = this.articleResults.splice(0, this.articleLimit - this.resultsLength);
        toPrint.forEach((article)=>{
            this.articlesContainer.appendChild(article);
        });
        this.resultsLength += toPrint.length;
        if (this.resultsLength < this.articleLimit && this.page < this.totalPages) {
            this.getArticles(++this.page);
            return;
        } else if (this.page == this.totalPages && this.articleResults.length == 0) this.blogLoadMore.classList.add('complete');
        this.blogLoadMoreBtn.classList.remove('loadingState');
        this.blogLoadMoreBtn.removeAttribute('disabled');
        this.loading = false;
    }
}
customElements.define('load-more-pagination', $694554d3e1507248$var$LoadMorePaginationButton);


parcelRequire("05crR");
parcelRequire("j29Ib");
document.addEventListener('DOMContentLoaded', function() {
    const openButtons = document.querySelectorAll('.full-nutrition-card-popup');
    const closeButtons = document.querySelectorAll('.full-nutrition-card__close');
    let overlay = document.querySelector('.overlay') || createOverlay();
    function createOverlay() {
        const overlayElement = document.createElement('div');
        overlayElement.className = 'overlay';
        document.body.appendChild(overlayElement);
        return overlayElement;
    }
    function initializeAccordions(popup) {
        if (!popup) return;
        const accordionItems = popup.querySelectorAll('.accordion__item');
        accordionItems.forEach((item)=>{
            const summary = item.querySelector('summary');
            if (summary) summary.addEventListener('click', function(e) {
                e.preventDefault();
                accordionItems.forEach((otherItem)=>{
                    if (otherItem !== item && otherItem.hasAttribute('open')) otherItem.removeAttribute('open');
                });
                item.toggleAttribute('open');
            });
        });
    }
    function openPopup(button) {
        if (!button) return;
        const productId = button.dataset.productId;
        const targetPopup = document.getElementById(`full-nutrition-card-${productId}`);
        if (targetPopup) {
            overlay.classList.add('active');
            targetPopup.classList.add('active');
            document.body.classList.add('body-no-scroll');
            initializeAccordions(targetPopup);
        }
    }
    function closePopup() {
        const activePopup = document.querySelector('.full-nutrition-popup.active');
        if (activePopup) {
            overlay.classList.remove('active');
            activePopup.classList.remove('active');
            setTimeout(()=>{
                document.body.classList.remove('body-no-scroll');
            }, 200);
        }
    }
    if (openButtons.length > 0) openButtons.forEach((button)=>{
        button.addEventListener('click', ()=>openPopup(button));
    });
    if (closeButtons.length > 0) closeButtons.forEach((button)=>{
        button.addEventListener('click', closePopup);
    });
    if (overlay) overlay.addEventListener('click', closePopup);
});


parcelRequire("gkyam");
function $9168539475c74f83$export$2e2bcd8739ae039(text) {
    const alert = document.querySelector(".alert__container");
    var alertContent = text !== undefined ? text : 'Please fill out all fields to continue.';
    alert.innerHTML = alertContent;
    alert.style.display = "block";
    setTimeout(()=>{
        alert.style.display = "none";
    }, 4000);
}


const $2da2de3a5c531def$export$7d7f25c62159ea33 = (value)=>{
    let weight;
    let description;
    switch(Number(value)){
        case 1:
            weight = "A bit skinny";
            description = "Narrow waistline and you can clearly see the ribs.";
            break;
        case 2:
            weight = "Just pawfect";
            description = "Visible waistline with some fat cover but the ribs are easy to feel.";
            break;
        case 3:
            weight = "A bit chubby";
            description = "Waistline is not visible and the ribs are hard to feel.";
            break;
        default:
            weight = "Just pawfect";
            description = "Visible waistline with some fat cover but the ribs are easy to feel.";
            break;
    }
    var obj = {
        answer: weight,
        weight: weight,
        description: description
    };
    return obj;
};
const $2da2de3a5c531def$export$8f41bc9a530ea710 = (value)=>{
    let activity;
    let description;
    switch(Number(value)){
        case 1:
            activity = "Pretty snoozy";
            description = "0-30 min walks per day";
            break;
        case 2:
            activity = "Active";
            description = "30-90 min walks per day";
            break;
        case 3:
            activity = "An explosion of energy";
            description = "90+ min walks per day";
            break;
        default:
            activity = "Active";
            description = "30-90 min walks per day";
            break;
    }
    var obj = {
        answer: activity,
        activity: activity,
        description: description
    };
    return obj;
};
const $2da2de3a5c531def$export$3ab91f0c4d924f36 = (value)=>{
    let treats;
    let description;
    switch(Number(value)){
        case 1:
            treats = "Never";
            description = "Keeping it clean! Doesn't eat any";
            break;
        case 2:
            treats = "Sometimes";
            description = "1-3 times a day";
            break;
        case 3:
            treats = "Pretty often";
            description = "4+ times a day";
            break;
        default:
            treats = "Sometimes";
            description = "1-3 times a day";
            break;
    }
    var obj = {
        answer: treats,
        treats: treats,
        description: description
    };
    return obj;
};


const $ca04856011d7276e$var$handleChange = (event, data)=>{
    const { type: type, value: value } = event.target;
    const attribute = event.target.getAttribute("data-order");
    // console.log(`✏️ [quiz] answered "${attribute}" →`, value);
    if (attribute === "size") data[attribute]["answer"] = (0, $2da2de3a5c531def$export$7d7f25c62159ea33)(value);
    else if (attribute === "activity") data[attribute]["answer"] = (0, $2da2de3a5c531def$export$8f41bc9a530ea710)(value);
    else if (attribute === "treats") data[attribute]["answer"] = (0, $2da2de3a5c531def$export$3ab91f0c4d924f36)(value);
    else if (type.match(/^(text|radio|email|number|range)$/)) data[attribute]["answer"] = value;
    else if (type === "checkbox") {
        if (value === "Nothing") data[attribute]["answer"] = [
            value
        ];
        else {
            if (data[attribute]["answer"].indexOf(value) != -1) data[attribute]["answer"].splice(data[attribute]["answer"].indexOf(value), 1);
            else data[attribute]["answer"].push(value);
            data[attribute]["answer"] = data[attribute]["answer"].filter((item)=>item !== "Nothing");
        }
    }
// console.log(`✏️ [quiz] "${attribute}" now:`, data[attribute]["answer"]);
};
var $ca04856011d7276e$export$2e2bcd8739ae039 = $ca04856011d7276e$var$handleChange;


// Loading / "Calculating..." overlay shown after the quiz while the meal plan
// is prepared. Runs for a fixed 3s: caption swaps from the kibble jab to the
// real-food praise at the 1.5s midpoint, and the bottom progress bar animates
// 0→100% over the full duration (see .loading__progress-bar in index.scss).
//
// Returns a Promise that resolves when the overlay is done so the caller can
// await it before revealing the recommendation. `ready` lets the caller pass a
// promise for the plan calculation — the overlay holds until BOTH the 3s timer
// and `ready` have settled, so we never lift onto a half-rendered plan.
const $57b144c3a8c298c7$var$LOADING_DURATION = 4000;
const $57b144c3a8c298c7$var$CAPTION_SWAP_AT = 2000;
const $57b144c3a8c298c7$export$13eeee5b6595ff83 = (root = document)=>{
    const img = root.querySelector("[data-current-food-img]");
    const map = window.currentFoodData;
    if (!map) return;
    const answer = document.querySelector('input[name="current__food"]:checked')?.value;
    const entry = map[answer] || map.default;
    if (!entry) return;
    const fallback = map.default;
    // Captions carry authored <br> markup from the Liquid template, so they go in
    // as HTML. Empty strings are skipped so a half-filled entry keeps the copy
    // already in the markup rather than blanking the caption.
    [
        1,
        2
    ].forEach((n)=>{
        const el = root.querySelector(`[data-loading-caption-text="${n}"]`);
        if (!el) return;
        const text = entry[`caption${n}`] || fallback?.[`caption${n}`];
        if (text) el.innerHTML = text;
    });
    if (!img || !entry.src) return;
    // asset_url returns a well-formed URL even for a file that hasn't been
    // uploaded, so a missing asset shows as a broken image rather than an empty
    // src. Swap back to the default bowl if the chosen art fails to load.
    img.onerror = ()=>{
        img.onerror = null;
        if (fallback?.src && img.getAttribute("src") !== fallback.src) {
            img.setAttribute("src", fallback.src);
            if (fallback.alt) img.setAttribute("alt", fallback.alt);
        }
    };
    if (img.getAttribute("src") !== entry.src) img.setAttribute("src", entry.src);
    if (entry.alt) img.setAttribute("alt", entry.alt);
};
const $57b144c3a8c298c7$export$18561e5972b41578 = (ready = Promise.resolve())=>{
    const overlay = document.querySelector(".loading__overlay");
    if (!overlay) return Promise.resolve();
    const captionKibble = overlay.querySelector('[data-loading-caption="1"]');
    const captionFood = overlay.querySelector('[data-loading-caption="2"]');
    $57b144c3a8c298c7$export$13eeee5b6595ff83(overlay);
    // Flag the loading state on the wizard host via data-current="loading" so CSS
    // (and anything else keying off the step) can target it. Stash the real value
    // and restore it when the overlay lifts.
    const wizard = document.querySelector("quiz-wizard") || document.querySelector(".wizard-v2");
    const prevCurrent = wizard?.dataset.current;
    // Restart the progress-bar animation on every run (reflow resets it).
    const bar = overlay.querySelector(".loading__progress-bar");
    if (bar) {
        bar.style.animation = "none";
        bar.offsetWidth; // force reflow
        bar.style.animation = "";
    }
    overlay.style.display = "flex";
    document.body.classList.add("no-scroll", "is-loading-plan");
    if (wizard) wizard.dataset.current = "loading";
    // Beat 1 → Beat 2 caption swap at the midpoint.
    captionKibble?.classList.add("is-visible");
    captionFood?.classList.remove("is-visible");
    const swapTimer = setTimeout(()=>{
        captionKibble?.classList.remove("is-visible");
        captionFood?.classList.add("is-visible");
    }, $57b144c3a8c298c7$var$CAPTION_SWAP_AT);
    const timer = new Promise((resolve)=>setTimeout(resolve, $57b144c3a8c298c7$var$LOADING_DURATION));
    return Promise.all([
        timer,
        Promise.resolve(ready).catch(()=>{})
    ]).then(()=>{
        clearTimeout(swapTimer);
        overlay.style.display = "none";
        document.body.classList.remove("no-scroll", "is-loading-plan");
        captionKibble?.classList.remove("is-visible");
        captionFood?.classList.remove("is-visible");
        if (wizard) wizard.dataset.current = prevCurrent ?? "";
    });
};


const $b1e6f5baf0910991$var$progressSteps = document.querySelectorAll(".progress__step");
const $b1e6f5baf0910991$var$handleProgress = (direction, step)=>{
    if (direction === "next") {
        let prev = step - 1;
        $b1e6f5baf0910991$var$progressSteps[prev - 1]?.classList.remove("is-active");
        $b1e6f5baf0910991$var$progressSteps[prev - 1]?.classList.add("is-complete");
        $b1e6f5baf0910991$var$progressSteps[step - 1]?.classList.add("is-active");
    }
    if (direction === "back") {
        let prev = step + 1;
        $b1e6f5baf0910991$var$progressSteps[step - 1]?.classList.add("is-active");
        $b1e6f5baf0910991$var$progressSteps[step - 1]?.classList.remove("is-complete");
        $b1e6f5baf0910991$var$progressSteps[prev - 1]?.classList.remove("is-active");
    }
};
var $b1e6f5baf0910991$export$2e2bcd8739ae039 = $b1e6f5baf0910991$var$handleProgress;


const $99c4775dc0c46940$export$f5d3771428a1f489 = ()=>{
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};
const $99c4775dc0c46940$export$8122fc39d44438ca = (selector)=>{
    document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
    });
};


const $871ee486fa4a0036$var$renderOrderData = (reviewButton, orderData)=>{
    const elements = Object.values(orderData).map((item)=>{
        if (Array.isArray(item.answer)) return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer.join(", ")}</p>
        </li>`;
        else if (item.answer.answer) return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer.answer}</p>
        </li>`;
        else return `<li>
          <p>${item.question.replace("Marley", orderData["name"]["answer"])}</p>
          <p>${item.answer}</p>
        </li>`;
    }).join("");
    reviewButton.innerHTML = `<ul>${elements}</ul>`;
    const closeBtn = document.querySelector('.review__button.close');
    if (closeBtn) closeBtn.style.display = 'block';
    (0, $99c4775dc0c46940$export$8122fc39d44438ca)(".review__button");
};
var $871ee486fa4a0036$export$2e2bcd8739ae039 = $871ee486fa4a0036$var$renderOrderData;



const $3105107e16cbe8b2$var$sections = document.querySelectorAll("section");
const $3105107e16cbe8b2$var$handleSections = (step)=>{
    $3105107e16cbe8b2$var$sections.forEach((section)=>{
        if (section.hasAttribute("data-step")) {
            if (Number(section.getAttribute("data-step")) === Number(step)) section.style.display = "block";
            else section.style.display = "none";
        }
    });
};
var $3105107e16cbe8b2$export$2e2bcd8739ae039 = $3105107e16cbe8b2$var$handleSections;


function $fef978881a8614e2$var$updateName(dogName) {
    const dog = dogName || document.querySelector('input[name="dog_name"]').value;
    if (dog) {
        document.querySelectorAll('[data-dog-name]').forEach((el)=>{
            const isPossessive = el.dataset.dogName === 'possessive';
            el.textContent = isPossessive ? `${dog}'s` : dog;
        });
        const dogNameEl = document.querySelector('#package-selector span.dogname');
        if (dogNameEl) dogNameEl.textContent = dog;
    }
}
var $fef978881a8614e2$export$2e2bcd8739ae039 = $fef978881a8614e2$var$updateName;


// weightSync.js
function $4ef9feb833444326$var$syncWeightInputs(weightTextId, weightRangeId) {
    const weightTextInput = document.getElementById(weightTextId);
    const weightRangeInput = document.getElementById(weightRangeId);
    // Update text input when range slider changes
    weightRangeInput.addEventListener('input', (event)=>{
        weightTextInput.value = event.target.value;
    });
    // Update range slider when text input changes
    weightTextInput.addEventListener('change', (event)=>{
        // Ensure the text input value is within range slider's min and max
        const min = parseFloat(weightRangeInput.min);
        const max = parseFloat(weightRangeInput.max);
        let value = parseFloat(event.target.value);
        // Empty / non-numeric → fall back to the minimum (no 0kg allowed)
        if (isNaN(value) || value < min) value = min;
        if (value > max) value = max;
        // Force the clamped value back into the manual entry field too
        weightTextInput.value = value;
        weightRangeInput.value = value;
        updateRangeBackground();
    });
    // Update the background gradient of the range slider
    function updateRangeBackground() {
        const value = (weightRangeInput.value - weightRangeInput.min) / (weightRangeInput.max - weightRangeInput.min) * 100;
        weightRangeInput.style.background = `linear-gradient(to right, #BFE7AD 0%, #BFE7AD ${value}%, #f3f3f3 ${value}%, #f3f3f3 100%)`;
    }
    // Add background update listeners
    weightRangeInput.addEventListener('input', updateRangeBackground);
    weightTextInput.addEventListener('input', updateRangeBackground);
    updateRangeBackground(); // Initialize on load
}
var $4ef9feb833444326$export$2e2bcd8739ae039 = $4ef9feb833444326$var$syncWeightInputs;


class $6373543018ca4811$var$QuizWizard extends HTMLElement {
    // Default protein splits
    static FULL_SPLIT = {
        chicken: 0.35,
        beef: 0.3,
        lamb: 0.2,
        salmon: 0.15
    };
    static TRIAL_SPLIT = {
        chicken: 0.25,
        beef: 0.25,
        lamb: 0.25,
        salmon: 0.25
    };
    connectedCallback() {
        console.log('quiz v2', true);
        // State
        this.step = 1;
        // Last step = highest data-step in the form (computed so reordering/adding
        // steps doesn't require touching hard-coded step numbers).
        this.lastStep = Math.max(1, ...Array.from(this.querySelectorAll('section[data-step]')).map((s)=>Number(s.dataset.step) || 0));
        this.dogName = 'Marley';
        this.isPuppy = true;
        this.trialCartons = 4;
        this.trialDays = 14;
        this.wpDays = 28;
        this.discountCodeValue = 0;
        this.discountCode = '';
        this.monthlyCartons = 0;
        this.feedingGuide = null;
        this.cartQuantities = {};
        this.trialCartQuantities = {};
        this.halfPlanCartQuantities = {};
        this.orderData = {
            name: {
                question: "Your dogs name is",
                answer: ""
            },
            breed: {
                question: "Marley's breed is a",
                answer: ""
            },
            gender: {
                question: "Marley is a",
                answer: ""
            },
            neutered: {
                question: "Is Marley Neutered",
                answer: ""
            },
            years: {
                question: "How old is Marley in years",
                answer: ""
            },
            months: {
                question: "How old is Marley in months",
                answer: ""
            },
            weight: {
                question: "Marley weights approximately",
                answer: ""
            },
            size: {
                question: "Marley is",
                answer: "Normal weight"
            },
            activity: {
                question: "Marley is",
                answer: "Normal activity"
            },
            allergies: {
                question: "Marley is allergic to",
                answer: []
            },
            treats: {
                question: "Marley gets treats",
                answer: "Sometimes"
            },
            eating: {
                question: "Marley is currently eating",
                answer: []
            },
            eating_brand: {
                question: "Marley's current food brand is",
                answer: ""
            },
            hasconditions: {
                question: "Does Marley have any medical conditions?",
                answer: ""
            },
            condition: {
                question: "Marley's medical conditions",
                answer: []
            },
            thrive: {
                question: "What we want Marley to thrive at",
                answer: ""
            },
            food_issues: {
                question: "Marley's current food issue",
                answer: ""
            },
            other_food_issue: {
                question: "Other food issue",
                answer: ""
            },
            health_issues: {
                question: "Health issues",
                answer: []
            },
            fussy_dog: {
                question: "Is Marley a real fussy dog?",
                answer: ""
            },
            prefered_treat: {
                question: "Prefered treat",
                answer: []
            },
            plan: {
                question: "Marley's plan",
                answer: "",
                contents: ""
            },
            owner_name: {
                question: "Your name",
                answer: ""
            },
            owner_email: {
                question: "Your email",
                answer: ""
            },
            owner_mobile: {
                question: "Mobile",
                answer: ""
            }
        };
        // Button refs
        this.nextButton = this.querySelector('.next__button');
        this.startButton = this.querySelector('.start__button');
        this.checkoutButton = this.querySelector('.checkout__button');
        this.skipButton = this.querySelector('.skip__button');
        this.reviewButton = this.querySelector('.review__button');
        // Show the true question total in the header counter (step 1 is the intro)
        const totalStepsEl = this.querySelector('[data-total-steps]');
        if (totalStepsEl) totalStepsEl.textContent = this.lastStep - 1;
        this._initListeners();
        this._initAgeToggle();
        this._initBreedLogic();
        this._initCheckboxExclusives();
        this._initConditionsToggle();
        this._initThriveCallout();
        this._initAutocomplete();
        this._initResumeFlow();
        window.onbeforeunload = ()=>true;
        this._checkoutFlow(1);
    }
    disconnectedCallback() {
        window.onbeforeunload = null;
    }
    // ─── Listeners ───────────────────────────────────────────────────────────────
    _initListeners() {
        // Order data tracking
        this.querySelectorAll('[data-order]').forEach((input)=>{
            input.addEventListener('change', (event)=>{
                (0, $ca04856011d7276e$export$2e2bcd8739ae039)(event, this.orderData);
                this._renderPayloadDebug(); // TESTING ONLY — live payload preview
            });
        });
        // TESTING ONLY — copy the debug payload JSON to the clipboard.
        this.querySelector('[data-quiz-payload-copy]')?.addEventListener('click', async (e)=>{
            const btn = e.currentTarget;
            const json = this.querySelector('[data-quiz-payload-debug] code')?.textContent || '';
            try {
                await navigator.clipboard.writeText(json);
                const original = btn.textContent;
                btn.textContent = 'Copied!';
                setTimeout(()=>{
                    btn.textContent = original;
                }, 1500);
            } catch (err) {
                btn.textContent = 'Copy failed';
            }
        });
        // Navigation buttons
        this.nextButton?.addEventListener('click', ()=>{
            this._handleSteps();
        });
        this.startButton?.addEventListener('click', ()=>{
            this._handleSteps();
            this._emptyCartOnStart();
        });
        this.checkoutButton?.addEventListener('click', ()=>{
            this._handleSteps();
        });
        this.skipButton?.addEventListener('click', ()=>{
            this._handleSteps();
        });
        // Quiz header back link
        this.querySelector('.quiz-header__back')?.addEventListener('click', ()=>{
            if (this.step === 1) {
                window.onbeforeunload = null;
                window.location.href = '/';
                return;
            }
            this._navigate('back');
        });
        // Review panel
        this.reviewButton?.addEventListener('click', ()=>{
            (0, $871ee486fa4a0036$export$2e2bcd8739ae039)(this.reviewButton, this.orderData);
        });
        this.querySelector('.review__button.close')?.addEventListener('click', ()=>{
            this.reviewButton.innerHTML = 'Review your choices';
            this.querySelector('.review__button.close').style.display = 'none';
        });
        // Enter key navigation
        document.addEventListener('keydown', this._boundKeydown = (e)=>{
            if (e.keyCode === 13) {
                e.preventDefault();
                document.querySelectorAll('input[type=text], textarea').forEach((el)=>el.blur());
                if (this.dataset.current == this.lastStep) this.querySelector('.next__button.trigger-post-quiz')?.click();
                else this.querySelector('.next__button:not(.trigger-post-quiz)')?.click();
            }
        });
        // "Another dog" toggle
        this.querySelector('.wizard__another_dog h3')?.addEventListener('click', (e)=>{
            e.preventDefault();
            const info = this.querySelector('.wizard__another_dog div.another_dog_info');
            if (info) info.style.display = info.style.display === 'none' ? 'block' : 'none';
        });
        this.querySelector('.another_dog_info__close')?.addEventListener('click', ()=>{
            const info = this.querySelector('.wizard__another_dog div.another_dog_info');
            if (info) info.style.display = 'none';
        });
        // Puppy modal listeners (age inputs)
        const yearsInput = this.querySelector('input[data-order="years"]');
        const monthsInput = this.querySelector('input[data-order="months"]');
        const getAgeMonths = ()=>Number(yearsInput?.value) * 12 + Number(monthsInput?.value || 0);
        yearsInput?.addEventListener('input', ()=>this._puppyModalHelper(getAgeMonths()));
        monthsInput?.addEventListener('input', ()=>this._puppyModalHelper(getAgeMonths()));
        // Gender → neutered/spayed label swap
        this.querySelectorAll('input[type="radio"][name="gender"]').forEach((radio)=>{
            radio.addEventListener('change', ()=>{
                const selection = this.querySelector('input[type="radio"][name="gender"]:checked')?.value;
                const label = document.getElementById('neutered-spayed');
                const old = label?.innerHTML || '';
                if (label) label.innerHTML = selection === 'Boy' ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
                // Document-scoped: gender spans also live on the plan / add-ons pages,
                // which render outside the <quiz-wizard> element.
                document.querySelectorAll('.gender-update').forEach((el)=>{
                    el.textContent = selection === 'Boy' ? 'he' : 'she';
                });
                document.querySelectorAll('.gender-update-possessive').forEach((el)=>{
                    el.textContent = selection === 'Boy' ? 'his' : 'her';
                });
                const neuteredContainer = document.getElementById('neutered-spayed-container');
                if (neuteredContainer) neuteredContainer.style.display = 'block';
            });
        });
        // Limit modal close
        const limitModal = this.querySelector('.limit-modal');
        limitModal?.querySelector('.close')?.addEventListener('click', ()=>{
            limitModal.style.display = 'none';
        });
        // Email input focus (clear invalid state)
        this.querySelector('.final-step-flow input[name="owner_email"]')?.addEventListener('focus', ()=>{
            this.querySelector('.invalid-email')?.classList.remove('triggered');
        });
        // Final step → post-wizard transition
        this.querySelector('.trigger-post-quiz')?.addEventListener('click', (e)=>{
            if (e.currentTarget.classList.contains('next__button') && this._validateEmail()) {
                this._submitToKlaviyo();
                const gender = this.querySelector('input[name="gender"]:checked')?.value;
                this.querySelectorAll('.dog-gender').forEach((el)=>{
                    el.innerHTML = gender === 'Boy' ? 'he' : 'she';
                });
                this.querySelectorAll('.dog-gender-possessive').forEach((el)=>{
                    el.innerHTML = gender === 'Boy' ? 'his' : 'her';
                });
                // Refresh gender spans on the (soon-to-be-revealed) plan / add-ons pages.
                document.querySelectorAll('.gender-update').forEach((el)=>{
                    el.textContent = gender === 'Boy' ? 'he' : 'she';
                });
                document.querySelectorAll('.gender-update-possessive').forEach((el)=>{
                    el.textContent = gender === 'Boy' ? 'his' : 'her';
                });
                this.dogName = this._qiv('dog_name') || this.dogName;
                (0, $fef978881a8614e2$export$2e2bcd8739ae039)(this.dogName);
                this.saveProgress(this.lastStep);
                // The plan calc + AI plan content fetch normally already kicked off
                // when the user reached this step — either via the step-18 "Next"
                // click (_handleSteps) or, on a refresh landing here directly, via
                // _prepopulate — so the AI call has had the whole email step's dwell
                // time to resolve. Fall back to starting both fresh here in case
                // neither ran. _calculateMealPlan is synchronous today, but wrapped
                // so handleLoader's async-safety gate still holds if it ever becomes
                // async — the overlay won't lift onto a half-rendered recommendation.
                // planReady only ever represents the (fast) plan calc, never the AI
                // fetch, so a slow AI response can never hold up the overlay.
                const planReady = this._planReadyPromise || Promise.resolve().then(()=>this._calculateMealPlan(JSON.stringify(this._getInput())));
                if (!this._planReadyPromise) planReady.then(()=>this._loadPlanContent());
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'checkout',
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: 17
                            }
                        }
                    }
                });
                // Show the "Calculating..." overlay for 3s (or until the plan is ready,
                // whichever is longer), then reveal the recommendation underneath it.
                (0, $57b144c3a8c298c7$export$18561e5972b41578)(planReady).then(()=>{
                    const wizardEl = this.querySelector('.wizard-v2') || this;
                    wizardEl.style.display = 'none';
                    document.querySelector('.post-wizard-wrapper').style.display = 'block';
                    (0, $99c4775dc0c46940$export$f5d3771428a1f489)();
                    document.querySelector('.wizard-page-post-extra')?.style && (document.querySelector('.wizard-page-post-extra').style.display = 'block');
                    document.querySelector('.wizard-section-post-extra')?.style && (document.querySelector('.wizard-section-post-extra').style.display = 'block');
                    // Re-initialize accordion tabs to reset event listeners
                    document.querySelectorAll('accordion-tab').forEach((accordion)=>{
                        const clone = accordion.cloneNode(true);
                        accordion.parentElement.replaceChild(clone, accordion);
                    });
                });
            } else this.querySelector('.invalid-email')?.classList.add('triggered');
        });
        // Results-page header back — inverse of the reveal above: hide the plan
        // screen and return to the quiz's final step.
        document.querySelector('.post-wizard-header__back')?.addEventListener('click', ()=>{
            const wrapper = document.querySelector('.post-wizard-wrapper');
            if (wrapper) wrapper.style.display = '';
            document.querySelectorAll('.wizard-page-post-extra, .wizard-section-post-extra').forEach((el)=>{
                el.style.display = '';
            });
            const wizardEl = this.querySelector('.wizard-v2') || this;
            wizardEl.style.display = '';
            (0, $99c4775dc0c46940$export$f5d3771428a1f489)();
        });
        // Recipe steppers / add-on cards (delegated — both rendered later). Any
        // [data-recipe-step] button resolves its group/key from the nearest
        // ancestor carrying data-recipe-group (a plan row or an add-on card).
        const stepHandler = (e)=>{
            const btn = e.target.closest('[data-recipe-step]');
            if (!btn) return;
            const host = btn.closest('[data-recipe-group]');
            if (!host) return;
            this._stepRecipe(host.dataset.recipeGroup, host.dataset.recipeKey, Number(btn.dataset.recipeStep));
        };
        document.querySelector('.psp-box-card__items')?.addEventListener('click', stepHandler);
        document.querySelector('.post-wizard-addons')?.addEventListener('click', stepHandler);
        // Plan box selector (trial/full/half)
        document.querySelectorAll('[data-box-plan-label]').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                const selectedPlan = e.currentTarget.dataset.boxPlanLabel;
                document.querySelectorAll('[data-selected-plan]').forEach((sp)=>{
                    sp.innerHTML = selectedPlan;
                });
                const planInput = document.querySelector(`input[name="box-plan"][value="${selectedPlan}"]`);
                if (planInput) planInput.checked = true;
                if (selectedPlan === 'full plan') {
                    document.querySelectorAll('[data-selected-box-price]').forEach((el)=>{
                        el.innerHTML = document.querySelector('[data-full-box-price]')?.innerHTML || '';
                    });
                    document.querySelectorAll('[data-selected-box-compare-price]').forEach((el)=>{
                        el.innerHTML = document.querySelector('[data-full-box-compare-price]')?.innerHTML || '';
                    });
                    document.querySelectorAll('[data-quiz-plan-discount="selected"]').forEach((el)=>{
                        el.innerHTML = document.querySelector('[data-quiz-plan-discount="full"]')?.innerHTML || '';
                    });
                } else {
                    document.querySelectorAll('[data-selected-box-price]').forEach((el)=>{
                        el.innerHTML = document.querySelector('[data-half-box-price]')?.innerHTML || '';
                    });
                    document.querySelectorAll('[data-selected-box-compare-price]').forEach((el)=>{
                        el.innerHTML = document.querySelector('[data-half-box-compare-price]')?.innerHTML || '';
                    });
                    document.querySelectorAll('[data-quiz-plan-discount="selected"]').forEach((el)=>{
                        el.innerHTML = document.querySelector('[data-quiz-plan-discount="half"]')?.innerHTML || '';
                    });
                }
            });
        });
        // Plan screen "Continue" → advance to the add-ons step (not checkout).
        document.querySelector('[data-goto-addons]')?.addEventListener('click', ()=>{
            // Guard against advancing while the starter box is below the meal minimum.
            if (this.starterBoxValid === false) return;
            document.querySelector('.post-wizard-wrapper').style.display = 'none';
            document.querySelector('.post-wizard-addons-wrapper').style.display = 'block';
            (0, $99c4775dc0c46940$export$f5d3771428a1f489)();
        });
        // Add-ons back → return to the plan overview.
        document.querySelector('[data-addons-back]')?.addEventListener('click', ()=>{
            document.querySelector('.post-wizard-addons-wrapper').style.display = 'none';
            document.querySelector('.post-wizard-wrapper').style.display = 'block';
            (0, $99c4775dc0c46940$export$f5d3771428a1f489)();
        });
        // Add-ons "Continue to checkout" → add items to cart and redirect.
        document.querySelector('[data-checkout-quiz]')?.addEventListener('click', ()=>{
            const itemsToAdd = Object.entries(this.trialCartQuantities).map(([id, quantity])=>({
                    id: id,
                    quantity: quantity
                })).filter((item)=>item.quantity > 0);
            const selectedPlan = document.querySelector('input[name="box-plan"]:checked')?.value || 'full plan';
            this._addItemsToCart(itemsToAdd, this.cartQuantities, this.halfPlanCartQuantities, selectedPlan);
        });
        // Quiz resume / restart
        this.querySelector('.continue-quiz')?.addEventListener('click', ()=>{
            this._emptyCartOnStart();
            this._prepopulate(localStorage.getItem('quizAnswers-v2'));
            setTimeout(()=>{
                this.querySelector('.quiz-started-overlay')?.classList.remove('show-modal');
            }, 400);
        });
        this.querySelector('.restart-quiz')?.addEventListener('click', ()=>{
            localStorage.removeItem('quizAnswers-v2');
            this.querySelector('.quiz-started-overlay')?.classList.remove('show-modal');
        });
        // Weight inputs sync
        (0, $4ef9feb833444326$export$2e2bcd8739ae039)('weightTextInput', 'weightRangeInput');
        // Discount code entry on the final quiz step
        this.querySelector('#have_discount')?.addEventListener('click', ()=>{
            this.querySelector('.discount-input-wrapper')?.classList.toggle('active');
        });
        this.querySelector('.apply-coupon')?.addEventListener('click', ()=>{
            const code = this.querySelector('input[name="discount"]')?.value.trim() || '';
            if (code.length < 3) {
                const statusEl = document.querySelector('.coupon-status');
                statusEl?.classList.remove('coupon-status--active');
                statusEl?.classList.add('coupon-status--error');
                return;
            }
            this._handleCoupon(code);
        });
        // Coupon on load: a cookie code (from a /discount/CODE link) wins over the
        // default code the section prefills into the field; auto-apply either one.
        // If the cookie code is rejected, fall back to the default code so a stale
        // cookie can't silently cost the customer the standing offer.
        const cookieCode = this._getCookie('discount_code');
        const discountInput = this.querySelector('input[name="discount"]');
        const defaultCode = discountInput?.value.trim() || '';
        if (cookieCode && discountInput) discountInput.value = cookieCode;
        const initialCode = cookieCode || defaultCode;
        if (initialCode) this._handleCoupon(initialCode, defaultCode);
    }
    // ─── Navigation ──────────────────────────────────────────────────────────────
    _navigate(click) {
        this.step = click === 'back' ? this.step - 1 : this.step + 1;
        const counter = document.querySelector('.progress__counter span');
        if (counter) counter.innerHTML = this.step - 1;
        const progressBar = this.querySelector('.quiz-header__progress-bar');
        if (progressBar) progressBar.style.width = `${this.step / this.lastStep * 100}%`;
        const headerBack = this.querySelector('.quiz-header__back');
        headerBack?.classList.toggle('disabled', this.step === 1);
        this.dogName = this._qiv('dog_name') || this.dogName;
        (0, $fef978881a8614e2$export$2e2bcd8739ae039)(this.dogName);
        (0, $b1e6f5baf0910991$export$2e2bcd8739ae039)(click, this.step);
        (0, $3105107e16cbe8b2$export$2e2bcd8739ae039)(this.step);
        (0, $99c4775dc0c46940$export$f5d3771428a1f489)();
        this.dataset.current = this.step;
        if (this.step === 1) this._checkoutFlow(1);
    }
    _handleSteps() {
        const next = this.step + 1;
        if (this.step > 1) this.saveProgress(this.step);
        if (next === 2) {
            if (this._validate(this.step)) {
                this._navigate('next');
                this.nextButton?.classList.remove('disabled');
                this._checkoutFlow(next);
            }
        } else if (next >= 3 && next < this.lastStep) {
            if (this._validate(this.step)) {
                this._navigate('next');
                this._checkoutFlow(next);
            }
        } else if (next === this.lastStep) {
            if (this._validate(this.step)) {
                this._navigate('next');
                this._checkoutFlow(next);
                // Record that the final step was reached so a reload resumes here, not
                // back on the last question. (saveProgress above ran with the prior step.)
                this.saveProgress(this.step);
                // Pick the Trustpilot review that fits the user's answers
                this._updateTrustpilotQuote();
                // Swap the loading-overlay bowl art now, while the user is on the
                // email step, so the image is already fetched by the time the overlay
                // shows. Doing it in handleLoader started the download too late.
                (0, $57b144c3a8c298c7$export$13eeee5b6595ff83)();
                // Kick off the plan calc + AI plan content fetch as soon as the user
                // lands on the email step (rather than waiting for the final submit)
                // so the AI content has the whole email step's dwell time to resolve.
                // Stashed on `this` so the trigger-post-quiz handler can reuse it.
                this._planReadyPromise = Promise.resolve().then(()=>this._calculateMealPlan(JSON.stringify(this._getInput())));
                this._planReadyPromise.then(()=>this._loadPlanContent());
            }
            const data = this._getInput();
            console.log("\uD83D\uDC15 Quiz completed - User choices:", data);
            const { MER: MER, monthlyCartons: monthlyCartons } = this._calculateCalories(data);
            this.monthlyCartons = monthlyCartons;
        }
        this.dataset.current = this.step;
    }
    // ─── Validation ──────────────────────────────────────────────────────────────
    _validate(target) {
        let errors = false;
        let customError = false;
        // Reset label styling
        document.querySelectorAll(`section[data-step="${target}"] label`).forEach((label)=>{
            label.style.color = '#0f4632';
        });
        // Validate required text inputs
        const invalidInputs = document.querySelectorAll(`section[data-step="${target}"] input[required]:invalid`);
        if (invalidInputs.length > 0) {
            invalidInputs.forEach((input)=>{
                const label = document.querySelector(`label[for="${input.name}"]`);
                if (label) label.style.color = '#ac2227';
            });
            errors = true;
        }
        // Validate radio groups
        document.querySelectorAll(`section[data-step="${target}"] .radio__select`).forEach((group)=>{
            if (!group.querySelector('input[type="radio"]:checked')) {
                const label = group.previousElementSibling;
                if (label?.tagName === 'LABEL') label.style.color = '#ac2227';
                errors = true;
            }
        });
        // Validate checkbox groups
        document.querySelectorAll(`section[data-step="${target}"] .multiselect__container`).forEach((group)=>{
            // Skip hidden groups (e.g. the conditions list when "No health conditions" is picked)
            if (group.offsetParent === null) return;
            const checked = group.querySelectorAll('input[type="checkbox"]:checked');
            if (checked.length === 0) {
                const label = group.previousElementSibling;
                if (label?.tagName === 'LABEL') label.style.color = '#ac2227';
                errors = true;
            }
            if (group.dataset.contains === 'allergies' && checked.length === 4) {
                const label = group.previousElementSibling;
                if (label?.tagName === 'LABEL') label.style.color = '#ac2227';
                errors = true;
                customError = `Oh no! Looks like ${this.orderData.name.answer} is allergic to all variants. Please get in touch if you have any questions`;
            }
        });
        document.querySelectorAll(`section[data-step="${target}"] .health__container`).forEach((group)=>{
            if (!group.querySelector('input[type="checkbox"]:checked')) {
                const label = group.previousElementSibling;
                if (label?.tagName === 'LABEL') label.style.color = '#ac2227';
                errors = true;
            }
        });
        // Weight step — must be at least 1kg (no 0kg dogs)
        if (Number(target) === 7) {
            const weight = parseFloat(document.querySelector('input[name="weight"]')?.value);
            if (isNaN(weight) || weight < 1) {
                errors = true;
                customError = `Please enter ${this.orderData.name.answer || 'your dog'}'s weight (at least 1kg).`;
            }
        }
        if (errors) {
            (0, $9168539475c74f83$export$2e2bcd8739ae039)(customError || undefined);
            return false;
        }
        return true;
    }
    _validateEmail() {
        const emailInput = document.querySelector('input[name="owner_email"]');
        const emailValue = emailInput?.value.trim() || '';
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue);
    }
    // ─── Pure Calculation ────────────────────────────────────────────────────────
    _calculateCalories(input) {
        const months = parseInt(input.years || 0) * 12 + parseInt(input.months || 0);
        const neutered = this._sanitizeBoolean(input.neutered ?? '');
        let multiplier;
        if (months < 6) multiplier = 1.8;
        else if (months < 9) multiplier = 1.6;
        else if (months < 12) multiplier = 1.4;
        else multiplier = 1.2;
        if (months >= 12) {
            if (input.activity < 2) multiplier -= 0.1;
            if (input.activity > 2) multiplier += 0.1;
        }
        if (months < 12) {
            if (input.weightgroup < 2) multiplier *= 1.1;
        } else {
            if (input.weightgroup < 2) multiplier *= 1.1;
            if (input.weightgroup > 2) multiplier *= 0.9;
        }
        if (neutered && months >= 6) multiplier *= 0.9;
        const treatsFactor = 1 - (input.treats - 1) * 0.05;
        const RER = 70 * Math.pow(input.weight, 0.75);
        const MER = RER * multiplier * treatsFactor;
        const dailyDinings = Math.round(MER / 125);
        const dailyCartons = dailyDinings / 4;
        const monthlyCartons = dailyCartons * this.wpDays;
        return {
            MER: MER,
            monthlyCartons: monthlyCartons,
            months: months,
            neutered: neutered
        };
    }
    _getMealDistribution(split, cartons) {
        const pkg = {
            chicken: split.chicken ? Math.round(cartons * split.chicken) : 0,
            beef: split.beef ? Math.round(cartons * split.beef) : 0,
            lamb: split.lamb ? Math.round(cartons * split.lamb) : 0,
            salmon: split.salmon ? Math.round(cartons * split.salmon) : 0
        };
        let diff = Math.round(cartons - Object.values(pkg).reduce((a, b)=>a + b, 0));
        while(diff > 0){
            for(const type in pkg)if (diff > 0 && split.hasOwnProperty(type)) {
                pkg[type] += 1;
                diff -= 1;
            }
        }
        return pkg;
    }
    _getFilteredSplit(allowedProteins, isTrial) {
        const base = isTrial ? {
            ...$6373543018ca4811$var$QuizWizard.TRIAL_SPLIT
        } : {
            ...$6373543018ca4811$var$QuizWizard.FULL_SPLIT
        };
        for(const key in base)if (!allowedProteins.includes(key)) delete base[key];
        return this._adjustSplitPercentage(base);
    }
    _adjustSplitPercentage(split) {
        const total = Object.values(split).reduce((a, b)=>a + b, 0);
        if (total < 1) {
            const diff = 1 - total;
            const count = Object.keys(split).length;
            for(const key in split)split[key] += diff / count;
        }
        return split;
    }
    _getFeedingGuide(mealCount) {
        const pct = mealCount / this.wpDays;
        if (pct < 0.25) return 0.25;
        return Math.round(pct * 4) / 4;
    }
    _sanitizeBoolean(value) {
        const v = String(value).trim().toLowerCase();
        if (v === 'yes') return true;
        if (v === 'no') return false;
        return Boolean(value);
    }
    _getVolumeDiscount(price) {
        if (price >= 12000) return 0.25;
        if (price >= 10000) return 0.2;
        if (price >= 7500) return 0.15;
        return 0.1;
    }
    _getTrialEndDate() {
        const date = new Date();
        date.setDate(date.getDate() + 14);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
    }
    // ─── Data Collection ─────────────────────────────────────────────────────────
    _getInput() {
        return {
            name: this._qiv('dog_name'),
            breed: document.querySelector('form input[name="breed"]:checked')?.value === 'unknown_breed' ? 'Pawfect mix' : this._qiv('breed__autocomplete'),
            gender: document.querySelector('form input[name="gender"]:checked')?.value,
            neutered: document.querySelector('form input[name="neutered"]:checked')?.value,
            years: parseInt(this._qiv('years')) || 0,
            months: parseInt(this._qiv('months')) || 0,
            weight: parseFloat(this._qiv('weight')),
            weightgroup: parseInt(document.querySelector('input[name="weightgroup"]:checked')?.value),
            activity: parseInt(document.querySelector('input[name="activity"]:checked')?.value),
            treats: parseInt(document.querySelector('input[name="treats"]:checked')?.value),
            allergies: Array.from(document.querySelectorAll('form input[name="allergies"]:checked')).map((el)=>el.value.toLowerCase()),
            food: Array.from(document.querySelectorAll('form input[name="current__food"]:checked')).map((el)=>el.value.toLowerCase()),
            food_brand: document.querySelector('form input[name="current_food_brand"]')?.value || '',
            thrive: document.querySelector('form input[name="thrive"]:checked')?.value || '',
            hasconditions: document.querySelector('form input[name="hasconditions"]:checked')?.value || '',
            conditions: Array.from(document.querySelectorAll('form input[name="condition"]:checked')).map((el)=>el.value),
            health_issues: Array.from(document.querySelectorAll('form input[name="health_issues"]:checked')).map((el)=>el.value.toLowerCase()),
            food_issues: document.querySelector('form input[name="food_issues"]:checked')?.value || '',
            other_food_issue: document.querySelector('form textarea[name="other_food_issue"]')?.value || '',
            fussy_dog: document.querySelector('form input[name="fussy_dog"]:checked')?.value,
            prefered_treat: Array.from(document.querySelectorAll('form input[name="prefered_treat"]:checked')).map((el)=>el.value.toLowerCase())
        };
    }
    _qiv(name) {
        const el = document.querySelector(`form input[name="${name}"]`);
        return el != null ? el.value : false;
    }
    // ─── View Updates ────────────────────────────────────────────────────────────
    _setHTML(selector, value) {
        document.querySelectorAll(selector).forEach((el)=>{
            el.innerHTML = value;
        });
    }
    _show(selector) {
        document.querySelectorAll(selector).forEach((el)=>{
            el.style.display = '';
        });
    }
    _hide(selector) {
        document.querySelectorAll(selector).forEach((el)=>{
            el.style.display = 'none';
        });
    }
    _renderProductCards(cartObj, trialObj, halfObj) {
        document.querySelectorAll('.wizard-product-card').forEach((card)=>{
            const variantId = card.getAttribute('data-variant-id');
            if (cartObj[variantId] && cartObj[variantId] !== 0 || trialObj[variantId] && trialObj[variantId] !== 0) {
                card.classList.add('is-selected');
                const halfPlanBox = card.closest('.plan-box--half .plan-box__summary-cards');
                if (halfPlanBox) {
                    const mealsDetail = card.closest('[data-plan-type="meals"]');
                    const span = card.querySelector('span');
                    if (span) span.innerHTML = mealsDetail && halfObj[variantId] ? halfObj[variantId] : cartObj[variantId];
                }
                const fullPlanBox = card.closest('.plan-box--full .plan-box__summary-cards');
                if (fullPlanBox) {
                    const span = card.querySelector('span');
                    if (span) span.innerHTML = cartObj[variantId];
                }
            }
            const priceWrapper = card.querySelector('.wizard-product-card__price-wrapper');
            if (priceWrapper) {
                const price = card.dataset.price;
                const discounted = priceWrapper.querySelector('.wizard-product-card__discounted-price');
                if (discounted) discounted.innerHTML = Shopify.formatMoney(price * (1 - this.discountCodeValue), Shopify.money_format);
            }
        });
    }
    // Show only the flavour bowls whose protein is present (count > 0) in the
    // given package; hide the rest so the imagery matches the recommendation.
    _renderFlavorBowls(foodPackage) {
        document.querySelectorAll('[data-flavor-bowl]').forEach((bowl)=>{
            const flavor = bowl.dataset.flavorBowl;
            const included = (foodPackage[flavor] || 0) > 0;
            bowl.style.display = included ? '' : 'none';
        });
    }
    // ─── Meal Plan Calculation ────────────────────────────────────────────────────
    _calculateMealPlan(payload) {
        const payloadData = JSON.parse(payload);
        let fullPrice = 0;
        let trialPrice = 0;
        let fullPlanPrice = 0;
        const subscriptionData = {
            dog_name: payloadData.name,
            dog_breed: payloadData.breed,
            dog_gender: payloadData.gender,
            dog_neutered: this._sanitizeBoolean(payloadData.neutered ?? ''),
            dog_years: payloadData.years,
            dog_months: payloadData.months,
            dog_weight: payloadData.weight,
            dog_weightgroup: payloadData.weightgroup,
            dog_activity: payloadData.activity,
            dog_treats: payloadData.treats,
            dog_allergies: payloadData.allergies,
            dog_eating: payloadData.food,
            dog_fussy_dog: payloadData.fussy_dog,
            dog_prefered_treat: payloadData.prefered_treat,
            dog_health_issues: payloadData.health_issues
        };
        // Build protein splits, removing allergies
        let split = {
            ...$6373543018ca4811$var$QuizWizard.FULL_SPLIT
        };
        let trialSplit = {
            ...$6373543018ca4811$var$QuizWizard.TRIAL_SPLIT
        };
        subscriptionData.dog_allergies.forEach((allergy)=>{
            delete split[allergy.toLowerCase()];
            delete trialSplit[allergy.toLowerCase()];
        });
        split = this._adjustSplitPercentage(split);
        trialSplit = this._adjustSplitPercentage(trialSplit);
        const { MER: MER, monthlyCartons: monthlyCartons, months: months } = this._calculateCalories(payloadData);
        this.monthlyCartons = monthlyCartons;
        if (months > 11) this.isPuppy = false;
        const foodPackage = this._getMealDistribution(split, monthlyCartons);
        const trialFoodPackage = this._getMealDistribution(trialSplit, this.trialCartons);
        // Treats
        let preferedTreat = {};
        if (subscriptionData.dog_treats > 1) {
            let treatList = [
                'lamb',
                'chicken',
                'beef'
            ];
            if (subscriptionData.dog_prefered_treat == 'none' || Array.isArray(subscriptionData.dog_prefered_treat) && subscriptionData.dog_prefered_treat.includes('none')) {
                subscriptionData.dog_allergies.forEach((allergy)=>{
                    const idx = treatList.indexOf(allergy.toLowerCase());
                    if (idx !== -1) treatList.splice(idx, 1);
                });
                if (treatList.length) preferedTreat[treatList[0]] = 1;
                else preferedTreat = 'no treats';
            } else {
                if (Array.isArray(subscriptionData.dog_prefered_treat)) subscriptionData.dog_prefered_treat.forEach((item)=>{
                    preferedTreat[item] = 1;
                });
                else if (subscriptionData.dog_prefered_treat) preferedTreat[subscriptionData.dog_prefered_treat] = 1;
            }
        }
        // Supplements
        let supplements = {};
        if (months >= 6) {
            const issues = subscriptionData.dog_health_issues;
            if (issues.includes('dry, itchy or dull coat')) supplements.oil = 1;
            if (issues.includes('a sensitive stomach')) supplements.gut = 1;
            if (issues.includes('dental issues or bad breath')) supplements.dental = 1;
            if (issues.includes('joint stiffness or pain')) supplements.joint = 1;
            if (months >= 84 && !supplements.joint) supplements.joint = 1;
        }
        const totalPackage = {
            foodPackage: foodPackage,
            preferedTreat: preferedTreat,
            supplements: supplements
        };
        const trialPackage = {
            foodPackage: trialFoodPackage,
            preferedTreat: preferedTreat,
            supplements: supplements
        };
        const productList = window.productList || [];
        // Meal-only carts here; treats/supplements are added by _repriceStarterBox.
        const cartQuantities = this.cartQuantities = {};
        const trialCartQuantities = this.trialCartQuantities = {};
        // Meals
        for (const product of productList){
            for (const [key, value] of Object.entries(totalPackage.foodPackage))if (product.title.toLowerCase().includes(key)) {
                cartQuantities[product.variants[0].id] = value;
                fullPrice += product.price * value;
                break;
            }
            for (const [key, value] of Object.entries(trialPackage.foodPackage))if (product.title.toLowerCase().includes(key)) {
                trialCartQuantities[product.variants[0].id] = value;
                trialPrice += product.price * value;
                break;
            }
        }
        fullPlanPrice += fullPrice;
        const mealTotalCount = Object.values(totalPackage.foodPackage).reduce((s, v)=>s + v, 0);
        this.feedingGuide = this._getFeedingGuide(mealTotalCount);
        const halfPlanMeals = Math.ceil(mealTotalCount / 2);
        const allowedProteins = Object.keys(totalPackage.foodPackage).filter((k)=>totalPackage.foodPackage[k] > 0);
        const halfPlanSplit = this._getFilteredSplit(allowedProteins, false);
        const halfPlanDistribution = this._getMealDistribution(halfPlanSplit, halfPlanMeals);
        const halfPlanCartQuantities = this.halfPlanCartQuantities = {};
        let halfPlanMealPrice = 0;
        for (const product of productList){
            for (const [key, value] of Object.entries(halfPlanDistribution))if (product.title.toLowerCase().includes(key)) {
                halfPlanCartQuantities[product.variants[0].id] = value;
                halfPlanMealPrice += product.price * value;
                break;
            }
        }
        // Half-plan meal count only — starter-box summary is owned by the editor.
        this._setHTML('.meal-portions', halfPlanMeals);
        // Meals are fixed by the quiz; treats/supplements are editable and priced
        // by _repriceStarterBox. Store the meal-only bases (price + subscription
        // carts) so reprice can add the current add-on quantities on top.
        this.fullPlanMealPrice = fullPlanPrice; // meals only at this point
        this.halfPlanMealPrice = halfPlanMealPrice;
        this.fullPlanMealCart = {
            ...cartQuantities
        }; // meal variants only
        this.halfPlanMealCart = {
            ...halfPlanCartQuantities
        }; // meal variants only
        // Legacy (old-design) trial spans + coupon %. All PSP plan/starter prices
        // and subscription carts are owned by _repriceStarterBox.
        const fmt = (val)=>Shopify.formatMoney(val, Shopify.money_format);
        this._setHTML('.pw-trial.post-wizard-recommendation__info-discount--full-price', fmt(trialPrice));
        this._setHTML('.pw-trial.post-wizard-recommendation__info-discount--discounted-price', fmt(trialPrice * (1 - this.discountCodeValue)));
        this._setHTML('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage', this.discountCodeValue * 100);
        this._setHTML('[data-quiz-trial-discount]', this.discountCodeValue * 100);
        this._setHTML('[data-trial-end-date]', this._getTrialEndDate());
        (0, $fef978881a8614e2$export$2e2bcd8739ae039)(payloadData.name);
        this._initStarterBoxEditor(trialFoodPackage, preferedTreat, supplements, months);
    }
    _renderPriorities(priorities) {
        const list = document.querySelector('[data-plan-priorities]');
        if (!list || !priorities?.length) return;
        const checkSvgTemplate = document.createElement('template');
        checkSvgTemplate.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 18C10.1821 18.0015 11.3529 17.7694 12.445 17.317C13.5372 16.8646 14.5291 16.2009 15.3639 15.3639C16.2009 14.5291 16.8646 13.5372 17.317 12.445C17.7694 11.3529 18.0015 10.1821 18 9C18.0015 7.81789 17.7694 6.64712 17.317 5.555C16.8646 4.46287 16.2009 3.4709 15.3639 2.63611C14.5291 1.79912 13.5372 1.13536 12.445 0.682965C11.3529 0.230575 10.1821 -0.00152412 9 7.53144e-06C7.81789 -0.00149947 6.64712 0.230611 5.555 0.683C4.46287 1.13539 3.4709 1.79914 2.63611 2.63611C1.79914 3.4709 1.13539 4.46287 0.683 5.555C0.230611 6.64712 -0.00149947 7.81789 7.53144e-06 9C-0.00152412 10.1821 0.230575 11.3529 0.682965 12.445C1.13536 13.5372 1.79912 14.5291 2.63611 15.3639C3.4709 16.2009 4.46287 16.8646 5.555 17.317C6.64712 17.7694 7.81789 18.0015 9 18Z" fill="#045A2F"/><path d="M8.50402 13.7488C8.26835 13.7488 8.04838 13.6238 7.93127 13.42L5.36604 8.9502C5.1875 8.63966 5.30034 8.24552 5.616 8.06988C5.92736 7.89353 6.33157 8.00242 6.51154 8.31508L8.42976 11.6572L11.4592 4.83873C11.6063 4.51204 11.9977 4.36239 12.3248 4.50571C12.6575 4.64904 12.8089 5.02984 12.6647 5.35724L9.10677 13.3617C9.00679 13.5858 8.78684 13.7355 8.53689 13.7481C8.52689 13.7488 8.51547 13.7488 8.50404 13.7488H8.50402Z" fill="#DFF3D6"/></svg>`;
        list.replaceChildren(...priorities.map((p)=>{
            const li = document.createElement('li');
            li.appendChild(checkSvgTemplate.content.cloneNode(true));
            const span = document.createElement('span');
            span.textContent = p; // AI-provided text — textContent only, never HTML-parsed
            li.appendChild(span);
            return li;
        }));
    }
    // ─── Starter Box Editor ──────────────────────────────────────────────────────
    // Recipe display names, keyed by the same protein/issue keys the plan uses.
    static RECIPE_LABELS = {
        meals: {
            chicken: 'Chicken',
            beef: 'Beef',
            lamb: 'Lamb',
            salmon: 'Salmon'
        },
        treats: {
            chicken: 'Chicken',
            beef: 'Beef',
            lamb: 'Lamb'
        },
        supplements: {
            oil: 'Omega Oil',
            gut: 'Gut Health',
            dental: 'Dental Health',
            joint: 'Joint Health'
        }
    };
    // Build a { key: {variantId, price, title, image} } index by matching each
    // recipe key against the product titles in the given Shopify product list.
    // title/image are used by the add-ons cards; variantId/price by pricing.
    _indexProducts(list, keys) {
        const index = {};
        for (const key of keys){
            const product = (list || []).find((p)=>p.title.toLowerCase().includes(key));
            if (product) index[key] = {
                variantId: product.variants[0].id,
                price: product.price,
                title: product.title,
                image: product.featured_image || product.images && product.images[0] || ''
            };
        }
        return index;
    }
    _initStarterBoxEditor(trialFoodPackage, preferedTreat, supplements, months) {
        const labels = $6373543018ca4811$var$QuizWizard.RECIPE_LABELS;
        // Editable quantity maps (packs of each recipe in the starter box).
        const treatMap = typeof preferedTreat === 'object' ? {
            ...preferedTreat
        } : {};
        const suppMap = months >= 6 ? {
            ...supplements
        } : {};
        this.starterBox = {
            meals: {
                ...trialFoodPackage
            },
            treats: treatMap,
            supplements: suppMap
        };
        // Snapshot which add-ons the quiz originally recommended (qty > 0 at init).
        // This fixes each add-on card's column on the add-ons step — editing the
        // quantity later changes the card's state, never which side it sits on.
        this.recommendedAddons = {
            treats: new Set(Object.keys(treatMap).filter((k)=>treatMap[k] > 0)),
            supplements: new Set(Object.keys(suppMap).filter((k)=>suppMap[k] > 0))
        };
        // Priced product index per group, covering every offered recipe so the
        // user can add ones not initially recommended (shown as "0 pack").
        this.starterIndex = {
            meals: this._indexProducts(window.productList, Object.keys(labels.meals)),
            treats: this._indexProducts(window.treatsList, Object.keys(labels.treats)),
            supplements: this._indexProducts(window.supplementList, Object.keys(labels.supplements))
        };
        // Dogs under 6 months aren't recommended supplements, but the customer can
        // still add them from the add-ons step — reprice reveals the row when any
        // supplement has a quantity. Store eligibility for that logic.
        this.supplementsEligible = months >= 6;
        this._renderRecipeEditors();
        this._repriceStarterBox();
    }
    // Render stepper rows into each [data-recipe-edits] container. Every recipe
    // the index knows about gets a row, defaulting to 0 packs when not present.
    _renderRecipeEditors() {
        const labels = $6373543018ca4811$var$QuizWizard.RECIPE_LABELS;
        for (const group of [
            'meals',
            'treats',
            'supplements'
        ]){
            const container = document.querySelector(`[data-recipe-edits="${group}"]`);
            if (!container) continue;
            const rows = Object.keys(this.starterIndex[group]).map((key)=>{
                const qty = this.starterBox[group][key] || 0;
                return `
          <div class="psp-recipe-edit" data-recipe-group="${group}" data-recipe-key="${key}">
            <div class="psp-recipe-edit__label">
              <b>${labels[group][key]}</b>
              <span><span data-recipe-qty>${qty}</span> pack</span>
            </div>
            <div class="psp-stepper">
              <button type="button" class="psp-stepper__btn" data-recipe-step="-1" aria-label="Remove one">&ndash;</button>
              <span class="psp-stepper__value" data-recipe-value>${qty}</span>
              <button type="button" class="psp-stepper__btn" data-recipe-step="1" aria-label="Add one">+</button>
            </div>
          </div>`;
            }).join('');
            container.innerHTML = rows;
        }
    }
    // ─── Add-ons Step ─────────────────────────────────────────────────────────────
    // Placeholder marketing copy per add-on (will be product/AI data later).
    static ADDON_COPY = {
        treats: {
            chicken: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: 'Stat placeholder'
            },
            beef: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: 'Stat placeholder'
            },
            lamb: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: 'Stat placeholder'
            }
        },
        supplements: {
            gut: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: '71% report better digestion'
            },
            dental: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: 'Stat placeholder'
            },
            joint: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: 'Stat placeholder'
            },
            oil: {
                desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                stat: 'Stat placeholder'
            }
        }
    };
    // Render the add-ons page from the current starter box. Add-ons already in
    // the box (qty > 0) go in the "Picked for" column; the rest in the upsell
    // grid. Called by _repriceStarterBox so edits on either page stay in sync.
    _renderAddons() {
        const pickedGrid = document.querySelector('[data-addons-picked-grid]');
        const upsellGrid = document.querySelector('[data-addons-upsell-grid]');
        if (!pickedGrid || !upsellGrid) return;
        const picked = [];
        const upsell = [];
        for (const group of [
            'treats',
            'supplements'
        ])for (const [key, priced] of Object.entries(this.starterIndex[group])){
            const qty = this.starterBox[group][key] || 0;
            const card = this._addonCard(group, key, priced, qty);
            // Column is fixed by the original recommendation, not current qty, so a
            // card stays put when its quantity changes — only its state updates.
            const wasRecommended = this.recommendedAddons?.[group]?.has(key);
            (wasRecommended ? picked : upsell).push(card);
        }
        pickedGrid.innerHTML = picked.join('');
        upsellGrid.innerHTML = upsell.join('');
        // State 3: nothing in the box → hide the "Picked for" column and drop the
        // "You Might Also Like" heading to a plain centred grid.
        const pickedCol = document.querySelector('[data-addons-picked]');
        if (pickedCol) pickedCol.hidden = picked.length === 0;
        document.querySelector('[data-addons-layout]')?.classList.toggle('post-wizard-addons__container--upsell-only', picked.length === 0);
    }
    _addonCard(group, key, priced, qty) {
        const fmt = (val)=>Shopify.formatMoney(val, Shopify.money_format);
        const inBox = qty > 0;
        const copy = $6373543018ca4811$var$QuizWizard.ADDON_COPY[group]?.[key] || {};
        const desc = copy.desc || '';
        const stat = copy.stat || '';
        // Compare price: strike the list price, show the discounted per-pack.
        const discounted = priced.price * (1 - this.discountCodeValue);
        const comparePrice = this.discountCodeValue > 0 ? `<s>${fmt(priced.price)}</s> ${fmt(discounted)}/each` : `${fmt(priced.price)}/each`;
        const image = priced.image ? `<img src="${priced.image}" alt="${priced.title}" loading="lazy">` : '';
        const badge = inBox ? `<div class="post-wizard-addon-card__badge">${this._checkSvgSmall()}<span>In your box</span></div>` : '';
        const control = inBox ? `<div class="psp-stepper post-wizard-addon-card__stepper">
           <button type="button" class="psp-stepper__btn" data-recipe-step="-1" aria-label="Remove one">&ndash;</button>
           <span class="psp-stepper__value" data-recipe-value>${qty}</span>
           <button type="button" class="psp-stepper__btn" data-recipe-step="1" aria-label="Add one">+</button>
         </div>` : `<button type="button" class="post-wizard-addon-card__add" data-recipe-step="1">+ Add</button>`;
        return `
      <div class="post-wizard-addon-card${inBox ? ' post-wizard-addon-card--in-box' : ''}" data-recipe-group="${group}" data-recipe-key="${key}">
        <div class="post-wizard-addon-card__image">
          ${image}
          ${badge}
        </div>
        <div class="post-wizard-addon-card__info">
          <p class="post-wizard-addon-card__name">${priced.title}</p>
          ${desc ? `<p class="post-wizard-addon-card__desc" style="display: none;">${desc}</p>` : ''}
          ${stat ? `<p class="post-wizard-addon-card__stat" style="display: none;">${stat}</p>` : ''}
          <p class="post-wizard-addon-card__price">${comparePrice}</p>
          ${control}
        </div>
      </div>`;
    }
    _checkSvgSmall() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none"><path d="M1 3.5 3 5.5 7 1" stroke="#E6FFD4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    }
    // Recompute starter-box price, cart quantities, and all summary displays
    // from the current editable maps. Single source of truth after any edit.
    _repriceStarterBox() {
        const fmt = (val)=>Shopify.formatMoney(val, Shopify.money_format);
        const trialCartQuantities = {};
        let trialPrice = 0;
        const groupTotals = {
            meals: 0,
            treats: 0,
            supplements: 0
        };
        for (const group of [
            'meals',
            'treats',
            'supplements'
        ])for (const [key, priced] of Object.entries(this.starterIndex[group])){
            const qty = this.starterBox[group][key] || 0;
            if (qty > 0) {
                trialCartQuantities[priced.variantId] = qty;
                trialPrice += priced.price * qty;
                groupTotals[group] += priced.price * qty;
            }
        }
        this.trialCartQuantities = trialCartQuantities;
        // Summary counts
        const mealCount = Object.values(this.starterBox.meals).reduce((s, v)=>s + v, 0);
        const treatCount = Object.values(this.starterBox.treats).reduce((s, v)=>s + v, 0);
        const suppCount = Object.values(this.starterBox.supplements).reduce((s, v)=>s + v, 0);
        this._setHTML('.meal-portions-full', mealCount);
        this._setHTML('.treat-count', treatCount);
        this._setHTML('.supplements-quantity', suppCount);
        const mealNames = Object.keys(this.starterBox.meals).filter((k)=>this.starterBox.meals[k] > 0).map((k)=>$6373543018ca4811$var$QuizWizard.RECIPE_LABELS.meals[k]).join(', ');
        this._setHTML('.meal-contains', mealNames);
        // Per-group /day prices, rounded to whole pence per line. The footer
        // compare/day is the SUM of these rounded lines, so the displayed line
        // prices always add up to the total the customer sees (avoids a ±1p
        // discrepancy from rounding each figure off the raw pence independently).
        const perDayPence = (total)=>Math.round(total / this.trialDays);
        const mealDayPence = perDayPence(groupTotals.meals);
        const suppDayPence = perDayPence(groupTotals.supplements);
        const treatDayPence = perDayPence(groupTotals.treats);
        const comparePerDayPence = mealDayPence + suppDayPence + treatDayPence;
        const fmtDay = (pence)=>fmt(pence) + '/day';
        this._setHTML('[data-meal-day-price]', fmtDay(mealDayPence));
        this._setHTML('[data-supplement-day-price]', fmtDay(suppDayPence));
        this._setHTML('[data-treat-day-price]', fmtDay(treatDayPence));
        // Meal & treat rows stay visible even at 0 packs. The supplements row is
        // shown for eligible dogs, and — once a non-eligible dog has added a
        // supplement — stays visible even after they remove it, so they can re-add.
        // It only stays hidden for a non-eligible dog who has never added any.
        if (suppCount > 0) this.supplementsTouched = true;
        if (this.supplementsEligible || this.supplementsTouched) this._show('[data-plan-type="supplements"]');
        else this._hide('[data-plan-type="supplements"]');
        // Bowls follow the current meal selection.
        this._renderFlavorBowls(this.starterBox.meals);
        // Footer + sticky toolbar prices (compare = full, price = discounted).
        const discounted = trialPrice * (1 - this.discountCodeValue);
        const discountedPerDayPence = Math.round(comparePerDayPence * (1 - this.discountCodeValue));
        this._setHTML('[data-trial-box-compare-price]', fmt(trialPrice));
        this._setHTML('[data-trial-box-price]', fmt(discounted));
        this._setHTML('[data-trial-box-compare-price-day]', fmtDay(comparePerDayPence));
        this._setHTML('[data-trial-box-price-day]', fmtDay(discountedPerDayPence));
        this._setHTML('[data-trial-box-savings]', `-${fmt(trialPrice - discounted)}`);
        // ── Full / Half subscription plans ──
        // Displayed plan prices are MEALS ONLY — treats and supplements are priced
        // separately in their own rows and must not inflate the /day figures (or
        // the volume-discount tier) shown on the plan cards. The carts below still
        // carry the add-on variants so checkout is unaffected.
        const fullPlanPrice = this.fullPlanMealPrice || 0;
        const halfPlanPrice = this.halfPlanMealPrice || 0;
        const fullPlanDiscount = this._getVolumeDiscount(fullPlanPrice);
        const halfVolumeDiscount = this._getVolumeDiscount(halfPlanPrice);
        // Subscription carts = meal base + editable add-ons (same variants).
        const fullPlanCart = {
            ...this.fullPlanMealCart || {}
        };
        const halfPlanCart = {
            ...this.halfPlanMealCart || {}
        };
        for (const group of [
            'treats',
            'supplements'
        ])for (const [key, priced] of Object.entries(this.starterIndex[group])){
            const qty = this.starterBox[group][key] || 0;
            if (qty > 0) {
                fullPlanCart[priced.variantId] = qty;
                halfPlanCart[priced.variantId] = qty;
            }
        }
        this.cartQuantities = fullPlanCart;
        this.halfPlanCartQuantities = halfPlanCart;
        // Full plan (per-day over the cycle) + its "selected" mirror.
        const fullPerDay = fmt(fullPlanPrice / this.wpDays);
        const fullDiscPerDay = fmt(fullPlanPrice * (1 - fullPlanDiscount) / this.wpDays);
        this._setHTML('[data-full-box-compare-price]', fullPerDay);
        this._setHTML('[data-full-box-price]', fullDiscPerDay + '/day');
        this._setHTML('[data-selected-box-compare-price]', fullPerDay);
        this._setHTML('[data-selected-box-price]', fullDiscPerDay + '/day');
        this._setHTML('[data-quiz-plan-discount="full"], [data-quiz-plan-discount="selected"]', fullPlanDiscount * 100);
        // Full plan legacy spans (old-design PSP summary).
        this._setHTML('.pw-full.post-wizard-recommendation__info-discount--full-price', fmt(fullPlanPrice));
        this._setHTML('.pw-full.post-wizard-recommendation__info-discount--discounted-price', fmt(fullPlanPrice * (1 - fullPlanDiscount)));
        this._setHTML('.pw-full.post-wizard-recommendation__info-discount--discounted-percentage', fullPlanDiscount * 100);
        // Half plan.
        this._setHTML('[data-half-box-compare-price]', fmt(halfPlanPrice / this.wpDays));
        this._setHTML('[data-half-box-price]', fmt(halfPlanPrice * (1 - halfVolumeDiscount) / this.wpDays) + '/day');
        this._setHTML('[data-quiz-plan-discount="half"]', halfVolumeDiscount * 100);
        // Starter box must keep at least trialCartons (4) meals to check out.
        this._validateStarterBox(mealCount);
        // Refresh the plan-step dropdown steppers and the add-ons cards so
        // treat/supplement edits stay in sync across both pages.
        this._renderRecipeEditors();
        this._renderAddons();
        this._logCartState();
    }
    // Debug: log the cart payload that would be sent at checkout, reflecting the
    // current product/add-on selection. Fires on every reprice (any change).
    _logCartState() {
        const selectedPlan = document.querySelector('input[name="box-plan"]:checked')?.value || 'full plan';
        const selectedPlanCart = selectedPlan === 'half plan' ? this.halfPlanCartQuantities : this.cartQuantities;
        // First box = line items actually added to cart (trial quantities).
        const firstBoxItems = Object.entries(this.trialCartQuantities).filter(([, qty])=>qty > 0).map(([id, quantity])=>({
                id: parseInt(id),
                quantity: quantity
            }));
        console.log("\uD83D\uDED2 [wizard-v2] cart state", {
            selectedPlan: selectedPlan,
            firstBoxItems: firstBoxItems,
            attributes: {
                _selected_plan: selectedPlan,
                _full_month_plan: selectedPlanCart,
                _dog_name: this.dogName
            }
        });
    }
    // Block checkout when the edited starter box drops below the minimum meals.
    _validateStarterBox(mealCount) {
        const valid = mealCount >= this.trialCartons;
        const button = document.querySelector('.psp-toolbar__continue');
        const error = document.querySelector('[data-starter-box-error]');
        if (button) {
            button.disabled = !valid;
            button.classList.toggle('psp-toolbar__continue--disabled', !valid);
        }
        if (error) error.hidden = valid;
        this.starterBoxValid = valid;
    }
    // Apply a +/- step to a recipe and refresh its row + all prices.
    _stepRecipe(group, key, delta) {
        if (!this.starterBox?.[group]) return;
        const current = this.starterBox[group][key] || 0;
        const next = Math.max(0, current + delta);
        if (next === current) return;
        this.starterBox[group][key] = next;
        // _repriceStarterBox re-renders both the plan-step steppers and the add-on
        // cards, so the clicked control updates without a targeted DOM tweak here.
        this._repriceStarterBox();
    }
    // ─── API ─────────────────────────────────────────────────────────────────────
    // Validate + apply a discount code (from the final-step entry field, the
    // discount_code cookie, or saved progress).
    _handleCoupon(coupon, fallbackCode = '') {
        if (!coupon || coupon.length < 3) return;
        const store = Shopify.shop;
        fetch(`https://netlify.blacklemon.dk/.netlify/functions/checkCouponCode?store=${store}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `ccode=${encodeURIComponent(JSON.stringify(coupon))}`
        }).then((r)=>r.json()).then((response)=>{
            const statusEl = document.querySelector('.coupon-status');
            if (response.error) {
                // Rejected cookie/saved code — retry once with the default code.
                if (fallbackCode && fallbackCode !== coupon) {
                    const input = document.querySelector('input[name="discount"]');
                    if (input) input.value = fallbackCode;
                    this._handleCoupon(fallbackCode);
                    return;
                }
                statusEl?.classList.remove('coupon-status--active');
                statusEl?.classList.add('coupon-status--error');
                this._hide('.post-wizard-recommendation__info-discount-wrapper');
                this.discountCode = '';
            } else {
                this.discountCodeValue = response.success / 100;
                statusEl?.classList.add('coupon-status--active');
                statusEl?.classList.remove('coupon-status--error');
                const msg = document.querySelector('.coupon-status_message--valid span');
                if (msg) msg.innerHTML = response.success;
                document.querySelectorAll('.package-original-price').forEach((el)=>{
                    el.classList.add('package-original-price--crossed');
                });
                this._show('.post-wizard-recommendation__info-discount-wrapper');
                this.discountCode = coupon;
                // If the plan was already priced before this response arrived (now
                // possible as early as the step-18 "Next" click, well before the
                // plan screen is even shown), the discount fields were written
                // with the stale 0 — re-run the calculation so the pill and prices
                // reflect the applied code. Check starterBox (set by
                // _calculateMealPlan) rather than the plan wrapper's visibility,
                // since pricing can now happen long before that wrapper is shown.
                if (this.starterBox) this._calculateMealPlan(JSON.stringify(this._getInput()));
            }
        }).catch(()=>(0, $9168539475c74f83$export$2e2bcd8739ae039)('An error occurred'));
    }
    async _addItemsToCart(items, fullPlanCart, halfPlanCart, selectedPlan) {
        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: items.map((item)=>({
                            id: parseInt(item.id),
                            quantity: item.quantity,
                            selling_plan: '8019935518',
                            properties: {
                                _dog_name: this.dogName,
                                _dynamicBoxIndex: 0,
                                _dynamicBoxId: 'b47674e0-72a2-4bff-9c7b-4f2cc0ef47d9'
                            }
                        }))
                })
            }).then((r)=>r.json());
            const selectedPlanCart = selectedPlan === 'half plan' ? halfPlanCart : fullPlanCart;
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        _hidden_note: JSON.stringify(this._getInput()),
                        _quiz_version: 'wizard-v2',
                        _feeding_guide: this.feedingGuide,
                        _dog_name: this.dogName,
                        _selected_plan: selectedPlan,
                        _full_month_plan: JSON.stringify(selectedPlanCart)
                    }
                })
            }).then((r)=>r.json());
            // Clear the leave-page guard so the checkout redirect doesn't prompt.
            window.onbeforeunload = null;
            window.location.href = this.discountCode.length ? `/checkout?discount=${this.discountCode}` : '/checkout';
        } catch (err) {
            console.error('Error adding items to cart:', err);
        }
    }
    _submitToKlaviyo() {
        const newsletter = document.querySelector('.final-step-flow input[name="mc_signup"]');
        if (!newsletter?.checked) return;
        const userEmail = document.querySelector('.final-step-flow [name="owner_email"]')?.value;
        const profile = this._getInput();
        if (!profile) return;
        const activityMap = {
            1: 'Pretty snoozy',
            2: 'Active',
            3: 'Explosion of energy'
        };
        const bodyTypeMap = {
            1: 'A bit skinny',
            2: 'Just paw-fect',
            3: 'A bit chonky'
        };
        const treatsMap = {
            1: 'Never',
            2: 'Sometimes',
            3: 'Pretty often'
        };
        const fussyMap = {
            Yes: 'Very fussy',
            Between: 'A little fussy',
            No: 'Not fussy'
        };
        const totalMonths = profile.years * 12 + profile.months;
        const lifeStage = totalMonths < 12 ? 'Puppy' : totalMonths > 84 ? 'Senior' : 'Adult';
        const klaviyoProfile = {
            dog_name: profile.name,
            dog_gender: profile.gender,
            dog_spayed_neutered: profile.neutered,
            dog_breed: profile.breed,
            dog_life_stage: lifeStage,
            dog_weight_kg: profile.weight,
            dog_bodytype: bodyTypeMap[profile.weightgroup],
            dog_activity_level: activityMap[profile.activity],
            dog_treats_per_day: treatsMap[profile.treats],
            dog_fussy_level: fussyMap[profile.fussy_dog],
            dog_allergies_dislikes: profile.allergies,
            dog_current_diet: profile.food,
            dog_health_issues: profile.health_issues,
            dog_treat_preference: profile.prefered_treat,
            dog_current_food_brand: profile.food_brand,
            dog_thrive_goal: profile.thrive,
            dog_has_conditions: profile.hasconditions,
            dog_conditions: profile.conditions.join(', '),
            dog_food_issues: profile.food_issues,
            dog_other_food_issue: profile.other_food_issue,
            _quiz_version: 'wizard-v2'
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=R6vSRF', {
            method: 'POST',
            headers: {
                revision: '2023-06-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        list_id: 'XWKRtA',
                        custom_source: 'Wizard',
                        email: userEmail,
                        properties: {
                            hasPuppy: this.isPuppy,
                            ...klaviyoProfile
                        }
                    }
                }
            })
        }).then((r)=>{
            if (!r.ok) return r.json().then((err)=>Promise.reject(err));
        }).then(()=>fetch('https://a.klaviyo.com/client/events/?company_id=R6vSRF', {
                method: 'POST',
                headers: {
                    revision: '2023-06-15',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'event',
                        attributes: {
                            properties: klaviyoProfile,
                            metric: {
                                name: 'Completed Dog Quiz'
                            },
                            profile: {
                                email: userEmail
                            }
                        }
                    }
                })
            })).catch((err)=>console.error('Klaviyo API Error:', err));
    }
    // ─── Persistence ──────────────────────────────────────────────────────────────
    saveProgress(step) {
        const existing = JSON.parse(localStorage.getItem('quizAnswers-v2') || '{}');
        const newData = this._getInput();
        newData.step = step;
        newData.age_group = document.querySelector('input[name="age_group"]:checked')?.value || '';
        newData.discount_code = this.discountCode || '';
        newData.customer_email = document.querySelector('input[name="owner_email"]')?.value || '';
        newData.accepts_newsletter = document.querySelector('input[name="mc_signup"]')?.checked || false;
        localStorage.setItem('quizAnswers-v2', JSON.stringify({
            ...existing,
            ...newData
        }));
    }
    _prepopulate(rawData) {
        if (!rawData) return;
        const data = JSON.parse(rawData);
        // Gender
        if (data.gender) {
            const label = document.getElementById('neutered-spayed');
            if (label) {
                const old = label.innerHTML;
                label.innerHTML = data.gender === 'Boy' ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
            }
            const genderInput = document.querySelector(`input[name="gender"][value="${data.gender.charAt(0).toUpperCase() + data.gender.slice(1)}"]`);
            if (genderInput) {
                genderInput.checked = true;
                // Setting .checked doesn't fire change, so update the gender spans
                // directly. Document-scoped for spans on the plan / add-ons pages.
                document.querySelectorAll('.gender-update').forEach((el)=>{
                    el.textContent = data.gender === 'Boy' ? 'he' : 'she';
                });
                document.querySelectorAll('.gender-update-possessive').forEach((el)=>{
                    el.textContent = data.gender === 'Boy' ? 'his' : 'her';
                });
            }
        }
        // Name
        if (data.name) {
            const nameInput = document.querySelector('input[data-order="name"]');
            if (nameInput) {
                nameInput.value = data.name;
                (0, $fef978881a8614e2$export$2e2bcd8739ae039)(data.name);
            }
        }
        // Age
        const months = data.months || 0;
        const years = data.years || 0;
        const monthsInput = document.querySelector('input[name="months"]');
        const yearsInput = document.querySelector('input[name="years"]');
        // Only populate when there's a real value, so empty fields keep their placeholder
        if (monthsInput) monthsInput.value = months || '';
        if (yearsInput) yearsInput.value = years || '';
        const totalMonths = years * 12 + months;
        // The number drives the group: derive it from the saved age when an age was
        // entered; otherwise fall back to the group the user explicitly selected.
        const restoredGroup = years || months ? this._ageGroupForMonths(totalMonths) : data.age_group;
        if (restoredGroup) {
            const groupRadio = document.querySelector(`input[name="age_group"][value="${restoredGroup}"]`);
            if (groupRadio) groupRadio.checked = true;
        }
        // Reveal + configure the age inputs for the restored group selection
        document.querySelector('input[name="age_group"]:checked')?.dispatchEvent(new Event('change'));
        // Breed
        if (data.breed) {
            const breedInput = document.querySelector('input[name="breed__autocomplete"]');
            if (data.breed === 'Pawfect mix') {
                const crossbreedRadio = document.getElementById('crossbreed');
                if (crossbreedRadio) crossbreedRadio.checked = true;
                if (breedInput) {
                    breedInput.value = 'Pawfect mix';
                    // Match the "Mix" selection: no suggestions dropdown/chevron, but still editable
                    breedInput.setAttribute('data-autocomplete-off', '');
                }
            } else {
                const purebredRadio = document.getElementById('purebred');
                if (purebredRadio) purebredRadio.checked = true;
                if (breedInput) {
                    breedInput.value = data.breed;
                    breedInput.removeAttribute('data-autocomplete-off');
                }
            }
        }
        // Weight — only override the 10kg default when a real saved weight exists
        const savedWeight = parseFloat(data.weight);
        if (!isNaN(savedWeight) && savedWeight >= 1) {
            const weightText = document.getElementById('weightTextInput');
            const weightRange = document.getElementById('weightRangeInput');
            if (weightText) weightText.value = savedWeight;
            if (weightRange) weightRange.value = savedWeight;
            // Refresh the slider fill via the already-registered change handler
            weightText?.dispatchEvent(new Event('change'));
        }
        // Neutered
        if (data.neutered) {
            const neuteredInput = document.querySelector(`input[name="neutered"][value="${data.neutered}"]`);
            if (neuteredInput) neuteredInput.checked = true;
        }
        // Body type
        if (data.weightgroup) {
            const wgInput = document.querySelector(`input[name="weightgroup"][value="${data.weightgroup}"]`);
            if (wgInput) wgInput.checked = true;
        }
        // Activity (fix: was reading weightgroup — now reads activity)
        if (data.activity) {
            const actInput = document.querySelector(`input[name="activity"][value="${data.activity}"]`);
            if (actInput) actInput.checked = true;
        }
        // Checkboxes
        const checkAll = (name, values)=>{
            if (!values?.length) return;
            values.forEach((val)=>{
                const cap = val.charAt(0).toUpperCase() + val.slice(1);
                const el = document.querySelector(`input[name="${name}"][type="checkbox"][value="${cap}"]`) || document.querySelector(`input[name="${name}"][type="checkbox"][value="${val}"]`);
                if (el) el.checked = true;
            });
        };
        checkAll('allergies', data.allergies);
        checkAll('health_issues', data.health_issues);
        checkAll('prefered_treat', data.prefered_treat);
        // Step 13 current diet is a single-select radio; data.food stores its value
        // lowercased, so match case-insensitively against the radio values.
        const foodVal = Array.isArray(data.food) ? data.food[0] : data.food;
        if (foodVal) {
            const foodRadio = Array.from(document.querySelectorAll('input[name="current__food"]')).find((el)=>el.value.toLowerCase() === String(foodVal).toLowerCase());
            if (foodRadio) foodRadio.checked = true;
        }
        // Current diet brand (optional — never blocks the quiz)
        if (data.food_brand) {
            const brandInput = document.querySelector('input[name="current_food_brand"]');
            if (brandInput) brandInput.value = data.food_brand;
        }
        // Step 12 "thrive" — restore the radio and re-render its fact callout
        if (data.thrive) {
            const thriveRadio = document.querySelector(`input[name="thrive"][value="${data.thrive}"]`);
            if (thriveRadio) {
                thriveRadio.checked = true;
                thriveRadio.dispatchEvent(new Event('change'));
            }
        }
        // Medical conditions — restore the None/Some radio and any checked conditions
        if (data.hasconditions) {
            const conditionsRadio = document.querySelector(`input[name="hasconditions"][value="${data.hasconditions}"]`);
            if (conditionsRadio) conditionsRadio.checked = true;
            (data.conditions || []).forEach((val)=>{
                const cb = document.querySelector(`input[name="condition"][value="${val}"]`);
                if (cb) cb.checked = true;
            });
            // Fire change so the conditions list shows/hides to match the restored choice
            conditionsRadio?.dispatchEvent(new Event('change'));
        }
        // Step 14 — what's not working (radio) + optional "something else" text
        if (data.food_issues) {
            const foodIssueRadio = document.querySelector(`input[name="food_issues"][value="${data.food_issues}"]`);
            if (foodIssueRadio) foodIssueRadio.checked = true;
        }
        const otherFoodIssue = document.querySelector('textarea[name="other_food_issue"]');
        if (otherFoodIssue) // Only keep the "something else" text when "Other" is the selected issue
        otherFoodIssue.value = data.food_issues === 'Other' ? data.other_food_issue || '' : '';
        if (data.treats) {
            const treatsInput = document.querySelector(`input[name="treats"][value="${data.treats}"]`);
            if (treatsInput) treatsInput.checked = true;
        }
        if (data.fussy_dog) {
            const fussyInput = document.querySelector(`input[name="fussy_dog"][value="${data.fussy_dog}"]`);
            if (fussyInput) fussyInput.checked = true;
        }
        // Resume step — render the saved step directly so the user lands on it
        // (previously this clicked "start", which validated & advanced one step and
        // left the user stranded on step 1 when the saved step had missing data).
        if (data.step) {
            // saveProgress records the step the user just COMPLETED, so resume on the
            // next question rather than re-showing an already-answered one.
            // If they already reached the final step, land there (the summary); otherwise
            // advance one step but never past the last question.
            this.step = data.step >= this.lastStep ? this.lastStep : Math.min(data.step + 1, this.lastStep - 1);
            // Mark earlier steps complete, the current step active
            document.querySelectorAll('.progress__step').forEach((el)=>{
                const stepNum = Number(el.dataset.step);
                el.classList.remove('is-active', 'is-complete');
                if (stepNum < this.step) el.classList.add('is-complete');
                else if (stepNum === this.step) el.classList.add('is-active');
            });
            // Update header chrome to match the landed step
            const counter = document.querySelector('.progress__counter span');
            if (counter) counter.innerHTML = this.step - 1;
            const progressBar = this.querySelector('.quiz-header__progress-bar');
            if (progressBar) progressBar.style.width = `${this.step / this.lastStep * 100}%`;
            this.querySelector('.quiz-header__back')?.classList.toggle('disabled', this.step === 1);
            this.nextButton?.classList.remove('disabled');
            // Render the saved step's section and sync the checkout flow
            (0, $3105107e16cbe8b2$export$2e2bcd8739ae039)(this.step);
            this.dataset.current = this.step;
            this._checkoutFlow(this.step);
            // If resuming onto the final step, pick the fitting Trustpilot review
            if (this.step === this.lastStep) this._updateTrustpilotQuote();
            (0, $99c4775dc0c46940$export$f5d3771428a1f489)();
        }
        // Discount code — re-apply the saved code automatically
        if (data.discount_code) {
            const discountInput = document.querySelector('input[name="discount"]');
            if (discountInput) discountInput.value = data.discount_code;
            this._handleCoupon(data.discount_code);
        }
        // Email
        if (data.customer_email) {
            const emailInput = document.querySelector('input[name="owner_email"]');
            if (emailInput) emailInput.value = data.customer_email;
        }
        requestAnimationFrame(()=>{
            this._calculateMealPlan(JSON.stringify(this._getInput()));
            // Resumed straight onto the email step (e.g. a refresh) — kick off the
            // AI plan content fetch now, same as the normal step-18 "Next" flow, so
            // it isn't left to start cold on final submit. this._planReadyPromise
            // stands for "meal plan calc is ready" (used to gate the loader
            // overlay) — the AI fetch is chained off it but NOT folded into it, so
            // a slow AI response never blocks the overlay.
            if (this.step === this.lastStep) {
                this._planReadyPromise = Promise.resolve();
                this._planReadyPromise.then(()=>this._loadPlanContent());
                (0, $57b144c3a8c298c7$export$13eeee5b6595ff83)();
            }
        });
    }
    // ─── Age Toggle ───────────────────────────────────────────────────────────────
    // Map a total age in months to its age group, using the same thresholds
    // as the calorie math: <12mo Puppy, 12–84mo Adult, >84mo Senior.
    _ageGroupForMonths(totalMonths) {
        if (totalMonths < 12) return 'Puppy';
        if (totalMonths > 84) return 'Senior';
        return 'Adult';
    }
    // Step 6 founder note — swaps the message to match the selected age group
    // and injects the dog's name.
    _updateFounderNote(group) {
        const el = this.querySelector('[data-founder-message]');
        if (!el) return;
        const name = (this._qiv('dog_name') || this.dogName || 'your pup').trim();
        const safe = name.replace(/[&<>"']/g, (c)=>({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            })[c]);
        const possessive = `${safe}${/s$/i.test(name) ? "\u2019" : "\u2019s"}`;
        const messages = {
            Puppy: `How exciting \u{2014} thousands of pups are already on Marleybones! ${safe} is in great hands.`,
            Adult: `The best years are ahead. We\u{2019}ll make sure ${possessive} nutrition keeps up with them.`,
            Senior: `Senior dogs deserve just as much love at mealtimes. We\u{2019}ll build ${possessive} plan around their needs.`
        };
        if (messages[group]) {
            el.innerHTML = messages[group];
            el.closest('[data-founder-note]').style.display = 'block';
        }
    }
    // Step 19 Trustpilot quote — pick a review based on the user's answers.
    // Rules are evaluated in order; the first whose match() returns true wins,
    // falling back to DEFAULT. Fill in real quotes + logic below.
    _updateTrustpilotQuote() {
        // Quote appears in the in-quiz Trustpilot block and again in the plan
        // overview (outside <quiz-wizard>), so query the whole document.
        const quoteEls = document.querySelectorAll('[data-trustpilot-quote]');
        const authorEls = document.querySelectorAll('[data-trustpilot-author]');
        if (!quoteEls.length) return;
        // Quote is chosen from the step-12 "thrive" answer (with a body-type split
        // for "Healthy weight"). thrive isn't in _getInput, so read it directly.
        const thrive = this.querySelector('input[name="thrive"]:checked')?.value;
        const weightgroup = parseInt(this.querySelector('input[name="weightgroup"]:checked')?.value); // 1 skinny, 2 pawfect, 3 chonky
        const DEFAULT = {
            quote: `"My dog wouldn't touch the old brand's meals. Marleybones changed everything\u{2014}now she eagerly waits for every meal!"`,
            author: `Emily T`
        };
        const QUOTES = {
            'Better digestion': {
                quote: `"She had always had a problem with soft poos no matter what we tried and when we saw some of the Marleybones reviews, thought it was worth giving it a go. It wasn't long before we saw a lot of improvement. She is excited at mealtimes and we love the ease of use!"`,
                author: `Marina Steel`
            },
            'Less fussy': {
                quote: `"Amazing service and amazing food - our very fussy cocker spaniel loves it."`,
                author: `Kerry Watts`
            },
            'Healthier coat': {
                quote: `"Since changing my French Bulldog to Marleybones she has enjoyed every bowl. Her coat and skin seem much better - brilliant food and great customer service."`,
                author: `Tracey Cutler`
            },
            'Healthier life': {
                quote: `"Marleybones is exceptional dog food. My dog LOVES it and is in the best shape of his life since starting his new dog food journey - he has more energy, a soft and silky coat, and is loving life."`,
                author: `Kate Woolford`
            }
        };
        // "Healthy weight" splits by body type: chonky (3) gets a different review.
        const HEALTHY_WEIGHT_CHONKY = {
            quote: `"We followed the feeding guide on the box and she is now up to and maintaining a healthy weight, her coat is now full and glossy and she is full of energy. The vet is very pleased with her progress."`,
            author: `SC`
        };
        const HEALTHY_WEIGHT_DEFAULT = {
            quote: `"My dog absolutely loves this food. His weight had rapidly dropped, however after swapping him onto Marleybones his weight is absolutely perfect again."`,
            author: `Kayla Ruddy`
        };
        let chosen = DEFAULT;
        if (thrive === 'Healthy weight') chosen = weightgroup === 3 ? HEALTHY_WEIGHT_CHONKY : HEALTHY_WEIGHT_DEFAULT;
        else if (QUOTES[thrive]) chosen = QUOTES[thrive];
        quoteEls.forEach((el)=>{
            el.innerHTML = chosen.quote;
        });
        authorEls.forEach((el)=>{
            el.innerHTML = `<strong>${chosen.author}</strong>`;
        });
    }
    // Confetti burst on age-group selection (window.confetti loaded via CDN)
    _celebrate() {
        if (typeof window.confetti !== 'function') return;
        window.confetti({
            spread: 360,
            ticks: 200,
            gravity: 1,
            decay: .94,
            startVelocity: 30,
            particleCount: 100,
            scalar: 3,
            shapes: [
                "image"
            ],
            shapeOptions: {
                image: [
                    {
                        src: "https://cdn.shopify.com/s/files/1/0784/5448/9374/files/confetti-1.svg?v=1783026389",
                        width: 32,
                        height: 32
                    },
                    {
                        src: "https://cdn.shopify.com/s/files/1/0784/5448/9374/files/confetti-2.svg?v=1783026389",
                        width: 32,
                        height: 32
                    },
                    {
                        src: "https://cdn.shopify.com/s/files/1/0784/5448/9374/files/confetti-3.svg?v=1783026388",
                        width: 32,
                        height: 32
                    },
                    {
                        src: "https://cdn.shopify.com/s/files/1/0784/5448/9374/files/confetti-4.svg?v=1783026388",
                        width: 32,
                        height: 32
                    },
                    {
                        src: "https://cdn.shopify.com/s/files/1/0784/5448/9374/files/confetti-5.svg?v=1783026389",
                        width: 32,
                        height: 32
                    }
                ]
            }
        });
    }
    _initAgeToggle() {
        const ageGroupRadios = this.querySelectorAll('input[name="age_group"]');
        const inputYears = this.querySelector('input[name="years"]');
        const inputMonths = this.querySelector('input[name="months"]');
        const inputYearsContainer = this.querySelector('#input_age_years');
        const ageInputSwitch = this.querySelector('#input_age');
        // Show/hide the year & month fields for a group, without clearing their values.
        const applyFieldVisibility = (selected)=>{
            if (!selected) {
                if (ageInputSwitch) ageInputSwitch.style.display = 'none';
                return;
            }
            if (ageInputSwitch) ageInputSwitch.style.display = 'flex';
            if (selected === 'Puppy') {
                if (inputYearsContainer) inputYearsContainer.style.display = 'none';
                if (inputMonths?.parentElement) inputMonths.parentElement.style.display = 'block';
                inputMonths?.setAttribute('required', 'required');
                inputYears?.removeAttribute('required');
            } else {
                if (inputYearsContainer) inputYearsContainer.style.display = 'block';
                if (inputMonths?.parentElement) inputMonths.parentElement.style.display = 'block';
                inputYears?.setAttribute('required', 'required');
                inputMonths?.removeAttribute('required');
            }
        };
        // When the user PICKS a group manually, reset the age fields for that group.
        const onGroupChange = (event)=>{
            const selected = this.querySelector('input[name="age_group"]:checked')?.value;
            applyFieldVisibility(selected);
            this._updateFounderNote(selected);
            // Only celebrate on a genuine user selection — not programmatic change
            // events dispatched during prepopulate/resume (event.isTrusted === false).
            if (event?.isTrusted) this._celebrate();
            // Puppy uses months only — clear any leftover years value.
            if (selected === 'Puppy' && inputYears) {
                inputYears.value = '';
                inputYears.dispatchEvent(new Event('change'));
            }
        };
        // When the user TYPES an age, derive the group from the number (number is the
        // source of truth) and update the selected radio + field visibility to match.
        const syncGroupFromAge = ()=>{
            const totalMonths = Number(inputYears?.value) * 12 + Number(inputMonths?.value || 0);
            // Nothing entered yet — leave the current selection alone.
            if (!inputYears?.value && !inputMonths?.value) return;
            const group = this._ageGroupForMonths(totalMonths);
            const groupRadio = this.querySelector(`input[name="age_group"][value="${group}"]`);
            if (groupRadio && !groupRadio.checked) {
                groupRadio.checked = true;
                applyFieldVisibility(group);
                this._updateFounderNote(group);
                this.saveProgress(this.step);
            }
        };
        ageGroupRadios.forEach((radio)=>radio.addEventListener('change', onGroupChange));
        inputYears?.addEventListener('input', syncGroupFromAge);
        inputMonths?.addEventListener('input', syncGroupFromAge);
        applyFieldVisibility(this.querySelector('input[name="age_group"]:checked')?.value);
    }
    // ─── Breed Logic ─────────────────────────────────────────────────────────────
    _initBreedLogic() {
        const purebredRadio = this.querySelector('#purebred');
        const crossbreedRadio = this.querySelector('#crossbreed');
        const breedInput = this.querySelector('#breed__autocomplete');
        const handleRadioChange = ()=>{
            if (purebredRadio?.checked) {
                breedInput?.setAttribute('required', 'required');
                // Re-enable the breed suggestions dropdown + chevron
                breedInput?.removeAttribute('data-autocomplete-off');
                if (breedInput) breedInput.value = '';
            } else if (crossbreedRadio?.checked) {
                breedInput?.removeAttribute('required');
                if (breedInput) breedInput.value = 'Pawfect mix';
                // Turn off the suggestions dropdown + chevron, but keep the field editable
                breedInput?.setAttribute('data-autocomplete-off', '');
                // Close the dropdown if it happens to be open
                document.querySelectorAll('.autocomplete-items').forEach((el)=>el.remove());
            }
        };
        purebredRadio?.addEventListener('change', handleRadioChange);
        crossbreedRadio?.addEventListener('change', handleRadioChange);
        // Default to "Breed" (purebred) unless a selection already exists (e.g. resumed quiz)
        if (purebredRadio && !purebredRadio.checked && !crossbreedRadio?.checked) purebredRadio.checked = true;
        handleRadioChange();
    }
    // ─── Checkbox Exclusives ─────────────────────────────────────────────────────
    _initCheckboxExclusives() {
        const makeExclusive = (name, noneValue)=>{
            const inputs = this.querySelectorAll(`input[name="${name}"]`);
            inputs.forEach((input)=>{
                input.addEventListener('click', ()=>{
                    if (input.value === noneValue) {
                        if (input.checked) inputs.forEach((other)=>{
                            if (other.value !== noneValue) other.checked = false;
                        });
                    } else {
                        const noneInput = this.querySelector(`input[name="${name}"][value="${noneValue}"]`);
                        if (noneInput) noneInput.checked = false;
                    }
                });
            });
        };
        makeExclusive('allergies', 'Nothing');
        makeExclusive('health_issues', 'No health issues');
        makeExclusive('prefered_treat', 'none');
    }
    // ─── Conditions Toggle ────────────────────────────────────────────────────────
    _initConditionsToggle() {
        const block = this.querySelector('[data-has-conditions]');
        if (!block) return;
        const radios = this.querySelectorAll('input[name="hasconditions"]');
        const toggle = ()=>{
            const selected = this.querySelector('input[name="hasconditions"]:checked')?.value;
            if (selected === 'Some') block.style.display = 'block';
            else {
                block.style.display = 'none';
                // Clear any condition selections when they're no longer applicable
                block.querySelectorAll('input[type="checkbox"]:checked').forEach((cb)=>{
                    cb.checked = false;
                });
            }
        };
        radios.forEach((radio)=>radio.addEventListener('change', toggle));
        toggle();
    }
    // ─── Thrive Callout ───────────────────────────────────────────────────────────
    _initThriveCallout() {
        const callout = this.querySelector('[data-thrive-callout]');
        const headlineEl = this.querySelector('[data-thrive-headline]');
        const bodyEl = this.querySelector('[data-thrive-body]');
        if (!callout || !headlineEl || !bodyEl) return;
        // Copy per "thrive" selection. {name}/{name's}/{they} tokens are filled at render.
        const content = {
            'Better digestion': {
                headline: "71% of customers\u2026",
                body: "report better digestion and stool quality after switching \u2014 {name's} gut health goal is front and centre in {their} plan."
            },
            'Less fussy': {
                headline: "9 in 10 former fussy dogs\u2026",
                body: "now enjoy mealtimes with Marleybones \u2014 so we\u2019re confident {name} will too."
            },
            'Healthy weight': {
                headline: "76% of customers\u2026",
                body: "reported improvements to their dog's weight after switching \u2014 nutritionally balanced meals to help support {name} reach a healthy weight."
            },
            'Healthier coat': {
                headline: "1 in 2 customers\u2026",
                body: "have reported improvements in their dog's skin & coat since switching to Marleybones."
            },
            'Healthier life': {
                headline: "98% of owners\u2026",
                body: "are glad they switched to Marleybones \u2014 {name's} health starts with what's in their bowl."
            }
        };
        const render = ()=>{
            const selected = this.querySelector('input[name="thrive"]:checked')?.value;
            const copy = selected && content[selected];
            if (!copy) {
                callout.style.display = 'none';
                return;
            }
            const name = (this._qiv('dog_name') || this.dogName || 'your pup').trim();
            const safe = name.replace(/[&<>"']/g, (c)=>({
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#39;'
                })[c]);
            const possessive = `${safe}${/s$/i.test(name) ? "\u2019" : "\u2019s"}`;
            const gender = this.querySelector('input[name="gender"]:checked')?.value;
            const their = gender === 'Boy' ? 'his' : gender === 'Girl' ? 'her' : 'their';
            const fill = (str)=>str.replace(/\{name's\}/g, possessive).replace(/\{name\}/g, safe).replace(/\{their\}/g, their);
            headlineEl.textContent = copy.headline;
            bodyEl.innerHTML = fill(copy.body);
            callout.style.display = 'block';
        };
        this.querySelectorAll('input[name="thrive"]').forEach((radio)=>radio.addEventListener('change', render));
        render();
    }
    // ─── Autocomplete ─────────────────────────────────────────────────────────────
    _initAutocomplete() {
        const sources = {
            dietBrands: window.dietBrandsData || '',
            default: window.breedsData || ''
        };
        this.querySelectorAll('.autocomplete').forEach((input)=>{
            const key = input.dataset.autocompleteSource || 'default';
            const list = (sources[key] || '').split('\n');
            this._autocomplete(input, list);
        });
        // Close any open list on outside clicks — registered once for all fields.
        // (Clicking an autocomplete input or an item is handled by their own listeners.)
        document.addEventListener('click', (e)=>{
            if (e.target.classList?.contains('autocomplete') || e.target.closest('.autocomplete-items')) return;
            document.querySelectorAll('.autocomplete-items').forEach((el)=>el.remove());
        });
    }
    _autocomplete(inp, arr) {
        let currentFocus = -1;
        // Drop empty entries (e.g. trailing newline from the CSV split)
        const breeds = arr.map((b)=>b.trim()).filter(Boolean);
        const closeAllLists = (except)=>{
            document.querySelectorAll('.autocomplete-items').forEach((el)=>{
                if (el !== except && el !== inp) el.parentNode.removeChild(el);
            });
        };
        // Build the dropdown. With no filter value, shows every breed (scrollable);
        // with a value, shows only matches with the match highlighted.
        const renderList = (val)=>{
            closeAllLists();
            currentFocus = -1;
            // Suggestions disabled (e.g. "Mix" selected) — field stays editable, just no dropdown
            if (inp.hasAttribute('data-autocomplete-off')) return;
            const filter = (val || '').toLowerCase().trim();
            const list = document.createElement('DIV');
            list.setAttribute('id', inp.id + 'autocomplete-list');
            list.setAttribute('class', 'autocomplete-items');
            inp.parentNode.appendChild(list);
            for (const breed of breeds){
                const lower = breed.toLowerCase();
                if (filter && lower.indexOf(filter) === -1) continue;
                const item = document.createElement('DIV');
                item.innerHTML = filter ? lower.replace(filter, `<strong>${filter}</strong>`) : lower;
                item.innerHTML += `<input type='hidden' value='${breed}'>`;
                item.addEventListener('click', function() {
                    inp.value = this.getElementsByTagName('input')[0].value;
                    inp.dispatchEvent(new Event('change'));
                    closeAllLists();
                });
                list.appendChild(item);
            }
        };
        // Focus → show the full list so the user can just scroll and click
        inp.addEventListener('focus', function() {
            renderList(this.value);
        });
        // Typing → filter (and still show the full list when the field is cleared)
        inp.addEventListener('input', function() {
            renderList(this.value);
        });
        inp.addEventListener('keydown', function(e) {
            let x = document.getElementById(this.id + 'autocomplete-list');
            if (x) x = x.getElementsByTagName('div');
            if (e.keyCode === 40) {
                currentFocus++;
                addActive(x);
            } else if (e.keyCode === 38) {
                currentFocus--;
                addActive(x);
            } else if (e.keyCode === 13) {
                e.preventDefault();
                if (currentFocus > -1 && x) x[currentFocus]?.click();
            }
        });
        const addActive = (x)=>{
            if (!x) return;
            Array.from(x).forEach((el)=>el.classList.remove('autocomplete-active'));
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = x.length - 1;
            x[currentFocus]?.classList.add('autocomplete-active');
        };
    // Outside-click closing is handled once in _initAutocomplete for all fields.
    }
    // ─── Resume Flow ─────────────────────────────────────────────────────────────
    _initResumeFlow() {
        const previousQuizData = localStorage.getItem('quizAnswers-v2');
        if (previousQuizData) {
            const saved = JSON.parse(previousQuizData);
            if (saved.name) (0, $fef978881a8614e2$export$2e2bcd8739ae039)(saved.name);
            this.querySelector('.quiz-started-overlay')?.classList.add('show-modal');
        }
    }
    // ─── AI Plan Content ──────────────────────────────────────────────────────────
    // Assemble the object sent to the plan-content endpoint: the raw quiz answers
    // plus the product NAMES that were recommended in the plan. Must run after
    // _calculateMealPlan (which populates starterBox / starterIndex).
    _buildQuizPayload() {
        // Recommended product titles per group. starterBox holds recommended
        // quantities (keyed by protein/issue); starterIndex maps each key to its
        // product { title, ... }. recommendedAddons is the original recommendation
        // for treats/supplements (before any add-ons-step edits).
        const namesFor = (group, keys)=>[
                ...keys
            ].filter((key)=>this.starterIndex?.[group]?.[key]).map((key)=>this.starterIndex[group][key].title);
        const mealKeys = Object.keys(this.starterBox?.meals || {}).filter((key)=>this.starterBox.meals[key] > 0);
        // Slider answers are stored as raw 1–3 values; send their human-readable
        // labels (matching setTreatsFromValue / setWeightFromValue / setActivity-
        // FromValue in range.js) so the plan-content endpoint gets readable text.
        const LABELS = {
            treats: {
                1: 'Never',
                2: 'Sometimes',
                3: 'Pretty often'
            },
            weightgroup: {
                1: 'A bit skinny',
                2: 'Just pawfect',
                3: 'A bit chubby'
            },
            activity: {
                1: 'Pretty snoozy',
                2: 'Active',
                3: 'An explosion of energy'
            }
        };
        const answers = this._getInput();
        for (const field of [
            'treats',
            'weightgroup',
            'activity'
        ])answers[field] = LABELS[field][answers[field]] ?? answers[field];
        // Client request: never send health conditions (suitable or unsuitable)
        // to the plan-content endpoint. _getInput() keeps them for the rest of
        // the quiz (subscription data, restore, etc.).
        delete answers.conditions;
        delete answers.hasconditions;
        return {
            answers: answers,
            dogName: this.dogName,
            recommendation: {
                meals: namesFor('meals', mealKeys),
                treats: namesFor('treats', this.recommendedAddons?.treats || []),
                supplements: namesFor('supplements', this.recommendedAddons?.supplements || [])
            }
        };
    }
    // TESTING ONLY — dump the _buildQuizPayload JSON into the debug <code> block
    // on the email step. Recommendation fields are empty until the plan is
    // calculated (on quiz completion).
    _renderPayloadDebug() {
        const el = document.querySelector('[data-quiz-payload-debug] code');
        if (!el) return;
        try {
            el.textContent = JSON.stringify(this._buildQuizPayload(), null, 2);
        } catch (err) {
            el.textContent = `payload error: ${err.message}`;
        }
    }
    // PLACEHOLDER — POST the quiz payload to the plan-content endpoint and return
    // the parsed response. Swap PLAN_CONTENT_ENDPOINT for the real Vercel URL.
    async _fetchPlanContent(payload) {
        const PLAN_CONTENT_ENDPOINT = 'https://marleybones-quiz-ai.vercel.app/api/quiz';
        const startedAt = performance.now();
        try {
            const res = await fetch(PLAN_CONTENT_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (!res.ok) throw new Error(`Plan content request failed: ${res.status}`);
            const data = await res.json();
            console.log(`\u{23F1}\u{FE0F} [wizard-v2] AI plan content responded in ${Math.round(performance.now() - startedAt)}ms`);
            return data;
        } catch (err) {
            console.error(`Could not fetch AI plan content (after ${Math.round(performance.now() - startedAt)}ms):`, err);
            return null; // fall back to the static plan content already in the DOM
        }
    }
    // Apply the plan-content endpoint's response to the DOM. Leaves the static
    // placeholder markup in place for any field that's missing or on a
    // null/failed response (see _fetchPlanContent). customer_frustration_strapline
    // is intentionally unused for now.
    _applyPlanContent(response) {
        if (!response) return;
        console.log("ai 2 response", response);
        const reasonEl = document.querySelector('[data-plan-reason]');
        if (reasonEl && response.why_this_plan) reasonEl.textContent = response.why_this_plan;
        const whyTheseEl = document.querySelector('[data-why-these]');
        if (whyTheseEl && response.why_these) whyTheseEl.textContent = response.why_these;
        const customerFrustrationEl = document.querySelector('[data-customer-frustration]');
        console.log('customerFrustrationEl', customerFrustrationEl);
        if (customerFrustrationEl && response.customer_frustration_strapline) customerFrustrationEl.textContent = response.customer_frustration_strapline;
        if (response.three_priorities?.length) this._renderPriorities(response.three_priorities);
    }
    async _loadPlanContent() {
        const payload = this._buildQuizPayload();
        console.log("\uD83D\uDCE4 [wizard-v2] quiz payload for plan content:", payload);
        this._renderPayloadDebug(); // TESTING ONLY — refresh with recommendation data
        const response = await this._fetchPlanContent(payload);
        this._applyPlanContent(response);
    }
    // ─── Helpers ─────────────────────────────────────────────────────────────────
    _checkoutFlow(step) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: step
                    }
                }
            }
        });
    }
    _emptyCartOnStart() {
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).catch((err)=>console.error('Error clearing cart:', err));
    }
    _puppyModalHelper(months) {
        const limitModal = this.querySelector('.limit-modal');
        if (!limitModal) return;
        if (months > 180) {
            const top = window.pageYOffset || document.documentElement.scrollTop;
            limitModal.style.marginTop = top + 'px';
            limitModal.style.display = 'inline-block';
        }
    }
    _getCookie(name) {
        const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return match ? match.pop() : '';
    }
}
customElements.define('quiz-wizard', $6373543018ca4811$var$QuizWizard);



})();
//# sourceMappingURL=parcel_scripts.js.map
